import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ReactDOM from "react-dom";
import ReactPaginate from 'react-paginate';
import { path, dropdownColourStyles } from 'Constants'
import { ExportToCsv } from 'utils/ExportToCsv';
import classNames from "classnames";
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment'
import { routes } from 'Constants'
import * as FileSaver from "file-saver";

import * as XLSX from 'xlsx';
import { Workbook } from 'exceljs/dist/exceljs';
import axios from 'axios'
import RadioButtonOption from "./RadioButtonOption";
//import { menuConfig } from "./DownloadConfig"; 

import {
    integralPartWithBlank,
    roundFix, formatThousands, getNonEmptyValue, roundFixWithBlank, formatThousandsWithBlank, mergeArrayByKey, RoundFormatter2,
    IntegralpartFormatter, IntegralpartPercentFormatter, binarySearchIndex, formatter, filterRenderer, editorComponent
} from 'utils/Utils'
import {
    columnFieldModalStyle,
    suggestedValueContentStyle, ExcelUploadColumns,
    backdropStyle, exportOptionsModalStyle, changeModalContentStyle, modalContentStyle, changeModalStyle
} from 'Constants';

import {
    dropdownValues, directSpendDropdown, scopeValues, goodsValues, requesitionValues, aribaBuyProcessValues,
    workingCaptialSegmentationValues, VendorLinkFormatter, IndustryLinkFormatter, discountingVals, termRationalizationVals
}
    from '../SpendConstants'

import Modal from 'reboron/OutlineModal'
import { RadioButton } from 'material-ui';
// Settings
import Select from 'react-select'
import {
    getDetailedFileSuccess,
    getDetailedFileLoading,
    getDetailedFileFailure,
    getDetailedFileSpendData,
    getSpendColumnsConfiguration,
    getNdlColumnsConfiguration,
    getNdlReportData,
    detailedFileFilters,
    detailedFileFilterText,
    selectedIndustryDetails,
    selectedEnablementWaveDetails,
    insertDetailedFileRecords,
    pendingChanges,
    defineScopeLoading,
    setResultSummaryDetails,
    setTopDetails,
    getSelectedColumn,
    addSelectedColumn,
    removeColumnsForRequest,
    selectedCapIqIdDetails,
    getVendorFiles,
    getVendorFilesEnhanced,
    insertReportLogDetails,
    FetchUpdateFieldVisibility,
    RunDmcDownloadSummary,
    requestRunDmcOutputEmail,
    redirectFromEnablementTab    
    //getReportLogDetails
} from 'actions/spendActions'
import TextEditor from 'UI/TextEditor';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data, Filters, Editors, Menu } from "react-data-grid-addons";
import Button from 'UI/Button';
import TextfilterRenderer from 'UI/TextFilterRenderer';
import NumericFilterRenderer from 'UI/NumericFilterRenderer';
import UserCommentsPopUp from '../UserCommentsPopUp'
import IndustryOverridePopUp from '../IndustryOverridePopUp'
import EnablementWavePopUp from '../EnablementWavePopUp'
import ColumnFields from '../ColumnFields'
import Popup from "reactjs-popup";
import VideoHelp from 'components/UI/VideoHelp'
import { PopupE, SelectE } from 'UI/CustomComponents/Controls';
import CapIQSearch from './CapIQSearch';
import UploadUserDefinedFields from './UploadUserDefinedFields'
import VendorUploadFilesModalContainer from './VendorUploadFilesModalContainer';
import { fetchJSONConfigSpendDownloadMenu } from "actions/userActions";
const changeBackdropStyle = Object.assign({}, backdropStyle);
changeBackdropStyle.zIndex = '1050';
const alertModalStyle = Object.assign({}, exportOptionsModalStyle);
const downloadThreshold = 1113000;
alertModalStyle.zIndex = '1060';

const { ContextMenu, MenuItem, SubMenu, ContextMenuTrigger } = Menu;


const menuFormats = {
    "Supply Chain Collaboration Customer": ["Excel", "CSV"],
    "Supply Chain Collaboration View": ["Excel"],
    "Supply Chain Collaboration Enablement Insight View": ["Excel"],
    "Customer View": ["Excel", "CSV"],
    "Enablement Insight": ["Excel"],
    "Standard (Internal Only)": ["Excel"],
    "Current View (Internal Only)": ["Excel"],
    "M&C Detail (Internal Only)": ["Excel", "CSV"],
    "M&C Details with Direct Connect (Internal Only)": ["Excel", "CSV"],
    "RunDMC Output (Internal Only)": ["Email"],
    "All (Internal Only)": ["CSV"],
    "SE Match Output (AVATAR)": ["Excel"],
    "Customer Facing SE Match Output (AVATAR)": ["Excel"],
    "SE Match Output (SDMC)": ["Excel"],
    "Customer Facing SE Match Output (SDMC)": ["Excel"],
    "Vendor Upload File": ["CSV"],
    "Vendor Upload File - Enhanced": ["CSV"],
}  

function defaultExtraCondition(props, downloadThreshold) {
    return !!(
      props &&
      props.spendDetails &&
      props.spendDetails.currentActiveRequest &&
      props.spendDetails.currentActiveRequest.Number_Of_Records < 1113000
    );
  }

const selectors = Data.Selectors;
const {
    NumericFilter,
    AutoCompleteFilter,
    MultiSelectFilter,
    SingleSelectFilter
} = Filters;

class SpendFilesContainer extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            isBlocking: false,
            triggerDownload: false,
            isLoading: true,
            isError: 'No',
            responseMsg: '',
            finalSpendData: [],
            RequestIds: [],
            selectedScopes: '',
            fileDetails: [],
            scopes: [],
            pageCount: 1,
            filters: {},
            perPage: 30000,
            paginatedRowFrom: 0,
            paginatedRowTo: 30000,
            columnDefs: [],
            rowData: [],
            filteredRows: [],
            columns: [],
            exportNonSensitiveColumns: [],
            exportEnablementInsightColumns: [],
            exportMatchAndClassificationColumns: [],
            exportMatchAndClassificationDirectConnectColumns: [],
            exportAllColumns: [],
            ndlColumnsDoNotShareWithCustomer: [],
            ndlColumns: [],
            ndlColumnsCustFacingEnhanced: [],
            ndlColumnsMatchOutputEnhanced:[],
            ndlParentAccountInfoColumns: [],
            ndlCustFacingColumns: [],
            ndlData: [],
            ndlDNS_Data: [],
            exportCustomerViewColumns: [],
            exportSccEnableInsightViewColumns: [],
            exportSccViewColumns: [],
            userDefinedColumns: [],
            pageCountOption: [{ label: '1,000', value: 1000 }, { label: '5,000', value: 5000 }, { label: '10,000', value: 10000 }, { label: '15,000', value: 15000 }, { label: '30,000', value: 30000 }],
            selectedPageCount: 50,
            filteredRows: [],
            cellUpdateCss: 'bisque',
            open: false,
            openUserCommentsPopUp: false,
            openEnablementInsightPopUp: false,
            userComments: '',
            userCommentsRowNo: -1,
            userCommentInsideCell: '',
            userCommentOverrides: {},
            industryOverrideRowNo: -1,
            pendingRecords: [],
            warningRecords: [],
            errorRecords: [],
            exclusionReason_directSpendUpdates: [],
            warningDiv: true,
            errorDiv: true,
            csvRows: [],
            isFilterVisible: false,
            cleanIndustryOverrides: {},
            confirmedflagTrans: {},
            isCapIQLicesend: false,
            filterArray: [],
            filterDiv: [],
            filterFlag: false,
            summationArray: {},
            filteredSummationArray: {},
            userSelectedColumns: [],
            selectedSupplier: -1,
            exportAction: 'customerViewColumns',
            isSaveInProgress: false,
            openCapIq: false,
            capIqIdOverrideRowNo: -1,
            capIQIdOverrides: {},
            currentCapIqId: '',
            dummyScroll: false,
            actualScroll: false,
            enablementWaveOverrides: {},
            enablementWaveInputValue: null,
            headerToColumn: {},
            exportMC_Cloumns: false,
            chunkSize : 0,
            sortByOption: [
                { value: "AVATAR_WAVE_SCORE", label: "Buyer Value" },
                { value: "COMBINED_WIZARD_PRIORITY_SCORE", label: "Enablement Strategy Value" },
                { value: "ENABLEMENT_WAVE", label: "Enablement Wave" },
                { value: "REF_NUMBER", label: "Original Order" },
            ],
            selectedSortBy: "AVATAR_WAVE_SCORE",
            sortByName: "Intelligent Enablement Match Spend & Document Score",
            gridSortBy: "AVATAR_WAVE_SCORE",
            gridSortDirection: 'DESC',
            currentChunkIndex: 0,
            totalChunks: 0,
            showFileTypePopup: false,
  selectedFileType: 'excel',
  selectedMenuItem: null,
  menuConfig: [],
    activeItem: null,
    selectedFormat: null,
    showFormatPopup: false,
        }
        this.loadDownloadMenuConfig = this.loadDownloadMenuConfig.bind(this)
        this.formatSpendData = this.formatSpendData.bind(this)
        this.ndlDownload = this.ndlDownload.bind(this)
        this.openNdlPopUp = this.openNdlPopUp.bind(this)
        this.openDownloadPopup = this.openDownloadPopup.bind(this)
        this.handlePageClick = this.handlePageClick.bind(this)
        this.getValidFilterValues = this.getValidFilterValues.bind(this)
        this.handleFilterChange = this.handleFilterChange.bind(this)
        this.handlePageCountChange = this.handlePageCountChange.bind(this)
        this.industryOverride = this.industryOverride.bind(this)
        this.closePopUp = this.closePopUp.bind(this)
        this.outsidePopupClick = this.outsidePopupClick.bind(this)
        this.addUserComments = this.addUserComments.bind(this)
        this.clearUserComments = this.clearUserComments.bind(this)
        this.closeUserCommentsPopUp = this.closeUserCommentsPopUp.bind(this)
        this.outsideUserCommentsPopupClick = this.outsideUserCommentsPopupClick.bind(this)
        this.requestRunDmcOutput = this.requestRunDmcOutput.bind(this)
        this.findRowIndex = this.findRowIndex.bind(this)
        this.filterValidationRecords = this.filterValidationRecords.bind(this)
        this.warningToggle = this.warningToggle.bind(this)
        this.errorToggle = this.errorToggle.bind(this)
        this.isCellEditable = this.isCellEditable.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onColumnSelection = this.onColumnSelection.bind(this)
        this.hasRecordErrors = this.hasRecordErrors.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.setColumnHelpTextAndHardRefresh = this.setColumnHelpTextAndHardRefresh.bind(this)
        this.setHeaderHelpText = this.setHeaderHelpText.bind(this)
        this.columnResize = this.columnResize.bind(this)
        this.exportCsv = this.exportCsv.bind(this)
        this.exportExcel = this.exportExcel.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.commonDownload = this.commonDownload.bind(this)
        this.clearIndustryOverride = this.clearIndustryOverride.bind(this)
        this.closeColumnFieldPopup = this.closeColumnFieldPopup.bind(this)
        this.filterToggle = this.filterToggle.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
        this.expandFilter = this.expandFilter.bind(this)
        this.getRows = this.getRows.bind(this)
        this.hideEmptyColumns = this.hideEmptyColumns.bind(this)
        this.radioButtonChecked = this.radioButtonChecked.bind(this)
        this.capIqRadioButtonClicked = this.capIqRadioButtonClicked.bind(this)
        this.capIqDataCleared = this.capIqDataCleared.bind(this)
        this.capIqIdOverride = this.capIqIdOverride.bind(this)
        this.closeCapIqPopUp = this.closeCapIqPopUp.bind(this)
        this.outsideCapIqIdPopupClick = this.outsideCapIqIdPopupClick.bind(this)
        this.closeEnablementInsightPopUp = this.closeEnablementInsightPopUp.bind(this)
        this.outsideEnablementInsightPopupClick = this.outsideEnablementInsightPopupClick.bind(this)
        this.enablementWaveInput = this.enablementWaveInput.bind(this);
        this.clearEnablementWaveOverride = this.clearEnablementWaveOverride.bind(this);
        this.actions = this.getApplicationFeatureActions()
        this.getHeaderGroups = this.getHeaderGroups.bind(this)
        this.redirect = this.redirect.bind(this)
        this.openFormatPopup = this.openFormatPopup.bind(this)
    }

    setColumnHelpTextAndHardRefresh(paginatedRows, columnDefs, isFilterVisible = this.state.isFilterVisible) {
        this.timer = setInterval(() => {
            this.setHeaderHelpText(columnDefs)
        }, 5000);


        if (paginatedRows.length === 0) {
            var grid = this.myOpenGrid;
            if (grid) {
                return grid.base.props.columns
            }
        } else {
            columnDefs = columnDefs.map((col, i) => ({
                ...col,
                hash: new Date().getTime()
            }));
        }

        return columnDefs
    }

    requestRunDmcOutput() {
        this.props.requestRunDmcOutputEmail(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Email,'W').then((response) => {
            alert(response.data.Result[0].MESSAGE);
        });
    }

    setHeaderHelpText(columnDefs) {
        var grid = this.myOpenGrid;
        if (grid === null || grid === undefined) {
            return;
        }

        var gridCells = ReactDOM.findDOMNode(grid).querySelectorAll('.react-grid-HeaderCell');
        gridCells.forEach((item) => {
            if (item.classList.length > 1) {
                return
            }
            const headerText = item.innerText;
            var col = columnDefs.findIndex((colDef) => {
                return colDef.name === headerText
            })

            if (col !== -1) {
                item.setAttribute('title', columnDefs[col].helpText)
                if (columnDefs[col].editable) {
                    item.style.backgroundColor = '#ff8c00';
                }
            }
        })

        // const canvas = document.getElementsByClassName('react-grid-Canvas')[0]
        // const dummyScroll = document.getElementsByClassName('scroll-dummy-child')[0]
        // let columnDefLength = this.state.columnDefs.length;
        // dummyScroll.style.width = (columnDefLength * (columnDefLength > 14 ? 160 : 120)) + 'px'
        // const dummyElement = document.getElementsByClassName('scroll-dummy')[0]

        // if (this.actions.indexOf(routes.businessValue) > -1) {
        //     dummyElement.style.width = '90vw'

        // } else {
        //     dummyElement.style.width = '96vw'
        // }

        // canvas.onscroll = () => {
        //     if (this.state.dummyScroll) {
        //         this.setState({ dummyScroll: false })
        //         return
        //     }

        //     this.setState({ actualScroll: true }, () => {
        //         const dummy = document.getElementsByClassName('scroll-dummy')[0]
        //         const length = this.state.columnDefs.length * 120
        //         const dummyScrollRatio = document.documentElement.clientWidth / length
        //         dummy.scrollLeft = canvas.scrollLeft// * dummyScrollRatio
        //     })
        // }
    }

    filterChange() {
        const isFilterVisible = this.state.isFilterVisible
        this.filteredColumnValues = []

        this.setState({ isFilterVisible: !isFilterVisible })
    }

    hasRecordErrors() {
        const errorRecords = this.state.errorRecords
        var errorRecordSize = 0;
        Object.values(errorRecords).forEach((item) => {
            errorRecordSize += item.length;
        })

        return errorRecordSize > 0
    }

    onColumnSelection(param) {
        if ((Array.isArray(param) && param.length > 0) || !isNaN(parseInt(param))) {
            this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, param).then((response) => {
                let selectedCols = response.data.Result;
                let columns = this.state.columns;
                let columnDefs = [];
                columns.map((column) => {
                    if (selectedCols.indexOf(column.id) > -1) {
                        let col = column.value;
                        col.hash = new Date().getTime();
                        column.isSelected = true;
                        columnDefs.push(col);
                    } else {
                        column.isSelected = false;
                    }
                })
                this.originalColumns = cloneDeep(columns);
                const headerToColumn = this.getHeaderGroups(columnDefs)

                this.setState({
                    columns: columns,
                    columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                    headerToColumn: headerToColumn
                    //}, this.removeFilter(this.state.filters, undefined, true))
                })
            });
        } else if (param === "DEFAULT") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.is_default === "Yes" || column.internalEnablementInsightView == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });

                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        } else if (param === "FlightPlanning") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.columnCategory === "Enablement Insight" || column.id === "VENDOR_ID" || column.id === "VENDOR_NAME" || column.id === "AN_MATCH_CRITERIA" || column.id === "MATCH_CONFIDENCE" || column.id === "PROPOSED_ENABLEMENT_MODE") {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        } else if (param === "InternalEnablementInsightView") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.internalEnablementInsightView == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        } else if (param === "ExternalEnablementInsightView") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.externalEnablementInsightView == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        } else if (param === "CategoryInsightsView") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.categoryInsightsView == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        } else if (param === "MandCView") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.matchAndClassification_export == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        } else if (param === "MandCViewDirectConnect") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.isMAndCDirectConnectExport == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        } else if (param === "EnterpriseEnablementEstimatesView") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.enterpriseEnablementEstimatesView == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        }
        else if (param === "SccEnableInsightView") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.sccEnableInsightView == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        }
        else if (param === "SccView") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.sccView == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        }
        else if (param === "AllSccView") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let columns = this.state.columns;
                    let paramTosave = [];
                    let columnDefs = [];
                    columns.forEach(column => {
                        if (column.allSccView == 'Yes') {
                            let col = column.value;
                            col.hash = new Date().getTime();
                            column.isSelected = true;
                            columnDefs.push(col);
                            paramTosave.push(column.id)
                        } else {
                            column.isSelected = false;
                        }
                    });
                    if (paramTosave.length > 0) {
                        this.props.addSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id, paramTosave)
                    }

                    const headerToColumn = this.getHeaderGroups(columnDefs)

                    this.setState({
                        columns: columns,
                        columnDefs: columnDefs.length === 0 ? [] : columnDefs.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        }
        else if (param === "HideEmptyColumns") {
            this.props.removeColumnsForRequest(this.props.user.user.Id, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.spendDetails.currentActiveRequest.DMC_ID).then(
                (response) => {
                    let modifiedColumns = this.hideEmptyColumns()
                    const headerToColumn = this.getHeaderGroups(modifiedColumns.defaultColumns)
                    this.setState({
                        columns: modifiedColumns.columns,
                        columnDefs: modifiedColumns.defaultColumns.length === 0 ? [] : modifiedColumns.defaultColumns.sort((a, b) => { return a.screenSeq - b.screenSeq }),
                        filters: {},
                        headerToColumn: headerToColumn
                    }, this.getRows([...this.state.rowData], {}))

                },
                (error) => { console.log(error) }
            )
        }
    }

    handlePageCountChange(value) {
        var result = this.state.pageCountOption.find(page => page.value === value)
        var pageCount = this.state.filteredRows.length / result.value
        this.setState({ perPage: value, paginatedRowFrom: 0, paginatedRowTo: result.value, pageCount: pageCount })
    }

    isCellEditable(e) {
        const editProperty = e.column.editProperty;

        if (e.column.key === 'EXCLUSION_REASON')
            return true;

        if (
            getNonEmptyValue(e.row['EXCLUSION_REASON']) === ''
            &&
            (e.column.key === 'SAP_ARIBA_BUY_PROCESS'
                || e.column.key === 'SOURCING_ELIGIBLE'
                || e.column.key === 'BUYING_INVOICING_ELIGIBLE'
                || e.column.key === 'REQUISITIONABLE'
                || e.column.key === 'REQUISITION_TYPE'
                || e.column.key === 'CONTRACT_INVOICING_ELIGIBLE'
                || e.column.key === 'COMMERCE_AUTOMATION_ELIGIBLE'
                || e.column.key === 'SUPP_CHAIN_COLLAB_ELIGIBLE'
                || e.column.key === 'SAP_FIELDGLASS_ELIGIBLE'
                || e.column.key === 'SAP_CONCUR_ELIGIBLE'
                || e.column.key === 'DISCOUNT_ELIGIBLE'
                || e.column.key === 'SPOT_BUY_ELIGIBLE'
                || e.column.key === 'PRIMARY_BUY_PROCESS_DELIVERED'
                || e.column.key === 'SECONDARY_BUY_PROCESS_DELIVERED'
                || e.column.key === 'OTHER_BUY_PROCESS_DELIVERED')) {
            return true;
        }

        if (e.column.key === 'OVERRIDE_INDUSTRY_ID' && this.state.open)
            return false;

        if (e.column.key === 'CAPIQ_COMPANY_ID' && this.state.openCapIq)
            return false;

        if (e.column.key === 'USER_COMMENT' && this.state.openUserCommentsPopUp)
            return false;

        if (e.column.key === 'ENABLEMENT_WAVE' && this.state.openEnablementInsightPopUp)
            return false;

        if (e.row['DATA_COLLECTIONS_SKEY'] == '')
            return false

        if (editProperty === 'Yes' && !this.props.readOnly) {
            return true;
        }

        if (editProperty === 'Override' && e.column.key === 'EXCLUSION_REASON')
            return e.row['SCOPE_SOURCE'] === 'Override'

        if (editProperty === 'OverrideWithExclusionReason' && getNonEmptyValue(e.row['EXCLUSION_REASON']) === '')
            return e.row['SCOPE_SOURCE'] === 'Override'


        return false;
    }

    handleSortByChange(data) {
        // var finalFilteredRows = [];
        // var finalRows = this.state.filteredRows;
        // finalRows.sort((a, b) => { return a['REF_NUMBER'] - b['REF_NUMBER'] });
        // if (data.value == 'ENABLEMENT_WAVE') {
        //     finalRows.sort(function (a, b) {
        //         return ('' + a[data.value]).localeCompare(b[data.value]);
        //     })
        // }
        // else
        //     finalRows.sort((a, b) => { return a[data.value] - b[data.value] });
        // finalFilteredRows = [...finalRows];
        // this.setState({ filteredRows: finalFilteredRows, selectedSortBy: data.value });

        // var finalFilteredRows = [];
        // var finalRows = this.state.filteredRows;
        // var comparer = this.downloadSortedRecords(data.value,'ASC');
        // finalRows = finalRows.sort(comparer);
        // finalFilteredRows = [...finalRows];
        // this.setState({ filteredRows: finalFilteredRows, selectedSortBy: data.value });


        //this.sortRows('REF_NUMBER','ASC');
        if (data.value == 'AVATAR_WAVE_SCORE' || data.value == 'COMBINED_WIZARD_PRIORITY_SCORE')
            this.sortRows(data.value, 'DESC');
        else
            this.sortRows(data.value, 'ASC');
        this.setState({ selectedSortBy: data.value });
    }

    columnResize(idx, width) {
        let column = this.state.columnDefs;
        const headerToColumn = { ...this.state.headerToColumn }
        column.map((value, index) => {
            if (index == (Number(idx))) {
                value.width = Number(width)
                const keys = Object.keys(headerToColumn)
                for (let idx2 = 0; idx2 < keys.length; idx2++) {
                    const key = keys[idx2]
                    const val = headerToColumn[key]
                    if (val.name === null && key === value.name) {
                        val.width = value.width
                        break
                    } else if (val instanceof Array) {
                        for (let idx1 = 0; idx1 < val.length; idx1++) {
                            let item = val[idx1]
                            if (item.name === value.name) {
                                item.width = value.width
                                break
                            }
                        }
                    }
                }
                return;
            }
        })

        this.setState({ columnDefs: column, headerToColumn: headerToColumn }, this.forceUpdate())
    }

    findRowIndex(array, value) {
        var low = 0,
            high = array.length;

        while (low < high) {
            var mid = (low + high) >>> 1;
            if (array[mid] === value) return -1
            if (array[mid] < value) low = mid + 1;
            else high = mid;
        }

        return low;
    }

    onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        const editedColumn  = Object.keys(updated)[0];
        if (Object.values(updated)[0] === 'DUMMY' && Object.keys(updated)[0] === 'OVERRIDE_INDUSTRY_ID') {
            return
        }
        if (Object.values(updated)[0] === 'DUMMY' && Object.keys(updated)[0] === 'CAPIQ_COMPANY_ID') {
            return
        }
        if (Object.keys(updated)[0] === 'USER_DATE_FIELD' && Object.values(updated)[0] !== null
            && (Object.values(updated)[0].toLowerCase() === 'invalid date' || Object.values(updated)[0].length !== 10)) {
            return
        }
        fromRow -= 2; toRow -= 2;

        this.setState(state => {
            const filteredRows = state.filteredRows;
            const rowData = state.rowData;

            const pendingRecords = state.pendingRecords;
            pendingRecords.sort((a, b) => {
                return a - b;
            })

            const colIdx = state.columnDefs.findIndex((item) => {
                return item.key === Object.keys(updated)[0]
            })

            const warningRecords = this.state.warningRecords;
            const errorRecords = this.state.errorRecords;
            const exclusionReason_directSpendUpdates = this.state.exclusionReason_directSpendUpdates;
            var userCommentOverrides = this.state.userCommentOverrides
            var cleanIndustryOverrides = this.state.cleanIndustryOverrides
            var confirmedflagTrans = this.state.confirmedflagTrans
            var capIQIdOverrides = this.state.capIQIdOverrides
            var enablementWaveOverrides = this.state.enablementWaveOverrides

            for (var idx = state.paginatedRowFrom + fromRow, len = (state.paginatedRowFrom + toRow); idx <= len; idx++) {
                const editable = { column: state.columnDefs[colIdx], row: filteredRows[idx] }
                if (!this.isCellEditable(editable) && Object.keys(updated)[0] !== 'OVERRIDE_INDUSTRY_ID' && Object.keys(updated)[0] !== 'USER_COMMENT'
                    && Object.keys(updated)[0] !== 'CAPIQ_COMPANY_ID' && Object.keys(updated)[0] !== 'ENABLEMENT_WAVE') {
                    continue;
                }
                if (Object.keys(updated)[0] === 'USER_COMMENT' && moment(Object.values(updated)[0], 'MM/DD/YYYY', true).isValid() === true) {
                    continue;
                }
                if (filteredRows[idx][editable.column.key] == Object.values(updated)[0])
                    continue;

                var exclusionReason = filteredRows[idx]['EXCLUSION_REASON']
                var directSpend = filteredRows[idx]['DIRECT_SPEND']
                let skey = filteredRows[idx]['DATA_COLLECTIONS_SKEY']

                if (editable.column.key === 'EXCLUSION_REASON') {
                    if (filteredRows[idx]['EXCLUSION_REASON'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                    }
                }

                if (editable.column.key === 'SAP_ARIBA_BUY_PROCESS') {
                    if (filteredRows[idx]['SAP_ARIBA_BUY_PROCESS'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SOURCING_ELIGIBLE') {
                    if (filteredRows[idx]['SOURCING_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'BUYING_INVOICING_ELIGIBLE') {
                    if (filteredRows[idx]['BUYING_INVOICING_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'REQUISITIONABLE') {
                    if (filteredRows[idx]['REQUISITIONABLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'REQUISITION_TYPE') {
                    if (filteredRows[idx]['REQUISITION_TYPE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'CONTRACT_INVOICING_ELIGIBLE') {
                    if (filteredRows[idx]['CONTRACT_INVOICING_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'COMMERCE_AUTOMATION_ELIGIBLE') {
                    if (filteredRows[idx]['COMMERCE_AUTOMATION_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SUPP_CHAIN_COLLAB_ELIGIBLE') {
                    if (filteredRows[idx]['SUPP_CHAIN_COLLAB_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SAP_FIELDGLASS_ELIGIBLE') {
                    if (filteredRows[idx]['SAP_FIELDGLASS_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SAP_CONCUR_ELIGIBLE') {
                    if (filteredRows[idx]['SAP_CONCUR_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'DISCOUNT_ELIGIBLE') {
                    if (filteredRows[idx]['DISCOUNT_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SPOT_BUY_ELIGIBLE') {
                    if (filteredRows[idx]['SPOT_BUY_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'PRIMARY_BUY_PROCESS_DELIVERED') {
                    if (filteredRows[idx]['PRIMARY_BUY_PROCESS_DELIVERED'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SECONDARY_BUY_PROCESS_DELIVERED') {
                    if (filteredRows[idx]['SECONDARY_BUY_PROCESS_DELIVERED'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'OTHER_BUY_PROCESS_DELIVERED') {
                    if (filteredRows[idx]['OTHER_BUY_PROCESS_DELIVERED'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }

                if (editable.column.key === 'OVERRIDE_INDUSTRY_ID') {
                    if (cleanIndustryOverrides[skey] === undefined) {
                        cleanIndustryOverrides[skey] = { old: filteredRows[idx]['OVERRIDE_INDUSTRY_ID'], new: Object.values(updated)[0] }
                    } else {
                        cleanIndustryOverrides[skey] = { old: cleanIndustryOverrides[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'USER_COMMENT') {
                    if (userCommentOverrides[skey] === undefined) {
                        userCommentOverrides[skey] = { old: filteredRows[idx]['USER_COMMENT'], new: Object.values(updated)[0] }
                    } else {
                        userCommentOverrides[skey] = { old: userCommentOverrides[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'CONFIRMED') {
                    if (confirmedflagTrans[skey] === undefined) {
                        confirmedflagTrans[skey] = { old: filteredRows[idx]['CONFIRMED'], new: Object.values(updated)[0] }
                    } else {

                        confirmedflagTrans[skey] = { old: confirmedflagTrans[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'CAPIQ_COMPANY_ID') {
                    if (capIQIdOverrides[skey] === undefined) {
                        capIQIdOverrides[skey] = { old: filteredRows[idx]['CAPIQ_COMPANY_ID'], new: Object.values(updated)[0] }
                    } else {
                        capIQIdOverrides[skey] = { old: capIQIdOverrides[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'ENABLEMENT_WAVE') {
                    updated.ENABLEMENT_WAVE_OVERRIDE = updated.ENABLEMENT_WAVE !== "" ? 'Override' : 'Calculated'
                    //also pass FP_FLAG_EIEDITED                    
                    if (enablementWaveOverrides[skey] === undefined) {
                        enablementWaveOverrides[skey] = { old: filteredRows[idx]['ENABLEMENT_WAVE'], new: Object.values(updated)[0] }
                    } else {
                        enablementWaveOverrides[skey] = { old: enablementWaveOverrides[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'SAP_ARIBA_BUY_ENABLE_MTHD_RECMD') {
                    updated.ENABLEMENT_RECOMMENDATION_OVERRIDE = 'Override'
                }

                if (editable.column.key === 'ONBOARDING_WORKSTREAM_DETAILS') {
                    updated.ONBOARDING_WORKSTREAM_DETAILS = updated.ONBOARDING_WORKSTREAM_DETAILS === "Null" ? '' : updated.ONBOARDING_WORKSTREAM_DETAILS
                    updated.ONBOARDING_WORKSTREAM_DETAILS_OVERRIDE = 'Override'
                }

                filteredRows[idx] = { ...filteredRows[idx], ...updated };

                rowData.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })  // binary search work with sorted array only
                var rowIdx = binarySearchIndex(rowData, skey, 'DATA_COLLECTIONS_SKEY')
                rowData[rowIdx] = { ...rowData[rowIdx], ...updated };


                var recordIdx = this.findRowIndex(pendingRecords, skey);
                if (recordIdx >= 0) {
                    pendingRecords.splice(recordIdx, 0, skey);
                }

                //Check for Exclusion reason and Direct Spend update
                if ((Object.keys(updated)[0] === "EXCLUSION_REASON" && Object.values(updated)[0] !== exclusionReason)
                    || (Object.keys(updated)[0] === "DIRECT_SPEND" && Object.values(updated)[0] !== directSpend)) {
                    if (!exclusionReason_directSpendUpdates.includes(skey))
                        exclusionReason_directSpendUpdates.push(skey)
                }
                
                this.validateForWarning(filteredRows[idx], warningRecords, editedColumn);
                this.validateForError(filteredRows[idx], errorRecords, editedColumn);
            }
            return {
                responseMsg: '',
                confirmedflagTrans: confirmedflagTrans,
                cleanIndustryOverrides: cleanIndustryOverrides,
                userCommentOverrides: userCommentOverrides,
                capIQIdOverrides: capIQIdOverrides,
                enablementWaveOverrides: enablementWaveOverrides,
                rowData: rowData, filteredRows: filteredRows, fromRow: fromRow, toRow: toRow, updated: updated,
                pendingRecords: pendingRecords, warningRecords: warningRecords, errorRecords: errorRecords, exclusionReason_directSpendUpdates
            };
        });
    };
    
    warningValidationMap = {
        EXCLUSION_REASON: ['exclusionReasonWarning'],
    
        BUYING_INVOICING_ELIGIBLE: [
          'buyingInvoicingFieldGlassEligibleWarning',
          'buyingInvoicingSupplyChainEligibleWarning',
          'buyingInvoicingConcurEligibleWarning'
        ],
    
        SAP_FIELDGLASS_ELIGIBLE: [
          'buyingInvoicingFieldGlassEligibleWarning',
          'fieldGlassSCCEligibleWarning'
        ],
    
        SUPP_CHAIN_COLLAB_ELIGIBLE: [
          'buyingInvoicingSupplyChainEligibleWarning',
          'fieldGlassSCCEligibleWarning'
        ],
    
        SAP_CONCUR_ELIGIBLE: [
          'buyingInvoicingConcurEligibleWarning'
        ],
    
        DISCOUNT_ELIGIBLE: [
          'discountAndTermRationalizationEligibleWarning',
          'discountEligibleWarning'
        ],
    
        TERMS_RATIONALIZATION: [
          'discountAndTermRationalizationEligibleWarning',
          'termRationalizationWarning'
        ],
    
        WORKING_CAPTIAL_SEGMENTATION: [
          'discountEligibleWarning',
          'termRationalizationWarning'
        ]
      };
    
      errorValidationMap = {
        BUYING_INVOICING_ELIGIBLE: ['buyingInvoicingError','requisitionableTypeError3','contractInvoicingError'],
        REQUISITIONABLE: ['buyingInvoicingError','requisitionableTypeError1','requisitionableTypeError2','requisitionableTypeError3'],
        CONTRACT_INVOICING_ELIGIBLE: ['buyingInvoicingError','contractInvoicingError'],
        REQUISITION_TYPE: ['requisitionableTypeError1','requisitionableTypeError2'],
        SUPP_CHAIN_COLLAB_ELIGIBLE: ['supplyCommerceError'],
        COMMERCE_AUTOMATION_ELIGIBLE: ['supplyCommerceError']
      };


      validateForWarning(record, warningRecords, editedColumn) {
        const warningMessages = this.props.content.validationMessage.warningMessage;
        const rulesToRun = this.warningValidationMap[editedColumn];
      
        if (!rulesToRun) return;
      
        var exclusionReason = record['EXCLUSION_REASON'];
        var buyingInvoicing = record['BUYING_INVOICING_ELIGIBLE'];
        var fieldGlassEligible = record['SAP_FIELDGLASS_ELIGIBLE'];
        var supplyChainEligible = record['SUPP_CHAIN_COLLAB_ELIGIBLE'];
        var concurEligible = record['SAP_CONCUR_ELIGIBLE'];
        var discountEligible = record['DISCOUNT_ELIGIBLE'];
        var termRationalizationEligible = record['TERMS_RATIONALIZATION'];
      
        var workingCapital = record['WORKING_CAPTIAL_SEGMENTATION'];
        workingCapital = workingCapital ? workingCapital.trim() : '';
      
        if (rulesToRun.indexOf('discountEligibleWarning') !== -1) {
          this.addWarningErroredRecord(
            warningMessages.discountEligibleWarning,
            record,
            warningRecords,
            getNonEmptyValue(discountEligible) === 'Yes' &&
            discountingVals.indexOf(getNonEmptyValue(workingCapital)) === -1
          );
        }
      
        if (rulesToRun.indexOf('termRationalizationWarning') !== -1) {
          this.addWarningErroredRecord(
            warningMessages.termRationalizationWarning,
            record,
            warningRecords,
            getNonEmptyValue(termRationalizationEligible) === 'Yes' &&
            termRationalizationVals.indexOf(getNonEmptyValue(workingCapital)) === -1
          );
        }
      }

      validateForError(record, errorRecords, editedColumn) {
        const errorMessages = this.props.content.validationMessage.errorMessage;
        const rulesToRun = this.errorValidationMap[editedColumn];
      
        if (!rulesToRun) return;
      
        const buyingInvoicing = record['BUYING_INVOICING_ELIGIBLE'];
        const requisitionable = record['REQUISITIONABLE'];
        const contractInvoicing = record['CONTRACT_INVOICING_ELIGIBLE'];
        const requisitionableType = record['REQUISITION_TYPE'];
        const supplyChain = record['SUPP_CHAIN_COLLAB_ELIGIBLE'];
        const commerceAutomation = record['COMMERCE_AUTOMATION_ELIGIBLE'];
      
        if (rulesToRun.includes('buyingInvoicingError')) {
          this.addWarningErroredRecord(
            errorMessages.buyingInvoicingError,
            record,
            errorRecords,
            (getNonEmptyValue(buyingInvoicing) === 'Yes' &&
              getNonEmptyValue(requisitionable) === 'Yes' &&
              getNonEmptyValue(contractInvoicing) === 'Yes') ||
            (getNonEmptyValue(buyingInvoicing) === 'Yes' &&
              getNonEmptyValue(requisitionable) === 'No' &&
              getNonEmptyValue(contractInvoicing) === 'No')
          );
        }
      
        if (rulesToRun.includes('requisitionableTypeError1')) {
          this.addWarningErroredRecord(
            errorMessages.requisitionableTypeError1,
            record,
            errorRecords,
            getNonEmptyValue(requisitionable) === 'Yes' &&
            getNonEmptyValue(requisitionableType) === 'N/A'
          );
        }
      
        if (rulesToRun.includes('requisitionableTypeError2')) {
          this.addWarningErroredRecord(
            errorMessages.requisitionableTypeError2,
            record,
            errorRecords,
            getNonEmptyValue(requisitionable) === 'No' &&
            getNonEmptyValue(requisitionableType) !== 'N/A'
          );
        }
      
        if (rulesToRun.includes('requisitionableTypeError3')) {
          this.addWarningErroredRecord(
            errorMessages.requisitionableTypeError3,
            record,
            errorRecords,
            getNonEmptyValue(requisitionable) === 'Yes' &&
            getNonEmptyValue(buyingInvoicing) === 'No'
          );
        }
      
        if (rulesToRun.includes('contractInvoicingError')) {
          this.addWarningErroredRecord(
            errorMessages.contractInvoicingError,
            record,
            errorRecords,
            getNonEmptyValue(contractInvoicing) === 'Yes' &&
            getNonEmptyValue(buyingInvoicing) === 'No'
          );
        }
      
        if (rulesToRun.includes('supplyCommerceError')) {
          this.addWarningErroredRecord(
            errorMessages.supplyCommerceError,
            record,
            errorRecords,
            getNonEmptyValue(supplyChain) === 'Yes' &&
            getNonEmptyValue(commerceAutomation) === 'Yes'
          );
        }
      }

    // validateForWarning(record, warningRecords) {
    //     const warningMessages = this.props.content.validationMessage.warningMessage;

    //     var exclusionReason = record['EXCLUSION_REASON']
    //     if (getNonEmptyValue(exclusionReason) !== '') {
    //         this.addWarningErroredRecord(warningMessages.exclusionReasonWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.exclusionReasonWarning, record, warningRecords, false)
    //     }

    //     var buyingInvoicing = record['BUYING_INVOICING_ELIGIBLE'];
    //     var fieldGlassEligible = record['SAP_FIELDGLASS_ELIGIBLE']
    //     if (getNonEmptyValue(buyingInvoicing) === 'Yes' && getNonEmptyValue(fieldGlassEligible) === 'Yes') {
    //         this.addWarningErroredRecord(warningMessages.buyingInvoicingFieldGlassEligibleWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.buyingInvoicingFieldGlassEligibleWarning, record, warningRecords, false)
    //     }

    //     var supplyChainEligible = record['SUPP_CHAIN_COLLAB_ELIGIBLE']
    //     if (getNonEmptyValue(buyingInvoicing) === 'Yes' && getNonEmptyValue(supplyChainEligible) === 'Yes') {
    //         this.addWarningErroredRecord(warningMessages.buyingInvoicingSupplyChainEligibleWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.buyingInvoicingSupplyChainEligibleWarning, record, warningRecords, false)
    //     }

    //     var concurEligible = record['SAP_CONCUR_ELIGIBLE']
    //     if (getNonEmptyValue(buyingInvoicing) === 'Yes' && getNonEmptyValue(concurEligible) === 'Yes') {
    //         this.addWarningErroredRecord(warningMessages.buyingInvoicingConcurEligibleWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.buyingInvoicingConcurEligibleWarning, record, warningRecords, false)
    //     }

    //     if (getNonEmptyValue(supplyChainEligible) === 'Yes' && getNonEmptyValue(fieldGlassEligible) === 'Yes') {
    //         this.addWarningErroredRecord(warningMessages.fieldGlassSCCEligibleWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.fieldGlassSCCEligibleWarning, record, warningRecords, false)
    //     }

    //     var discountEligible = record['DISCOUNT_ELIGIBLE']
    //     var termRationalizationEligible = record['TERMS_RATIONALIZATION']
    //     var workingCaptialSegmentation = record['WORKING_CAPTIAL_SEGMENTATION'].trim()
    //     if (getNonEmptyValue(discountEligible) === 'Yes' && getNonEmptyValue(termRationalizationEligible) === 'Yes') {
    //         this.addWarningErroredRecord(warningMessages.discountAndTermRationalizationEligibleWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.discountAndTermRationalizationEligibleWarning, record, warningRecords, false)
    //     }

    //     if (getNonEmptyValue(discountEligible) === 'Yes' && getNonEmptyValue(termRationalizationEligible) === 'Yes') {
    //         this.addWarningErroredRecord(warningMessages.discountAndTermRationalizationEligibleWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.discountAndTermRationalizationEligibleWarning, record, warningRecords, false)
    //     }

    //     if (getNonEmptyValue(discountEligible) === 'Yes'
    //         && discountingVals.indexOf(getNonEmptyValue(workingCaptialSegmentation)) == -1) {
    //         this.addWarningErroredRecord(warningMessages.discountEligibleWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.discountEligibleWarning, record, warningRecords, false)
    //     }

    //     if (getNonEmptyValue(termRationalizationEligible) === 'Yes'
    //         && termRationalizationVals.indexOf(getNonEmptyValue(workingCaptialSegmentation)) == -1
    //     ) {
    //         this.addWarningErroredRecord(warningMessages.termRationalizationWarning, record, warningRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(warningMessages.termRationalizationWarning, record, warningRecords, false)
    //     }

    // }

    // validateForError(record, errorRecords) {
    //     const errorMessages = this.props.content.validationMessage.errorMessage;

    //     var buyingInvoicing = record['BUYING_INVOICING_ELIGIBLE'];
    //     var requisitionable = record['REQUISITIONABLE'];
    //     var contractInvoicing = record['CONTRACT_INVOICING_ELIGIBLE'];

    //     if ((getNonEmptyValue(buyingInvoicing) === 'Yes' && getNonEmptyValue(requisitionable) === 'Yes' && getNonEmptyValue(contractInvoicing) === 'Yes') ||
    //         (getNonEmptyValue(buyingInvoicing) === 'Yes' && getNonEmptyValue(requisitionable) === 'No' && getNonEmptyValue(contractInvoicing) === 'No')) {
    //         this.addWarningErroredRecord(errorMessages.buyingInvoicingError, record, errorRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(errorMessages.buyingInvoicingError, record, errorRecords, false)
    //     }

    //     var requisitionableType = record['REQUISITION_TYPE'];
    //     if (getNonEmptyValue(requisitionable) === 'Yes' && getNonEmptyValue(requisitionableType) === 'N/A') {
    //         this.addWarningErroredRecord(errorMessages.requisitionableTypeError1, record, errorRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(errorMessages.requisitionableTypeError1, record, errorRecords, false)
    //     }

    //     if (getNonEmptyValue(requisitionable) === 'No' && getNonEmptyValue(requisitionableType) !== 'N/A') {
    //         this.addWarningErroredRecord(errorMessages.requisitionableTypeError2, record, errorRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(errorMessages.requisitionableTypeError2, record, errorRecords, false)
    //     }

    //     if (getNonEmptyValue(requisitionable) === 'Yes' && getNonEmptyValue(buyingInvoicing) === 'No') {
    //         this.addWarningErroredRecord(errorMessages.requisitionableTypeError3, record, errorRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(errorMessages.requisitionableTypeError3, record, errorRecords, false)
    //     }

    //     if (getNonEmptyValue(contractInvoicing) === 'Yes' && getNonEmptyValue(buyingInvoicing) === 'No') {
    //         this.addWarningErroredRecord(errorMessages.contractInvoicingError, record, errorRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(errorMessages.contractInvoicingError, record, errorRecords, false)
    //     }

    //     var supplyChain = record['SUPP_CHAIN_COLLAB_ELIGIBLE'];
    //     var commerceAutomation = record['COMMERCE_AUTOMATION_ELIGIBLE'];

    //     if (getNonEmptyValue(supplyChain) === 'Yes' && getNonEmptyValue(commerceAutomation) === 'Yes') {
    //         this.addWarningErroredRecord(errorMessages.supplyCommerceError, record, errorRecords, true)
    //     } else {
    //         this.addWarningErroredRecord(errorMessages.supplyCommerceError, record, errorRecords, false)
    //     }
    // }

    addWarningErroredRecord(reason, record, records, add) {
        var arr = records[reason];
        if (getNonEmptyValue(arr) === '') {
            arr = []
        }

        var eltIdx = arr.indexOf((record['DATA_COLLECTIONS_SKEY']));
        if (eltIdx === -1 && add) {
            arr.push(record['DATA_COLLECTIONS_SKEY'])
        } else if (eltIdx !== -1 && !add) {
            arr.splice(eltIdx, 1)
        }

        records[reason] = arr;
    }

    radioButtonChecked = (value) => {
        this.setState({ exportAction: value });
      };


      checkVisibility(item, props) {
        
        var userRoles = [];
        var solutionScope = "";
        var valueStoryType = "";
        var recordCount = 0;
    
        //var downloadThreshold = downloadThreshold || 0;
    
        // --- User Roles (Array) ---
        if (
            props &&
            props.user &&
            props.user.userprofile &&
            props.user.userprofile.Roles &&
            props.user.userprofile.Roles.length > 0
        ) {
            userRoles = props.user.userprofile.Roles[0];
        }
    
        // --- Solution Scope ---
        if (props && props.spendDetails && props.spendDetails.solutionScope) {
            solutionScope = props.spendDetails.solutionScope;
        }
    
        var isSCC = (solutionScope === "Supply Chain Collaboration");
    
        // --- Value Story Type ---
        if (props && props.userData && props.userData.ValueStoryType) {
            valueStoryType = props.userData.ValueStoryType;
        }
    
        // --- Record Count ---
        if (
            props &&
            props.spendDetails &&
            props.spendDetails.currentActiveRequest &&
            props.spendDetails.currentActiveRequest.Number_Of_Records >= 0
        ) {
            recordCount = props.spendDetails.currentActiveRequest.Number_Of_Records;
        }
    
    
        // --------------------------------------------
        // 1️⃣ ACCESS MATRIX VALIDATION (ROLE MATCH)
        // --------------------------------------------
    
        if (item.accessMatrix && typeof item.accessMatrix === "object") {
    
            var selectedRoleConfig = null;
    
            // Loop through the roles and find the first match
            for (var i = 0; i < userRoles.length; i++) {
                var roleName = userRoles[i];
                if (item.accessMatrix[roleName]) {
                    selectedRoleConfig = item.accessMatrix[roleName];
                    break;
                }
            }
    
            // ❌ No matching role → deny
            if (!selectedRoleConfig) {
                return false;
            }
    
            // ❌ SCC Mode but role does NOT allow SCC
            if (isSCC && selectedRoleConfig.scc !== true) {
                return false;
            }
    
            // ❌ NON-SCC Mode but role does NOT allow Non-SCC
            if (!isSCC && selectedRoleConfig.nonSCC !== true) {
                return false;
            }
        }
    
    
        // --------------------------------------------
        // 2️⃣ VALUE STORY TYPE VALIDATION
        // --------------------------------------------
        if (item.valueStoryTypes && Array.isArray(item.valueStoryTypes)) {
            if (item.valueStoryTypes.indexOf(valueStoryType) === -1) {
                return false;
            }
        }
    
    
        // --------------------------------------------
        // 3️⃣ EXTRA CONDITION VALIDATION
        // --------------------------------------------
        if (typeof item.extraCondition === "function") {
            const ok = item.extraCondition(props, downloadThreshold);
            if (!ok) return false;
          } else if (item.extraCondition === false) {
            // Explicit false → deny
            return false;
          } else {
            // ✅ null or undefined → allow
            return true;
          }
    
        return true;
    }
    
    handleMenuClick = (item) => {

        // if both Excel + CSV exist → show popup

        this.setState({
            //exportAction: item.value,
            selectedMenuItem: item
        });

        if (item.isUnified) {
            this.setState({
                showFileTypePopup: true,                
            });
            return;
        }

        this.setState({
            exportAction: item.value,
            //selectedMenuItem: item
        });
    
        // existing behavior
        //this.radioButtonChecked(item.value);
    };
    
    handleFileTypeSelect = () => {            
        this.setState({
            showFileTypePopup: false,
        });
    };

    handleDownloadClick = () => {
 
        const { selectedFileType, selectedMenuItem } = this.state;
     
        let exportAction = '';
     
        if (selectedMenuItem.isUnified) {
            exportAction =
                selectedFileType === 'excel'
                    ? selectedMenuItem.excelValue
                    : selectedMenuItem.csvValue;
        } else {
            exportAction = selectedMenuItem.excelValue;
        }
     
        this.setState({ exportAction }, () => {
     
            this.props.defineScopeLoading(true);
     
            setTimeout(() => {
                // if (selectedFileType === 'excel') {
                //     this.exportExcel();
                // } else {
                //     this.exportCsv();
                // }
                this.commonDownload();
            }, 100);
     
        });
    };
    // onPopupClose = () =>{

    //     if (!this.state.triggerDownload) return ;

    //     const {  selectedFileType } = this.state;
    //     this.props.defineScopeLoading(true);
    //     setTimeout(() => {
    //         if (selectedFileType === 'excel') {
    //             this.exportExcel();
    //         } else {
    //             this.exportCsv();
    //         }

    //         this.setState({ triggerDownload: false });
    //     }, (100));          
        

    // }

    handleDownload = () => {
        const { activeItem, selectedFormat } = this.state;
        if (!activeItem || !selectedFormat) return;
      
        let exportAction = "";
      
        if (selectedFormat === "Email") {
          // For Email, call your email method directly
          this.requestRunDmcOutput();
      
          // Close popup after email
          this.setState({ showFormatPopup: false, activeItem: null, selectedFormat: null });
          return;
        }
      
        // Find the correct format object from activeItem.formats
        const selectedItem = activeItem.formats.find(f => f.format === selectedFormat);
      
        if (selectedItem) {
          exportAction = selectedItem.value;
        }
      
        this.setState({ exportAction }, () => {
          this.props.defineScopeLoading(true);
      
          setTimeout(() => {
            this.commonDownload();
      
            // ✅ Close popup after download
            this.setState({ showFormatPopup: false, activeItem: null, selectedFormat: null });
          }, 100);
        });
      };

    // First popup: open when a menu radio is selected
  openMenuPopup = (item) => {
    this.setState({
      activeItem: item,
      showMenuPopup: true,
      showFormatPopup: false,
      selectedFormat: null
    });
  };

  // Second popup: open when user clicks "Choose Format"
  openFormatPopup = (item) => {
    if (this.state.showFormatPopup) {
        this.setState({ showFormatPopup: false, activeItem: null });
      }
    this.setState({
      activeItem: item,
      showFormatPopup: true,
      selectedFormat: item.formats[0].format
    });
  };

  closeFormatPopup = () => {
    this.setState({ showFormatPopup: false, activeItem: null });
  };

    renderFormatPopup() {
        const { activeItem, selectedFormat } = this.state;
        if (!activeItem) return null;
    
        return (
            <div className="popup">
                <h4>{activeItem.baseLabel} - Select Format</h4>
                {activeItem.formats.map(fmt => (
                    <label key={fmt.format}>
                        <input
                            type="radio"
                            name="format"
                            value={fmt.format}
                            checked={selectedFormat === fmt.format}
                            onChange={() => this.setState({ selectedFormat: fmt.format })}
                        />
                        {fmt.format}
                    </label>
                ))}
                <button onClick={() => this.handleDownload(activeItem, selectedFormat)}>
                    Download
                </button>
            </div>
        );
    }
    
    renderMenu() {
        if (!this.state || !this.state.menuConfig) return null;
      
        return (
          <div>
            {this.state.menuConfig.map((group, index) => {
              // ✅ No need to run checkVisibility again
              const visibleItems = group.items;
      
              if (visibleItems.length === 0) return null;
      
              return (
                <div key={index} style={{ marginBottom: "15px" }}>
                  <strong>{group.group}</strong>
      
                  {/* ✅ Indent items inside the group */}
                  <div style={{ marginLeft: "20px" }}>
                    {visibleItems.map(item => (
                      <div key={item.baseLabel} style={{ marginBottom: "8px" }}>
                        <label>
                          <input
                            type="radio"
                            name="menu"
                            value={item.baseLabel}
                            checked={
                              this.state.activeItem &&
                              this.state.activeItem.baseLabel === item.baseLabel
                            }
                            onChange={() => this.openFormatPopup(item)}
                            style={{ marginRight: '8px' }}
                          />
                          {item.baseLabel}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
      
            {/* Second modal popup (overlay) */}
            {this.state.showFormatPopup && this.state.activeItem && (
              <div style={styles.overlayPopupStyle}>
                {/*<h4>Select Format for {this.state.activeItem.baseLabel}</h4>*/}
                <h4>Select Format</h4>
                <div style={{ marginBottom: "10px" }}>
                {this.props.spendDetails.currentActiveRequest.Number_Of_Records > this.state.chunkSize ?
                                                'We recommend downloading files longer than 7000 records as a csv. Excel outputs longer than 7000 records will be delivered in multiple files.'.replaceAll("7000", this.state.chunkSize)
                                                : null
                                            }
                
                </div>
                {this.state.activeItem.formats.map(fmt => (
                  <label key={fmt.format} style={styles.labelStyle}>
                    <input
                      type="radio"
                      name="format"
                      value={fmt.format}
                      checked={this.state.selectedFormat === fmt.format}
                      onChange={() => this.setState({ selectedFormat: fmt.format })}
                      style={{ marginRight: '12px' }}
                    />
                    {fmt.format}
                  </label>
                ))}
      
                <div style={styles.buttonRowStyle}>
                  <Button
                    content={"Download"}
                    disabled={this.state.isLoading}
                    onClick={this.handleDownload}
                    color
                  />
                  <Button
                    content={"Close"}
                    disabled={this.state.isLoading}
                    onClick={this.closeFormatPopup}
                    color
                  />
                </div>
              </div>
            )}
          </div>
        );
      }
      
      
    onSave() {
        const pendingRecords = this.state.pendingRecords;
        if (pendingRecords.length === 0) {
            return;
        }

        this.props.defineScopeLoading(true)
        this.setState({ isLoading: true, isError: 'No', responseMsg: '', isSaveInProgress: true })
        const rowData = this.state.rowData
        const exclusionReason_directSpendUpdates = this.state.exclusionReason_directSpendUpdates
        const recordsToInsert = [];
        const cleanIndustryOverrides = this.state.cleanIndustryOverrides
        const userCommentOverrides = this.state.userCommentOverrides
        const confirmedflagTrans = this.state.confirmedflagTrans
        const capIQIdOverrides = this.state.capIQIdOverrides
        const enablementWaveOverrides = this.state.enablementWaveOverrides

        pendingRecords.forEach((item) => {
            rowData.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })  // binary search work with sorted array only
            var rowIdx = binarySearchIndex(rowData, item, 'DATA_COLLECTIONS_SKEY')
            const row = rowData[rowIdx]
            const dkeyRecord = cleanIndustryOverrides[item]
            const skeyRecord = userCommentOverrides[item]
            const confirmedFlagRecord = confirmedflagTrans[item]
            const capIqIdRecord = capIQIdOverrides[item]
            const enablementWaveRecord = enablementWaveOverrides[item]
            const record = {
                VS_ID: this.props.spendDetails.currentActiveRequest.VS_ID, DMC_ID: this.props.spendDetails.currentActiveRequest.DMC_ID, DATA_COLLECTIONS_SKEY: item,
                USER_ID: this.props.user.user.Email,
                FLAG_SOLUTION: row["SCOPE_SOURCE"] === "Override" ? "Yes" : "No",
                FLAG_INDUSTRY: ((dkeyRecord && dkeyRecord.old !== dkeyRecord.new) || row["SCOPE_SOURCE"] === "Industry") ? "Yes" : "No",
                FLAG_INP: exclusionReason_directSpendUpdates.includes(row["DATA_COLLECTIONS_SKEY"]) ? "Yes" : "No",
                FLAG_CONFIRMED: (confirmedFlagRecord && confirmedFlagRecord.old !== confirmedFlagRecord.new) ? "Yes" : "No",
                SCOPE_SOURCE: row["SCOPE_SOURCE"],
                OVERRIDE_GICS: row["OVERRIDE_INDUSTRY_ID"],
                CONFIRMED: row["CONFIRMED"],
                EXCLUSION_REASON: row["EXCLUSION_REASON"],
                GOODS_OR_SERVICE: row["GOODS_OR_SERVICE"],
                DIRECT_SPEND: row["DIRECT_SPEND"],
                SAP_ARIBA_BUY_PROCESS: row["SAP_ARIBA_BUY_PROCESS"],
                SOURCING_ELIGIBLE: row["SOURCING_ELIGIBLE"],
                BUYING_INV_ELIGIBLE: row["BUYING_INVOICING_ELIGIBLE"],
                REQUISITION_ABLE: row["REQUISITIONABLE"],
                REQUISITION_TYPE: row["REQUISITION_TYPE"],
                CONTRACT_INV_ELIGIBLE: row["CONTRACT_INVOICING_ELIGIBLE"],
                COMMERCE_AUTOMATION_ELIGIBLE: row["COMMERCE_AUTOMATION_ELIGIBLE"],
                SUPP_CHAIN_COLLAB_ELIGIBLE: row["SUPP_CHAIN_COLLAB_ELIGIBLE"],
                PAYABLES_ELIGIBLE: row["PAYABLES_ELIGIBLE"],
                SAP_FIELDGLASS_ELIGIBLE: row["SAP_FIELDGLASS_ELIGIBLE"],
                SAP_CONCUR_ELIGIBLE: row["SAP_CONCUR_ELIGIBLE"],
                SPOT_BUY_ELIGIBLE: row["SPOT_BUY_ELIGIBLE"],
                USER_DEF_TEXT_FIELD_1: row["USER_DEF_TEXT_FIELD_1"],
                USER_DEF_TEXT_FIELD_2: row["USER_DEF_TEXT_FIELD_2"],
                USER_DEF_TEXT_FIELD_3: row["USER_DEF_TEXT_FIELD_3"],
                USER_DEF_TEXT_FIELD_4: row["USER_DEF_TEXT_FIELD_4"],
                USER_DEF_TEXT_FIELD_5: row["USER_DEF_TEXT_FIELD_5"],
                USER_DEF_NUMBERIC_FIELD_1: row["USER_DEF_NUMBERIC_FIELD_1"],
                USER_DEF_NUMBERIC_FIELD_2: row["USER_DEF_NUMBERIC_FIELD_2"],
                USER_DEF_NUMBERIC_FIELD_3: row["USER_DEF_NUMBERIC_FIELD_3"],
                USER_DEF_NUMBERIC_FIELD_4: row["USER_DEF_NUMBERIC_FIELD_4"],
                USER_DEF_NUMBERIC_FIELD_5: row["USER_DEF_NUMBERIC_FIELD_5"],
                USER_COMMENT: row["USER_COMMENT"],
                USER_DATE_FIELD: row["USER_DATE_FIELD"],
                DPO: row["DPO"],
                STANDARD_TERM: row["STANDARD_TERM"],
                DISCOUNT_TERM: row["DISCOUNT_TERM"],
                DISCOUNT_PERCENTAGE: row["DISCOUNT_PERCENTAGE"],
                WORKING_CAPTIAL_SEGMENTATION: row["WORKING_CAPTIAL_SEGMENTATION"],
                TERMS_RATIONALIZATION: row["TERMS_RATIONALIZATION"],
                DISCOUNT_ELIGIBLE: row["DISCOUNT_ELIGIBLE"],
                COMPANY_ID: row["CAPIQ_COMPANY_ID"],
                BUYER_SUPPLIER_RELATIONSHIP: row["BUYER_SUPPLIER_RELATIONSHIP"],
                SAP_ARIBA_DOC_PROXY: row["SAP_ARIBA_DOC_PROXY"],
                SAP_ARIBA_SPEND_PROXY: row["SAP_ARIBA_SPEND_PROXY"],
                SAP_ARIBA_BUY_ENABLE_MTHD_RECMD: row["SAP_ARIBA_BUY_ENABLE_MTHD_RECMD"],
                ENABLEMENT_WAVE: row["ENABLEMENT_WAVE"],
                ENABLEMENT_RECOMMENDATION_OVERRIDE: row["ENABLEMENT_RECOMMENDATION_OVERRIDE"],
                ENABLEMENT_WAVE_OVERRIDE: row["ENABLEMENT_WAVE_OVERRIDE"],
                ONBOARDING_WORKSTREAM_DETAILS: row["ONBOARDING_WORKSTREAM_DETAILS"] == "" ? "" : row["ONBOARDING_WORKSTREAM_DETAILS"],
                ONBOARDING_WORKSTREAM_DETAILS_OVERRIDE: row["ONBOARDING_WORKSTREAM_DETAILS_OVERRIDE"],
                ENABLE_MTHD_RECMD_OUT_SCOPE_REASON: row["ENABLE_MTHD_RECMD_OUT_SCOPE_REASON"],

                // SCC Fields
                ADD_SUPPLIER_NAME: row["ADD_SUPPLIER_NAME"],
                COMPANY_VENDOR_LIST: row["COMPANY_VENDOR_LIST"],
                CUSTOM_FIELD1: row["CUSTOM_FIELD1"],
                CUSTOM_FIELD2: row["CUSTOM_FIELD2"],
                ENABLEMENT_WAVE: row["ENABLEMENT_WAVE"],
                ERP_ASN_CNT: row["ERP_ASN_CNT"],
                ERP_OC_CNT: row["ERP_OC_CNT"],
                ERP_PO_LINE_ITEM_CNT: row["ERP_PO_LINE_ITEM_CNT"],
                GOBAL_SUPPLIER_REGION: row["GOBAL_SUPPLIER_REGION"],
                LST_TRANS_BUYER_ERP_DATE: row["LST_TRANS_BUYER_ERP_DATE"],
                PLANT_BUSS_VENDOR_ADDRESS: row["PLANT_BUSS_VENDOR_ADDRESS"],
                PLANT_BUSS_VENDOR_ID: row["PLANT_BUSS_VENDOR_ID"],
                SUPPLIER_TYPE: row["SUPPLIER_TYPE"],
                SCC_CONSIGMENT_COLLABRATION_IN_SCOPE: row["SCC_CONSIGMENT_COLLABRATION_IN_SCOPE"],
                SCC_FORECAST_IN_SCOPE: row["SCC_FORECAST_IN_SCOPE"],
                SCC_QUALITY_INSPECTION_IN_SCOPE: row["SCC_QUALITY_INSPECTION_IN_SCOPE"],
                SCC_QUALITY_NOTIFICATION_IN_SCOPE: row["SCC_QUALITY_NOTIFICATION_IN_SCOPE"],
                SCC_QUALITY_REVIEW_IN_SCOPE: row["SCC_QUALITY_REVIEW_IN_SCOPE"],
                SCC_SCHEDULE_AGGREMENT_IN_SCOPE: row["SCC_SCHEDULE_AGGREMENT_IN_SCOPE"],
                SCC_SMI_IN_SCOPE: row["SCC_SMI_IN_SCOPE"],
                SCC_SOLUTION_IN_SCOPE: row["SCC_SOLUTION_IN_SCOPE"],
                SCC_STD_ORDER_PROCESS_IN_SCOPE: row["SCC_STD_ORDER_PROCESS_IN_SCOPE"],
                SCC_SUBCONTRACTING_IN_SCOPE: row["SCC_SUBCONTRACTING_IN_SCOPE"],
                SAP_BUSS_NET_TRANS_MTHD: row["SAP_BUSS_NET_TRANS_MTHD"],
                RETURN_IN_SCOPE: row["RETURN_IN_SCOPE"],

                PRIMARY_BUY_PROCESS_DELIVERED: row["PRIMARY_BUY_PROCESS_DELIVERED"],
                SECONDARY_BUY_PROCESS_DELIVERED: row["SECONDARY_BUY_PROCESS_DELIVERED"],
                OTHER_BUY_PROCESS_DELIVERED: row["OTHER_BUY_PROCESS_DELIVERED"],

                SPEND_COMPLIANCE: row["SPEND_COMPLIANCE"],
                PROCESS_IMPROVEMENT: row["PROCESS_IMPROVEMENT"],
                PRICE_REDUCTION: row["PRICE_REDUCTION"],
                WORKING_CAPITAL: row["WORKING_CAPITAL"]
              };

            recordsToInsert.push(record);
        })

        this.props.insertDetailedFileRecords(recordsToInsert)
            .then((response) => {
                let spendData = response.data.Result.SpendData;
                let supplierComments = response.data.Result.SupplierComments;
                let flightPlanningData = response.data.Result.FlightPlanningData;
                const rowData = this.state.rowData;
                const filteredRows = this.state.filteredRows;
                var matched = 0;

                for (var i = 0; i < spendData.length; i++) {
                    const row = spendData[i];
                    if (row['OVERRIDE_INDUSTRY_ID'] === 0)
                        row['OVERRIDE_INDUSTRY_ID'] = ''

                    const skey = row['DATA_COLLECTIONS_SKEY'];
                    rowData.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })  // binary search work with sorted array only
                    var rowIdx = binarySearchIndex(rowData, skey, 'DATA_COLLECTIONS_SKEY')
                    rowData[rowIdx] = { ...rowData[rowIdx], ...row };

                    for (var idx = 0; idx < filteredRows.length; idx++) {
                        if (filteredRows[idx]['DATA_COLLECTIONS_SKEY'] === row['DATA_COLLECTIONS_SKEY']) {
                            filteredRows[idx] = { ...filteredRows[idx], ...row };
                            matched++;
                        }

                        if (matched === spendData.length) {
                            break;
                        }
                    }
                }

                matched = 0;
                for (var i = 0; i < supplierComments.length; i++) {
                    const commentRow = supplierComments[i];
                    const commentSkey = commentRow['DATA_COLLECTIONS_SKEY'];
                    rowData.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })  // binary search work with sorted array only
                    var rowIdx = binarySearchIndex(rowData, commentSkey, 'DATA_COLLECTIONS_SKEY')
                    rowData[rowIdx] = { ...rowData[rowIdx], ...commentRow };
                    for (var idx = 0; idx < filteredRows.length; idx++) {
                        if (filteredRows[idx]['DATA_COLLECTIONS_SKEY'] === commentRow['DATA_COLLECTIONS_SKEY']) {
                            filteredRows[idx] = { ...filteredRows[idx], ...commentRow };
                            matched++;
                        }
                        if (matched === supplierComments.length) {
                            break;
                        }
                    }
                }

                matched = 0;
                for (var i = 0; i < flightPlanningData.length; i++) {
                    const flightPlanningRow = flightPlanningData[i];
                    const flightPlanningRowSkey = flightPlanningRow['DATA_COLLECTIONS_SKEY'];
                    rowData.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })  // binary search work with sorted array only
                    var rowIdx = binarySearchIndex(rowData, flightPlanningRowSkey, 'DATA_COLLECTIONS_SKEY')
                    rowData[rowIdx] = { ...rowData[rowIdx], ...flightPlanningRow };
                    for (var idx = 0; idx < filteredRows.length; idx++) {
                        if (filteredRows[idx]['DATA_COLLECTIONS_SKEY'] === flightPlanningRow['DATA_COLLECTIONS_SKEY']) {
                            filteredRows[idx] = { ...filteredRows[idx], ...flightPlanningRow };
                            matched++;
                        }
                        if (matched === flightPlanningData.length) {
                            break;
                        }
                    }
                }

                this.props.defineScopeLoading(false)
                this.props.pendingChanges(null)

                if (spendData.length > 0) {
                    this.props.setResultSummaryDetails([])
                    this.props.setTopDetails([])
                }
                this.setState({ confirmedflagTrans: {}, cleanIndustryOverrides: {}, capIQIdOverrides: {}, enablementWaveOverrides: {}, filteredRows: filteredRows, rowData: rowData, pendingRecords: [], errorRecords: [], warningRecords: [], exclusionReason_directSpendUpdates: [], responseMsg: 'Record/s has been updated successfully', isError: 'No', isLoading: false, isSaveInProgress: false },
                    () => this.filteredColumnValues = [])
            }).catch((error) => {
                if (error.stack.includes('Network Error')) {
                    this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: 'API service is down. Please contact administrator.', isError: 'Yes', isLoading: false, isSaveInProgress: false })
                }
                else {
                    this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false, isSaveInProgress: false })
                }
            })
    }

    /* This method can be used to highlight the cell values */
    RowRenderer = ({ renderBaseRow, ...props }) => {
        if (props.row.superHeader && Object.keys(props.row.superHeader).length > 0) {
            const value = props.row.superHeader
            let left = 0
            let headerGroupDiv = Object.keys(value).map((key, index) => {
                const val = value[key]
                let row = {}
                if (val.name === null) {
                    let cellValue = (<div className='react-grid-HeaderCell react-grid-HeaderCell-Group'
                        style={{ position: 'absolute', width: `${val.width}px`, height: '35px', left: `${left}px`, backgroundColor: '#ffffff', }}>
                        <div className='react-grid-HeaderCell-sortable'>
                        </div>
                    </div>)

                    left = left + val.width

                    return cellValue
                } else {
                    let width = 0
                    val.forEach(item => {
                        width = width + item.width
                    })
                    // const width = val.length * val.width
                    let cellValue = (<div className='react-grid-HeaderCell react-grid-HeaderCell-Group'
                        style={{ textAlign: 'left', position: 'absolute', width: `${width}px`, height: '35px', left: `${left}px`, backgroundColor: '#7f7f7f', color: '#ffffff', textOverflow: 'ellipsis', whiteSpace: 'nowrap', transform: 'none' }}>
                        <div title={key} className='react-grid-HeaderCell-sortable'>
                            {key}
                        </div>
                    </div>)

                    val.forEach(item => {
                        left = left + item.width
                    })

                    return cellValue
                }
            })

            return <div className='react-grid-HeaderRow' style={{ height: '35px', overflow: 'hidden' }}>{headerGroupDiv}</div>
        }


        if (this.state.pendingRecords.length === 0) {
            return renderBaseRow(props);
        }

        let backgroundColor = '';
        let textAlign = 'left';

        const pendingRecords = this.state.pendingRecords;
        const warningRecords = this.state.warningRecords;
        const errorRecords = this.state.errorRecords;

        Object.values(pendingRecords).every((item) => {
            if (item === props.row.DATA_COLLECTIONS_SKEY) {
                backgroundColor = 'lightgray'
                return false
            } else {
                return true
            }
        })

        Object.values(warningRecords).forEach((itemArr) => {
            itemArr.every(item => {
                if (item === props.row.DATA_COLLECTIONS_SKEY) {
                    backgroundColor = 'yellow'
                    return false
                } else {
                    return true
                }
            })
        })

        Object.values(errorRecords).forEach((itemArr) => {
            itemArr.every(item => {
                if (item === props.row.DATA_COLLECTIONS_SKEY) {
                    backgroundColor = 'red'
                    return false
                } else {
                    return true
                }
            })
        })

        return <div style={{ backgroundColor }}>{renderBaseRow(props)}</div>;

    };

    mergeCsvMenus = (menuConfig) => {
        return menuConfig.map(group => {
            const map = {};
            group.items.forEach(item => {
                let label = item.label || '';
                label = label.trim();
                if (!label) return;
                const isCsv = /csv/i.test(label);
                const baseLabel = label
                    .replace(/csv/ig, '')
                    .replace(/\(\s*\)/g, '')
                    .replace(/[_\-]+/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim();

                if (!map[baseLabel]) {
                    map[baseLabel] = {
                        ...item,
                        label: baseLabel,
                        isUnified: false,
                        extraCondition: item.HasExtraCondition,
                        // 🔥 IMPORTANT
                        excelValue: null,
                        csvValue: null
                    };
                }
                else{

                    const existing = map[baseLabel];

                    map[baseLabel] = {
                        ...existing,
                        extraCondition : existing.HasExtraCondition || item.HasExtraCondition,
                        value: existing.value || item.value,
                    }
                }
                if (isCsv) {
                    map[baseLabel].csvValue = item.value;
                } else {
                    map[baseLabel].excelValue = item.value;
                    map[baseLabel].value = item.value;
                }

                if (map[baseLabel].excelValue && map[baseLabel].csvValue) {
                    map[baseLabel].isUnified = true;
                }
            });

            return {
                ...group,
                items: Object.values(map)
            };
        });
    };   

    loadDownloadMenuConfig() {
        this.props.fetchJSONConfigSpendDownloadMenu()
          .then((res) => {
            const groupedItems = {};
      
            // Step 1️⃣ Collect all items by baseLabel
            res.data.forEach(group => {
                group.items.forEach(item => {
                    const baseLabel = item.label
                      .replace(/csv/i, "")
                      .replace(/\s+/g, " ")
                      .trim();
                  
                    if (!groupedItems[baseLabel]) {
                      groupedItems[baseLabel] = {
                        baseLabel,
                        group: group.group,
                        formats: []
                      };
                    }
                  
                    const format = /csv/i.test(item.label) ? "CSV" : "Excel";
                  
                    groupedItems[baseLabel].formats.push({
                      ...item,
                      format,
                      extraCondition: item.HasExtraCondition ? (props) => true : null
                    });
                  });
            });
      
            // Step 2️⃣ Inject Email formats if allowed
            Object.keys(groupedItems).forEach(baseLabel => {
                const item = groupedItems[baseLabel];
                const allowedFormats = menuFormats[baseLabel] || [];
              
                // Special-case handling for RunDMC, All, VUF
                if (["RunDMC Output (Internal Only)", "All (Internal Only)", "Vendor Upload File","Vendor Upload File - Enhanced"].includes(baseLabel)) {
                  item.formats = item.formats.map(original => {
                    // Keep original value/label, only override format
                    const fmt = allowedFormats[0]; // only one format defined in menuFormats
                    return {
                      ...original,
                      format: fmt,
                      extraCondition: original.HasExtraCondition ? (props) => true : null
                    };
                  });
                } else {
                  // Normal handling for other menus
                  item.formats = allowedFormats.map(fmt => {
                    const original = item.formats.find(f => f.format === fmt);
                    if (original) {
                      return {
                        ...original,
                        format: fmt,
                        extraCondition: original.HasExtraCondition ? (props) => true : null
                      };
                    } else {
                      return {
                        baseLabel,
                        label: baseLabel,
                        value: baseLabel, // fallback only if API didn’t provide
                        format: fmt,
                        extraCondition: () => true
                      };
                    }
                  });
                }
              
                // Visibility check
                item.formats = item.formats.filter(fmt =>
                  this.checkVisibility(fmt, this.props)
                );
              
                if (item.formats.length === 0) {
                  delete groupedItems[baseLabel];
                }
              });
              
              
              

            // Step 4️⃣ Rebuild groups with merged items
            const transformed = res.data.map(group => ({
              ...group,
              items: Object.values(groupedItems).filter(i => i.group === group.group)
            }));
      
            this.setState({ menuConfig: transformed });
          });
      }
      
      
    componentDidMount() {
        this.loadDownloadMenuConfig();
        var sortByOption = this.state.sortByOption;
        var selectedSortBy = this.state.selectedSortBy;
        var gridSortBy = this.state.gridSortBy;
        var sortByName = this.state.sortByName;
        if (this.props.spendDetails.solutionScope == 'Supply Chain Collaboration') {
            sortByOption[0].value = 'SCC_ENABLE_MATCH_SPND_DOC_SCORE';
            selectedSortBy = 'SCC_ENABLE_MATCH_SPND_DOC_SCORE';
            gridSortBy = 'SCC_ENABLE_MATCH_SPND_DOC_SCORE';
            sortByName = 'SCC Enablement Match Spend & Document Score';
        }
        else if (this.props.spendDetails.kpi_Model == 1) {
            sortByOption[0].value = 'AVATAR_WAVE_SCORE';
            selectedSortBy = 'AVATAR_WAVE_SCORE';
            gridSortBy = 'AVATAR_WAVE_SCORE';
            sortByName = 'Intelligent Enablement Match Spend & Document Score';
        }
        else if (this.props.spendDetails.kpi_Model == 2) {
            sortByOption[0].value = 'KPI_ENABLE_MATCH_SPD_DOC_SCORE';
            selectedSortBy = 'KPI_ENABLE_MATCH_SPD_DOC_SCORE';
            gridSortBy = 'KPI_ENABLE_MATCH_SPD_DOC_SCORE';
            sortByName = 'KPI Enablement Match Spend & Document Score';
        }

        this.props.defineScopeLoading(true)
        let matchAndClassificationColumnsFlag = this.props.user.user.applicationFeatures.findIndex(a => a.Action === 'exportMatchAndClassificationColumns') > -1 ? true : false
        this.loadData();
        this.loadVendorData()
        this.loadVendorDataEnhanced()
        // if(this.props.spendDetails.currentActiveRequest.DMC_ID !== undefined && this.state.rowData.length == 0){
        //     this.loadVendorData()
        //   }       

        let fileExportOption = this.props.spendDetails.currentActiveRequest.Number_Of_Records > downloadThreshold ? 'customerViewColumnsCSV' : 'customerViewColumns';

        var data=[{READ_WRITE_FLAG : "R", SCREEN_FLAG : "A"}]; 
        this.props.FetchUpdateFieldVisibility(data).then((response) => {
            if (response.status === 200) {
                this.setState({ chunkSize: response.data.Result.filter(x=>x.FIELD_VISIBILITY_ID == 2)[0].VISIBLE_FLAG});
            }
        });     

        window.scrollTo(0, 0);
        this.setState({
            exportAction: fileExportOption, exportMC_Cloumns: matchAndClassificationColumnsFlag,
            isCapIQLicesend: this.props.user.user.applicationFeatures.findIndex(a => a.Action === this.props.content.capIQAction) > -1 ? true : false,
            sortByOption: sortByOption, selectedSortBy: selectedSortBy, gridSortBy: gridSortBy, sortByName: sortByName
        })
    }

    getApplicationFeatureActions() {
        let actions = [];
        let applicationFeatures = this.props.user && this.props.user.user && this.props.user.user.applicationFeatures ? this.props.user.user.applicationFeatures : [];
        applicationFeatures.map(applicationFeat => {
            actions.push(applicationFeat.Action);
        })
        return actions;
    }

    getTableColumn(self, fieldName, fieldConfig) {
        let tableColumn = {};
        tableColumn = {
            name: fieldConfig.screen_field_name,
            key: fieldName,
            width: 120,
            sortable: true,
            editable: fieldConfig.is_editable !== 'No',
            resizable: true,
            filterable: true,
            screenSeq: fieldConfig.screen_seq,
            editProperty: fieldConfig.is_editable,
            formatter: formatter(fieldConfig.alignment),
            filterRenderer: filterRenderer(fieldConfig.filter_type),
            helpText: fieldConfig.screen_help_text,
            hash: (new Date).getTime(),
            headerGroup: fieldConfig.headerGroup,
            label: fieldConfig.excel_col_name
        }

        if (fieldConfig.editor) {
            tableColumn.editor = editorComponent(fieldConfig.editor, fieldConfig.editorValues);
        }

        if (fieldName == 'OVERRIDE_INDUSTRY_ID') {
            tableColumn.editProperty = 'Yes'
            tableColumn.events = {
                onDoubleClick: function (ev, args) {
                    if (args.rowIdx > 1)
                        self.setState({ open: true, industryOverrideRowNo: args.rowIdx })
                }
            }
        }
        else if (fieldName == 'CAPIQ_COMPANY_ID') {
            tableColumn.editProperty = 'Yes'
            tableColumn.events = {
                onDoubleClick: function (ev, args) {
                    //console.log("double click id ",self.state.filteredRows[(self.state.paginatedRowFrom + args.rowIdx) - 1]['CAPIQ_COMPANY_ID'])
                    var capIqId = self.state.filteredRows[(self.state.paginatedRowFrom + args.rowIdx) - 2]['CAPIQ_COMPANY_ID'];
                    var scopeSource = self.state.filteredRows[(self.state.paginatedRowFrom + args.rowIdx) - 2]['SCOPE_SOURCE'];
                    var finalIndustryDesc = self.state.filteredRows[(self.state.paginatedRowFrom + args.rowIdx) - 2]['FINAL_INDUSTRY_DESCRIPTION'];
                    var dmcIndustryId = self.state.filteredRows[(self.state.paginatedRowFrom + args.rowIdx) - 2]['DMC_INDUSTRY_ID']; // DMC_INDUSTRY_ID value is not overrided when we overried unclassified industry, so we can use this flag while opening capiq popup
                    if (args.rowIdx != 0)
                        self.setState({ openCapIq: true, capIqIdOverrideRowNo: args.rowIdx, currentCapIqId: capIqId, currentScopeSource: scopeSource, industryDesc: finalIndustryDesc, currentDMCIndstryId: dmcIndustryId })
                }
            }
        }
        else if (fieldName == 'VENDOR_NAME' && self.state.isCapIQLicesend) {
            tableColumn['formatter'] = VendorLinkFormatter
        }
        else if (fieldName == 'FINAL_INDUSTRY_DESCRIPTION' && self.state.isCapIQLicesend) {
            tableColumn['formatter'] = IndustryLinkFormatter
        }
        else if (fieldName == 'USER_COMMENT') {
            tableColumn.editable = true
            tableColumn.editProperty = 'Yes'
            tableColumn.events = {
                onDoubleClick: function (ev, args) {
                    var skey = self.state.filteredRows[(self.state.paginatedRowFrom + args.rowIdx) - 2]['DATA_COLLECTIONS_SKEY'];
                    var userComment = self.state.filteredRows[(self.state.paginatedRowFrom + args.rowIdx) - 2]['USER_COMMENT'];
                    if (args.rowIdx != 0)
                        self.setState({ selectedSupplier: skey, openUserCommentsPopUp: true, userCommentsRowNo: args.rowIdx, userCommentInsideCell: userComment })
                }
            }
        } else if (fieldName == 'ENABLEMENT_WAVE') {
            tableColumn.editProperty = 'Yes'
            tableColumn.events = {
                onDoubleClick: function (ev, args) {
                    if (args.rowIdx != 0)
                        self.setState({ openEnablementInsightPopUp: true, enablementWaveInputRowNo: args.rowIdx, enablementWaveInputValue: ev.target.innerText })
                }
            }
        }

        if (fieldConfig.field == 'SAP_ARIBA_BUY_ENABLE_MTHD_RECMD') {
            tableColumn["width"] = 380
        }

        if (fieldConfig.field == 'GANTT_CHART_WORKSTREAM_NAME') {
            tableColumn["width"] = 250
        }

        if (fieldConfig.field == 'BUYER_SUPPLIER_RELATIONSHIP') {
            tableColumn["editor"] = TextEditor
            tableColumn["max"] = 50
        }
        tableColumn.editable = tableColumn.editable && !this.props.readOnly

        return tableColumn;
    }

    breakNumberInSet(number, n) {
        const values = [];
        let times = number;
        while (times > 0) {
            if (times >= n)
                values.push(n);
            else
                values.push(times);
            times = times - n;
        }
        return values;
    }

    getSpendData = (recordNumber, index) => {
        return new Promise((resolve, reject) => {
            this.props.getDetailedFileSpendData(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID,
                this.props.user.user.Email, recordNumber, index)
                .then((response) => {
                    // console.log(index);
                    // console.log(response.data.Result);
                    return resolve(response.data.Result)
                })
                .catch(error => {
                    return reject(error.message)
                })
        })
    }

    async loadData() {
        // console.log('Load Start');
        // console.log(+ new Date().getDate() + '/' + new Date().getMonth() + '/' + new Date().getFullYear() + '- ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
        let recordsPerSet = 40000;
        this.props.defineScopeLoading(true)
        this.setState({ finalSpendData: [], vufData: [], vufDataEnhanced: [], isLoading: true, responseMsg: '', isError: 'No' })
        // let firstRoundTrip = 1; let secondRoundTrip = 2;
        let requestFileRecordCount = this.props.spendDetails.currentActiveRequest.Number_Of_Records;

        let arrRecords = this.breakNumberInSet(requestFileRecordCount, recordsPerSet);
        let finalSpendData = [];
        let vufWaves = [];
        var procedureResult = [];
        var procedureNames;
        var procedureNextResult = [];
        let j = 0;

        //-----------------------

        //let results = [];
        let promises = [];
        //let param;

        for (j; j < arrRecords.length; j++) {

            let param = { 'page': j }
            let tmpPromise = this.getSpendData(arrRecords[j], j);
            promises.push(tmpPromise);

        }
        let resolved = await Promise.all(promises).then((arrayOfArrays) => {
            return [].concat.apply([], arrayOfArrays);
        });
        //resolved is an array of resolved promises, each with value returned by async call
        let indivResult = resolved.forEach((response, index) => {
            // console.log('resolve ' + index + ' start');
            // console.log(+ new Date().getDate() + '/' + new Date().getMonth() + '/' + new Date().getFullYear() + '- ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());

            if (index == 0) {
                //var procedureResult = [];
                procedureNames = Object.keys(response)
                for (var i = 0; i < procedureNames.length; i++) {
                    procedureResult.push(response[procedureNames[i]])
                }
                finalSpendData = response[procedureNames[0]]
                for (var i = 1; i < procedureResult.length; i++) {
                    finalSpendData = mergeArrayByKey(finalSpendData, procedureResult[i], 'DATA_COLLECTIONS_SKEY')
                }
                //let waves = finalSpendData.filter(item => Number.isInteger(Number(item.ENABLEMENT_WAVE)))
                let waves = finalSpendData.filter(item => item.ENABLEMENT_WAVE)
                //let vufWaves = []
                waves.forEach(item => vufWaves.push(item.ENABLEMENT_WAVE))
            }
            else {

                procedureNextResult = [];
                for (var i = 0; i < procedureNames.length; i++) {
                    procedureNextResult.push(response[procedureNames[i]])
                }
                var remainingSpendData = response[procedureNames[0]]
                for (var i = 1; i < procedureNextResult.length; i++) {
                    remainingSpendData = mergeArrayByKey(remainingSpendData, procedureNextResult[i], 'DATA_COLLECTIONS_SKEY')
                }
                finalSpendData = [...finalSpendData, ...remainingSpendData]
                remainingSpendData = null;
                //this.setState({ finalSpendData: finalSpendData, vufWaves: vufWaves }, () => this.formatSpendData())
                // console.log('resolve ' + index + ' end');
                // console.log(+ new Date().getDate() + '/' + new Date().getMonth() + '/' + new Date().getFullYear() + '- ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());

            }
        });
        // console.log('API END');
        // console.log(+ new Date().getDate() + '/' + new Date().getMonth() + '/' + new Date().getFullYear() + '- ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
        finalSpendData = finalSpendData.sort((a, b) => a.DATA_COLLECTIONS_SKEY - b.DATA_COLLECTIONS_SKEY);
        // console.log('SORT END');
        // console.log(+ new Date().getDate() + '/' + new Date().getMonth() + '/' + new Date().getFullYear() + '- ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
        this.setState({ finalSpendData: finalSpendData, vufWaves: vufWaves }, () => this.formatSpendData());
        finalSpendData = [];
        vufWaves = [];
        procedureResult = [];
        procedureNextResult = [];
        resolved = null;
        // console.log('Set State End');
        // console.log(+ new Date().getDate() + '/' + new Date().getMonth() + '/' + new Date().getFullYear() + '- ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
    }

    openNdlPopUp() {
        this.setState({ exportAction: 'matchedOutputDemo' }, this.showModal('ndlAlert'));
    }

    openDownloadPopup() {
        var exportAction = this.state.exportAction === 'matchedOutputDemo' ? 'customerViewColumns' : this.state.exportAction;
        this.setState({ showFormatPopup: false, activeItem: null,exportAction: exportAction }, this.showModal('alert'));
    }

    const
    move = (array, from, to) => {
        const value = array[from];

        if (from < to) array.copyWithin(from, from + 1, to + 1);
        else array.copyWithin(to + 1, to, from + 1);
        array[to] = value;
        return array;
    };

    ndlDownload() {
        this.setState({ isLoading: true }, this.forceUpdate);
        this.props.getNdlColumnsConfiguration().then((response) => {
            const colConfig = response.data.Result;
            const colConfigArr = [];
            var ndlColumns = [];            
            var ndlColumnsCustFacingEnhanced = [];
            var ndlColumnsMatchOutputEnhanced = [];
            var ndlParentAccountInfoColumns = [];
            var ndlCustFacingColumns = [];
            var ndlColumnsDoNotShareWithCustomer = [];

            colConfig.forEach((item, index) => {
                for (var key in item) {
                    if (key === 'field') {
                        //colConfigArr[item[key]] = item;
                        if (item.isNDL == 'Yes') {
                            ndlColumns.push({ label: item.excel_col_name, key: item.field, seq: item.screen_seq, filter_type: item.filter_type, alignment: item.alignment })
                        }                        
                        if (item.isCustFacing == 'Yes') {
                            ndlCustFacingColumns.push({ label: item.excel_col_name, key: item.field, seq: item.screen_seq, filter_type: item.filter_type, alignment: item.alignment })
                        }
                        if (item.IsNdlCustFacingEnhanced == 'Yes') {
                            ndlColumnsCustFacingEnhanced.push({ label: item.excel_col_name, key: item.field, seq: item.screen_seq, filter_type: item.filter_type, alignment: item.alignment })
                        }
                        if (item.IsNdlMatchOutputEnhanced == 'Yes') {
                            ndlColumnsMatchOutputEnhanced.push({ label: item.excel_col_name, key: item.field, seq: item.screen_seq, filter_type: item.filter_type, alignment: item.alignment })
                        }
                        if (item.isParentAccountInfo == 'Yes')
                            ndlParentAccountInfoColumns.push({ label: item.excel_col_name, key: item.field, seq: item.screen_seq, filter_type: item.filter_type, alignment: item.alignment })
                        break;
                    }
                }
            })


            let arr = [...ndlColumns];

            // Keep the last column
            const last = arr.pop();

            // Take last 4 (before last)
            const lastFour = arr.splice(-4);

            // Rebuild array: lastFour + remaining + last
            ndlColumnsDoNotShareWithCustomer = [...lastFour, ...arr, last];
            
            var flag_avatar_sdmc = this.state.exportAction == 'matchedOutputDemo' || this.state.exportAction == 'custFacingMatchedOutputDemo' ? 'AVATAR' : 'SDMC';
            var detail = { DMCID: this.props.spendDetails.currentActiveRequest.DMC_ID, VSID: this.props.spendDetails.currentActiveRequest.VS_ID, Email: this.props.user.user.Id,FLAG_AVATAR_SDMC:flag_avatar_sdmc }
            var gridSortBy = this.state.gridSortBy;
            var gridSortDirection = this.state.gridSortDirection;
            this.props.getNdlReportData(detail).then((response) => {
                var ndlData = response.data.Result.Table;
                var ndlDNS_Data = response.data.Result.Table1;
                var comparer = this.downloadSortedRecords(gridSortBy, gridSortDirection);
                ndlData = ndlData.sort((a, b) => { return a['REF_NUMBER'] - b['REF_NUMBER'] });
                ndlData = gridSortDirection == 'NONE' ? ndlData : ndlData.sort(comparer);
                this.setState({ ndlColumns: ndlColumns, ndlData: ndlData,ndlDNS_Data:ndlDNS_Data, ndlParentAccountInfoColumns: ndlParentAccountInfoColumns, ndlCustFacingColumns: ndlCustFacingColumns, ndlColumnsCustFacingEnhanced: ndlColumnsCustFacingEnhanced,ndlColumnsMatchOutputEnhanced:ndlColumnsMatchOutputEnhanced, ndlColumnsDoNotShareWithCustomer: ndlColumnsDoNotShareWithCustomer }, this.handleClick())
            });
        });
    }


    formatSpendData() {
        this.props.getSpendColumnsConfiguration()
            .then((response) => {
                const colConfig = response.data.Result;
                const colConfigArr = [];
                colConfig.forEach((item, index) => {
                    for (var key in item) {
                        if (key === 'field') {
                            colConfigArr[item[key]] = item;
                            break;
                        }
                    }
                })
                this.setState({ responseMsg: '', isError: 'No' })
                var self = this;
                let selectedColumns = [];

                this.props.getSelectedColumn(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID, this.props.user.user.Id).then((colResponse) => {
                    selectedColumns = colResponse.data.Result;

                    var column = [];
                    for (var i = 0; i < this.state.finalSpendData.length; i++) {
                        column = Object.keys(this.state.finalSpendData[0]);

                        if (i === 0)
                            break;
                    }

                    //removed INDUSTRY_SCOPE_TYPE temporarily
                    const fieldIdx = column.indexOf('INDUSTRY_SCOPE_TYPE')
                    if (fieldIdx != -1) {
                        column.splice(fieldIdx, 1)
                    }
                    if (column.indexOf('VS_ID') != -1) {
                        column.splice(column.indexOf('VS_ID'), 1)
                    }
                    if (column.indexOf('DMC_ID') != -1) {
                        column.splice(column.indexOf('DMC_ID'), 1)
                    }

                    if (column.length === 0) {
                        this.props.defineScopeLoading(false)
                        this.setState({ responseMsg: this.props.content.noData, isError: 'Yes', isLoading: false })
                    }
                    else {
                        var finalColumn = [];
                        var colOptions = [];
                        var exportNonSensitiveColumns = [];
                        var exportEnablementInsightColumns = [];
                        var exportMatchAndClassificationColumns = [];
                        var exportMatchAndClassificationDirectConnectColumns = [];
                        var exportCustomerViewColumns = [];
                        var exportAllColumns = [];
                        var tableColumn = {};
                        var defaultScreenColumns = [];
                        var userDefinedColumns = [];
                        var exportSccEnableInsightViewColumns = [];
                        var exportSccViewColumns = [];

                        for (let index = 0; index < column.length; index++) {
                            const fieldName = column[index];

                            const fieldConfig = colConfigArr[fieldName];
                            if (!fieldConfig) {
                                this.setState({ responseMsg: 'Invalid Field Configuration: ' + fieldName, isError: 'Yes' })
                                return;
                            }
                            tableColumn = this.getTableColumn(self, fieldName, fieldConfig);
                            tableColumn.filter_type = fieldConfig.filter_type;
                            tableColumn.alignment = fieldConfig.alignment;
                            finalColumn.push(tableColumn);

                            if (fieldConfig.SccEnableInsightView === 'Yes') {
                                exportSccEnableInsightViewColumns.push({ label: fieldConfig.excel_col_name, key: fieldName, seq: fieldConfig.screen_seq, filter_type: fieldConfig.filter_type, alignment: fieldConfig.alignment, helpText : fieldConfig.screen_help_text })
                            }

                            if (fieldConfig.SccView === 'Yes') {
                                exportSccViewColumns.push({ label: fieldConfig.excel_col_name, key: fieldName, seq: fieldConfig.screen_seq, filter_type: fieldConfig.filter_type, alignment: fieldConfig.alignment, helpText : fieldConfig.screen_help_text })
                            }

                            //if (fieldConfig.export_fl === 'Yes' || (fieldConfig.internalEnablementInsightView === 'Yes' && fieldConfig.enablementInsight_export === 'Yes')) {
                            if (fieldConfig.is_default === 'Yes' || (fieldConfig.internalEnablementInsightView === 'Yes')) {
                                exportNonSensitiveColumns.push({ label: fieldConfig.excel_col_name, key: fieldName, seq: fieldConfig.screen_seq, filter_type: fieldConfig.filter_type, alignment: fieldConfig.alignment, helpText : fieldConfig.screen_help_text })
                            }
                            if (fieldConfig.enablementInsight_export === 'Yes') {
                                exportEnablementInsightColumns.push({ label: fieldConfig.excel_col_name, key: fieldName, seq: fieldConfig.screen_seq, filter_type: fieldConfig.filter_type, alignment: fieldConfig.alignment, helpText : fieldConfig.screen_help_text })
                            }
                            if (fieldConfig.matchAndClassification_export === 'Yes') {
                                exportMatchAndClassificationColumns.push({ label: fieldConfig.excel_col_name, key: fieldName, seq: fieldConfig.screen_seq, filter_type: fieldConfig.filter_type, alignment: fieldConfig.alignment, helpText : fieldConfig.screen_help_text })
                            }
                            if (fieldConfig.isMAndCDirectConnectExport === 'Yes') {
                                exportMatchAndClassificationDirectConnectColumns.push({ label: fieldConfig.excel_col_name, key: fieldName, seq: fieldConfig.screen_seq, filter_type: fieldConfig.filter_type, alignment: fieldConfig.alignment, helpText : fieldConfig.screen_help_text })
                            }
                            if (fieldConfig.customerView_export === 'Yes') {
                                exportCustomerViewColumns.push({ label: fieldConfig.excel_col_name, key: fieldName, seq: fieldConfig.screen_seq, filter_type: fieldConfig.filter_type, alignment: fieldConfig.alignment, helpText : fieldConfig.screen_help_text })
                            }
                            var self = this;
                            if (self.props.user.userprofile.Roles[0].indexOf("Export All_Spend Details") > -1) {
                                exportAllColumns.push({ label: fieldConfig.excel_col_name, key: fieldName, seq: fieldConfig.screen_seq, filter_type: fieldConfig.filter_type, alignment: fieldConfig.alignment, helpText : fieldConfig.screen_help_text })
                            }

                            let colOption = { id: fieldName, label: fieldConfig.screen_field_name, seq: fieldConfig.screen_seq, columnCategory: fieldConfig.column_category, value: tableColumn, is_default: fieldConfig.is_default, internalEnablementInsightView: fieldConfig.internalEnablementInsightView, externalEnablementInsightView: fieldConfig.externalEnablementInsightView, categoryInsightsView: fieldConfig.categoryInsightsView, enterpriseEnablementEstimatesView: fieldConfig.enterpriseEnablementEstimatesView, matchAndClassification_export: fieldConfig.matchAndClassification_export, sccEnableInsightView: fieldConfig.SccEnableInsightView, sccView: fieldConfig.SccView, allSccView: fieldConfig.allSccView };
                            if (selectedColumns.length > 0) {
                                if (selectedColumns.indexOf(fieldName) > -1) {
                                    defaultScreenColumns.push(tableColumn);
                                    colOption.isSelected = true;
                                } else {
                                    colOption.isSelected = false;
                                }
                            } else {
                                defaultScreenColumns.push(tableColumn);
                                colOption.isSelected = true;
                            }

                            if (fieldConfig.showOnUi == 'Yes')
                                colOptions.push(colOption);
                        }

                        // add Update flag
                        userDefinedColumns.push({ label: "Update Flag", key: "isUserDefinedRowUpdated", seq: column.length + 1 })

                        //Sequence of columns in Grid
                        if (defaultScreenColumns.length > 0)
                            defaultScreenColumns = defaultScreenColumns.sort((a, b) => { return a.screenSeq - b.screenSeq })
                        //Sequence of columns in popup
                        if (colOptions.length > 0)
                            colOptions = colOptions.sort((a, b) => { return a.seq - b.seq })
                        //Sequence of columns in Excel
                        if (exportNonSensitiveColumns.length > 0)
                            exportNonSensitiveColumns = exportNonSensitiveColumns.sort((a, b) => { return a.seq - b.seq })
                        if (exportEnablementInsightColumns.length > 0)
                            exportEnablementInsightColumns = exportEnablementInsightColumns.sort((a, b) => { return a.seq - b.seq })
                        if (exportMatchAndClassificationColumns.length > 0)
                            exportMatchAndClassificationColumns = exportMatchAndClassificationColumns.sort((a, b) => { return a.seq - b.seq })
                        if (exportMatchAndClassificationDirectConnectColumns.length > 0)
                            exportMatchAndClassificationDirectConnectColumns = exportMatchAndClassificationDirectConnectColumns.sort((a, b) => { return a.seq - b.seq })
                        if (exportCustomerViewColumns.length > 0)
                            exportCustomerViewColumns = exportCustomerViewColumns.sort((a, b) => { return a.seq - b.seq })
                        if (exportAllColumns.length > 0) {
                            exportAllColumns = exportAllColumns.sort((a, b) => { return a.seq - b.seq })
                        }
                        if (exportSccEnableInsightViewColumns.length > 0) {
                            exportSccEnableInsightViewColumns = exportSccEnableInsightViewColumns.sort((a, b) => { return a.seq - b.seq })
                        }
                        if (exportSccViewColumns.length > 0) {
                            exportSccViewColumns = exportSccViewColumns.sort((a, b) => { return a.seq - b.seq })
                        }


                        var finalRows = [];
                        var finalFilteredRows = [];
                        let isColumnEmpty = {}
                        for (let rowindex = 0; rowindex < this.state.finalSpendData.length; rowindex++) {
                            var row = { isCapIQLicesend: self.state.isCapIQLicesend, isUserDefinedRowUpdated: 'No' };
                            var combineVendorDetails = '';
                            var combineIndustryDetails = '';
                            for (let Cindex = 0; Cindex < finalColumn.length; Cindex++) {
                                const element = finalColumn[Cindex];

                                var item = element["key"]
                                var itemVal = this.state.finalSpendData[rowindex][item] === null ? '' : this.state.finalSpendData[rowindex][item];

                                isColumnEmpty[item] = isColumnEmpty[item] !== undefined ? isColumnEmpty[item] && itemVal === '' : itemVal === ''
                                row[item] = itemVal;
                            }
                            finalRows.push(row);
                        }

                        let emptyColumns = []

                        Object.keys(isColumnEmpty).forEach(key => {
                            if (isColumnEmpty[key] &&
                                selectedColumns.indexOf(key) === -1 &&
                                !(['EXCLUSION_REASON', 'OVERRIDE_INDUSTRY_ID', 'DIRECT_SPEND', 'USER_COMMENT'].includes(key))) {
                                emptyColumns.push(key)
                            }
                        })

                        for (const key of emptyColumns) {
                            let idx = defaultScreenColumns.findIndex(item => {
                                return item.key === key
                            })

                            if (idx !== -1) {
                                defaultScreenColumns.splice(idx, 1);
                            }

                            idx = colOptions.findIndex(item => {
                                return item.id === key
                            })

                            if (idx !== -1) {
                                colOptions[idx].isSelected = false;
                            }
                        }

                        //Create a summation row
                        let summationArray = this.sum(finalRows, defaultScreenColumns);
                        // if(this.props.spendDetails.kpi_Model == 1)
                        //     finalRows.sort((a, b) => { return b['AVATAR_WAVE_SCORE'] - a['AVATAR_WAVE_SCORE'] });
                        // else
                        //     finalRows.sort((a, b) => { return b['KPI_ENABLE_MATCH_SPD_DOC_SCORE'] - a['KPI_ENABLE_MATCH_SPD_DOC_SCORE'] });
                        // //finalRows.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })


                        // finalRows.sort((a, b) => { return a[sortBy] - b[sortBy] }) 
                        // finalFilteredRows = [...finalRows]

                        var gridSortBy = this.state.gridSortBy;
                        var gridSortDirection = this.state.gridSortDirection;
                        var comparer = this.downloadSortedRecords(gridSortBy, gridSortDirection);
                        finalRows = finalRows.sort((a, b) => { return a['REF_NUMBER'] - b['REF_NUMBER'] })
                        finalRows = gridSortDirection == 'NONE' ? finalRows : finalRows.sort(comparer);
                        finalFilteredRows = [...finalRows]

                        exportNonSensitiveColumns.sort((a, b) => {
                            var seq1 = isNaN(a.screenSeq) ? 9999 : a.screenSeq;
                            var seq2 = isNaN(b.screenSeq) ? 9999 : b.screenSeq;
                            return seq1 - seq2
                        })
                        exportEnablementInsightColumns.sort((a, b) => {
                            var seq1 = isNaN(a.screenSeq) ? 9999 : a.screenSeq;
                            var seq2 = isNaN(b.screenSeq) ? 9999 : b.screenSeq;
                            return seq1 - seq2
                        })
                        exportMatchAndClassificationColumns.sort((a, b) => {
                            var seq1 = isNaN(a.screenSeq) ? 9999 : a.screenSeq;
                            var seq2 = isNaN(b.screenSeq) ? 9999 : b.screenSeq;
                            return seq1 - seq2
                        })
                        exportMatchAndClassificationDirectConnectColumns.sort((a, b) => {
                            var seq1 = isNaN(a.screenSeq) ? 9999 : a.screenSeq;
                            var seq2 = isNaN(b.screenSeq) ? 9999 : b.screenSeq;
                            return seq1 - seq2
                        })
                        exportCustomerViewColumns.sort((a, b) => {
                            var seq1 = isNaN(a.screenSeq) ? 9999 : a.screenSeq;
                            var seq2 = isNaN(b.screenSeq) ? 9999 : b.screenSeq;
                            return seq1 - seq2
                        })
                        exportAllColumns.sort((a, b) => {
                            var seq1 = isNaN(a.screenSeq) ? 9999 : a.screenSeq;
                            var seq2 = isNaN(b.screenSeq) ? 9999 : b.screenSeq;
                            return seq1 - seq2
                        })
                        exportSccEnableInsightViewColumns.sort((a, b) => {
                            var seq1 = isNaN(a.screenSeq) ? 9999 : a.screenSeq;
                            var seq2 = isNaN(b.screenSeq) ? 9999 : b.screenSeq;
                            return seq1 - seq2
                        })
                        exportSccViewColumns.sort((a, b) => {
                            var seq1 = isNaN(a.screenSeq) ? 9999 : a.screenSeq;
                            var seq2 = isNaN(b.screenSeq) ? 9999 : b.screenSeq;
                            return seq1 - seq2
                        })


                        var pageCount = finalRows.length / this.state.perPage
                        this.originalColumns = cloneDeep(colOptions);

                        const headerToColumn = this.getHeaderGroups(defaultScreenColumns)

                        this.props.defineScopeLoading(false)

                        this.setState({
                            exportNonSensitiveColumns: exportNonSensitiveColumns, exportEnablementInsightColumns: exportEnablementInsightColumns, exportMatchAndClassificationColumns: exportMatchAndClassificationColumns, exportMatchAndClassificationDirectConnectColumns: exportMatchAndClassificationDirectConnectColumns, exportCustomerViewColumns: exportCustomerViewColumns, exportAllColumns: exportAllColumns, columns: colOptions, columnDefs: defaultScreenColumns,
                            exportSccEnableInsightViewColumns: exportSccEnableInsightViewColumns, exportSccViewColumns: exportSccViewColumns,
                            rowData: finalRows, filteredRows: finalFilteredRows, pageCount: pageCount, isError: 'No',
                            isLoading: false, summationArray: summationArray, filteredSummationArray: { ...summationArray },
                            userSelectedColumns: selectedColumns, finalColumn: finalColumn, headerToColumn: headerToColumn, userDefinedColumns: userDefinedColumns
                        }, selectedColumns.length == 0 ? this.onColumnSelection("ExternalEnablementInsightView") : null)// default load enablement insight view
                    }
                });
            }).catch((error) => {
                if (error.stack.includes('Network Error')) {
                    this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: 'API service is down. Please contact administrator.', isError: 'Yes', isLoading: false })
                }
                else {
                    this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false })
                }
            })
    }

    hideEmptyColumns() {
        let isColumnEmpty = {}
        const rowData = this.state.rowData;
        const columns = this.state.columns;
        const defaultScreenColumns = []

        for (let rowindex = 0; rowindex < rowData.length; rowindex++) {
            for (let Cindex = 0; Cindex < columns.length; Cindex++) {
                const element = columns[Cindex];

                var item = element["id"]
                var itemVal = rowData[rowindex][item]

                isColumnEmpty[item] = isColumnEmpty[item] !== undefined ? isColumnEmpty[item] && itemVal === '' : itemVal === ''
            }
        }

        let emptyColumns = []

        Object.keys(isColumnEmpty).forEach(key => {
            if (isColumnEmpty[key] &&
                !(['EXCLUSION_REASON', 'OVERRIDE_INDUSTRY_ID', 'DIRECT_SPEND', 'USER_COMMENT'].includes(key))) {
                emptyColumns.push(key)
            }
        })

        columns.forEach(item => {
            let idx = emptyColumns.findIndex(key => {
                return item.id === key
            })

            if (idx !== -1) {
                item.isSelected = false;
            } else {
                defaultScreenColumns.push(item.value)
                item.isSelected = true;
            }
        })

        this.originalColumns = cloneDeep(columns);

        return { columns: columns, defaultColumns: defaultScreenColumns }
    }

    sortFilteredRows = (filteredRows) => {
        if (!this.sortedColumns) {
            return filteredRows
        }

        var comparerAsc = (sortColumn) => (a, b) => {
            return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
        }

        var comparerDesc = (sortColumn) => (a, b) => {
            return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
        }

        this.sortedColumns.forEach((item) => {
            let sortColumn = item.key;
            let sortDirection = item.direction
            if (sortDirection === 'NONE') {
                return
            }

            var comparer = comparerAsc(sortColumn);
            if (sortDirection === 'DESC') {
                comparer = comparerDesc(sortColumn)
            }


            filteredRows.sort(comparer);
        })

        return filteredRows;
    };

    sortRows = (sortColumn, sortDirection) => {
        if (!this.sortedColumns) {
            this.sortedColumns = []
        }

        let rowIdx = this.sortedColumns.findIndex((item) => {
            return item.key === sortColumn
        })

        if (rowIdx !== -1) {
            this.sortedColumns.splice(rowIdx, 1);
        }

        this.sortedColumns.push({ key: sortColumn, direction: sortDirection })

        if (sortDirection === 'NONE') {
            return
        }

        var comparer = function (a, b) {
            if (sortDirection === 'ASC') {
                return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
            } else if (sortDirection === 'DESC') {
                return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
            }
        }


        var filteredRows = this.state.filteredRows;
        let firstRow = {}
        filteredRows = filteredRows.sort((a, b) => { return a['REF_NUMBER'] - b['REF_NUMBER'] });
        var rows = sortDirection === 'NONE' ? filteredRows : filteredRows.sort(comparer);

        var rowData = this.state.rowData;
        rowData = rowData.sort((a, b) => { return a['REF_NUMBER'] - b['REF_NUMBER'] });
        var originalRows = sortDirection === 'NONE' ? rowData : rowData.sort(comparer);

        this.sortColumn = sortColumn;
        var pageCount = rows.length / this.state.perPage
        this.setState({ filteredRows: [], rowData: [], gridSortBy: sortColumn, gridSortDirection: sortDirection }, () => this.setState({ filteredRows: rows, rowData: originalRows }))
    };

    downloadSortedRecords = (sortColumn, sortDirection) => {
        if (!this.sortedColumns) {
            this.sortedColumns = []
        }

        let rowIdx = this.sortedColumns.findIndex((item) => {
            return item.key === sortColumn
        })

        if (rowIdx !== -1) {
            this.sortedColumns.splice(rowIdx, 1);
        }

        this.sortedColumns.push({ key: sortColumn, direction: sortDirection })

        if (sortDirection === 'NONE') {
            return
        }

        var comparer = function (a, b) {
            if (sortDirection === 'ASC') {
                return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
            } else if (sortDirection === 'DESC') {
                return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
            }
        }

        return comparer;
    };

    handlePageClick = data => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.state.perPage);
        this.setState({ paginatedRowFrom: offset, paginatedRowTo: (offset + this.state.perPage) });
    };

    handleFilterChange(filter) {
        var rows = [...this.state.rowData];
        this.props.detailedFileFilterText(filter)
        let newFilters = { ...this.state.filters };
        if (filter === null || filter.filterTerm == null) {
            this.setState({ filters: null, filteredRows: rows }, this.getRows(rows, {}))
            return;

        } else if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
        } else {
            delete newFilters[filter.column.key];
        }

        this.props.detailedFileFilters(newFilters)
        this.setState({ filters: newFilters }, this.getRows(rows, newFilters))

        return newFilters;
    };

    getValidFilterValues(columnId) {
        var rows = this.state.rowData
        var isFilterVisible = this.state.isFilterVisible
        this.filteredColumnValues = this.filteredColumnValues ? this.filteredColumnValues : []
        if (this.filteredColumnValues[columnId] === undefined) {
            var rows_filter = [...new Set(rows.map(item => item[columnId] != null ? item[columnId] : ""))]
            rows_filter.splice(0, 0, 'Not Included')
            this.filteredColumnValues[columnId] = rows_filter
            return rows_filter
        } else {
            return this.filteredColumnValues[columnId]
        }
    }

    getRows(rows, filters, node) {
        let normalFilters = {}
        let globalFilters = {}
        for (const [key, value] of Object.entries(filters)) {
            if (value.type === 'global') {
                globalFilters[key] = value
                delete filters[key]
            }
        }

        let hasNormalFilters = Object.values(filters).length > 0
        let hasGlobalFilters = Object.values(globalFilters).length > 0

        let filteredRowsTemp = []
        //let globalFilters = Object.values(filters).filter(filter => filter.type === 'global')


        Object.values(globalFilters).forEach(filter => {
            filter.filteredRows.forEach(filteredRow => {
                let idx = filteredRowsTemp.findIndex(row => {
                    return row['DATA_COLLECTIONS_SKEY'] === filteredRow['DATA_COLLECTIONS_SKEY']
                })

                if (idx === -1) {
                    filteredRowsTemp.push(filteredRow)
                }
            })
        })

        let filteredRows = []
        if (hasNormalFilters && hasGlobalFilters) {
            rows = filteredRowsTemp
            filteredRows = selectors.getRows({ rows, filters })
        }
        else if (!hasNormalFilters && hasGlobalFilters)
            filteredRows = filteredRowsTemp
        else if (hasNormalFilters && !hasGlobalFilters)
            filteredRows = selectors.getRows({ rows, filters })
        else
            filteredRows = rows

        filteredRows = this.sortFilteredRows(filteredRows)
        var pageCount = filteredRows.length / this.state.perPage;
        //Summation row logic
        let sum = this.state.summationArray
        if (Object.keys(filters).length >= 1) {
            sum = this.sum(filteredRows)
        }

        for (const [key, value] of Object.entries(globalFilters)) {
            filters[key] = value
        }

        this.setState({ filteredSummationArray: sum, filteredRows: filteredRows, paginatedRowFrom: 0, paginatedRowTo: this.state.perPage, pageCount: pageCount, filters: filters });
    }

    exportCsvAllColumns() {
        var rowData = this.state.rowData;
        var sortBy = this.state.selectedSortBy;
        var self = this;

        let nonSensetiveKeys = this.state.exportNonSensitiveColumns.map(item => item.key);
        let enablementKeys = this.state.exportEnablementInsightColumns.map(item => item.key);
        let filteredCurrentView = this.state.columnDefs.filter(item => nonSensetiveKeys.includes(item.key) || enablementKeys.includes(item.key));

        const exportData = this.state.exportAction === 'currentViewColumns' ?
            filteredCurrentView : this.state.exportAction === 'customerViewColumns' ?
                this.state.exportCustomerViewColumns : this.state.exportAction === 'nonSensitiveColumns' ?
                    this.state.exportNonSensitiveColumns : this.state.exportAction === 'enablementInsightColumns' ?
                        this.state.exportEnablementInsightColumns : this.state.exportAction === 'matchAndClassificationColumns' ?
                            this.state.exportMatchAndClassificationColumns : this.state.exportAction === 'runDMCoutputColumns' ?
                            this.state.exportMatchAndClassificationColumns :this.state.exportAction === 'matchAndClassificationColumnsCSV' ?
                                this.state.exportMatchAndClassificationColumns : this.state.exportAction === 'matchAndClassificationDirectConnectColumns' ?
                                    this.state.exportMatchAndClassificationDirectConnectColumns : this.state.exportAction === 'matchAndClassificationDirectConnectColumnsCSV' ?
                                        this.state.exportMatchAndClassificationDirectConnectColumns : this.state.exportAction === 'customerViewColumnsCSV' ?
                                            this.state.exportCustomerViewColumns : this.state.exportAction === 'sccCustView' ?
                                                this.state.exportSccEnableInsightViewColumns : this.state.exportAction === 'sccCustViewCSV' ?
                                                    this.state.exportSccEnableInsightViewColumns : this.state.exportAction === 'sccView' ?
                                                        this.state.exportSccViewColumns : this.state.exportAction === 'sccEnableInsightView' ?
                                                            this.state.exportSccEnableInsightViewColumns : this.state.exportAllColumns;

        const fileName = this.state.exportAction === 'currentViewColumns' ?
            'Current View (Internal Only)' : this.state.exportAction === 'customerViewColumns' ?
                'Customer View' : this.state.exportAction === 'customerViewColumnsCSV' ?
                    'Customer View CSV' : this.state.exportAction === 'nonSensitiveColumns' ?
                        'Standard (Internal Only)' : this.state.exportAction === 'enablementInsightColumns' ?
                            'Enablement Insight' : this.state.exportAction === 'matchAndClassificationColumns' ?
                                'M&C Detail (Internal Only)' : this.state.exportAction === 'runDMCoutputColumns' ?
                                    'RunDMC Output (Internal Only)' : this.state.exportAction === 'matchAndClassificationColumnsCSV' ?
                                        'M&C Detail CSV (Internal Only)' : this.state.exportAction === 'matchAndClassificationDirectConnectColumns' ?
                                            'M&C Detail Direct Connect (Internal Only)' : this.state.exportAction === 'matchAndClassificationDirectConnectColumnsCSV' ?
                                                'M&C Detail Direct Connect CSV (Internal Only)' : this.state.exportAction === 'matchedOutputDemo' ?
                                                    'SE Match Output (AVATAR)' : this.state.exportAction === 'matchedOutputDemoSDMC' ?
                                                        'SE Match Output (SDMC)' : this.state.exportAction === 'matchedOutputDemoEnhanced' ?
                                                            'SE Match Output Enhanced' : this.state.exportAction === 'custFacingMatchedOutputDemo' ?
                                                                'Customer Facing SE Match Output (AVATAR)' : this.state.exportAction === 'custFacingMatchedOutputDemoSDMC' ?
                                                                    'Customer Facing SE Match Output (SDMC)' : this.state.exportAction === 'sccCustView' ?
                                                                        'Supply Chain Collaboration Customer View' : this.state.exportAction === 'sccCustViewCSV' ?
                                                                            'Supply Chain Collaboration Customer View CSV' : this.state.exportAction === 'sccView' ?
                                                                                'Supply Chain Collaboration View' : this.state.exportAction === 'sccEnableInsightView' ?
                                                                                    'Supply Chain Collaboration Enablement Insight View' : 'All';

        const csvRows = [];
        rowData.forEach((item) => {
            var row = {};
            exportData.forEach((cols) => {
                row[cols.key] = item[cols.key];
            });

            if (row["ENTERPRISE_ESTIM_SUPP_YIELD"] !== undefined && row["ENTERPRISE_ESTIM_SUPP_YIELD"] !== null && row["ENTERPRISE_ESTIM_SUPP_YIELD"] !== '')
                row["ENTERPRISE_ESTIM_SUPP_YIELD"] = row["ENTERPRISE_ESTIM_SUPP_YIELD"] + "%";

            csvRows.push(row);
        });

        var keys = exportData.map((cols) => cols.key);
        var headers = exportData.map((cols) => cols.label);

        const options = {
            filename: fileName,
            decimalSeparator: '.',
            showLabels: false,
            showTitle: false,
            useTextFile: false,
            keys: keys,
            headers: headers
        };

        const csvExporter = new ExportToCsv(options);

        var finalRows = [];
        let isColumnEmpty = {};
        let finalColumn = this.state.finalColumn;

        for (let rowindex = 0; rowindex < csvRows.length; rowindex++) {
            var row = { isCapIQLicesend: self.state.isCapIQLicesend };
            for (let Cindex = 0; Cindex < finalColumn.length; Cindex++) {
                const element = finalColumn[Cindex];
                var item = element["key"];
                var itemVal = csvRows[rowindex][item] === null ? '' : csvRows[rowindex][item];
                isColumnEmpty[item] = isColumnEmpty[item] !== undefined ? isColumnEmpty[item] && itemVal === '' : itemVal === '';
                row[item] = itemVal;
            }
            finalRows.push(row);
        }

        // 👉 Subtotal formula row
        const getExcelCol = (index) => {
            let dividend = index + 1, col = '';
            while (dividend > 0) {
                let modulo = (dividend - 1) % 26;
                col = String.fromCharCode(65 + modulo) + col;
                dividend = Math.floor((dividend - modulo) / 26);
            }
            return col;
        };

        let subtotalRow = {};
        exportData.forEach((col, idx) => {
            if (col.key === 'REF_NUMBER') {
                subtotalRow[col.key] = 'Totals';
            } else if (col.filter_type === 'NumericFilterRenderer') {
                const colLetter = getExcelCol(idx);
                subtotalRow[col.key] = `=SUBTOTAL(9,${colLetter}3:${colLetter}${finalRows.length + 2})`; // Data starts from row 3
            } else {
                subtotalRow[col.key] = '';
            }
        });

        // 👉 Header row
        let headerRow = {};
        Object.keys(finalRows[0] || {}).forEach(key => {
            const col = this.state.finalColumn.find(col => col.key === key);
            headerRow[key] = col ? col.name : key; // fallback to key if name is not found
        });

        // Step 2: Build header group row using finalColumn.headerGroup
        let headerGroupRow = {};
        Object.keys(finalRows[0] || {}).forEach(key => {
            const col = this.state.finalColumn.find(c => c.key === key);
            headerGroupRow[key] = col && col.headerGroup ? col.headerGroup : '';
        });

        // 👉 Inject subtotal at top, then header, then data
        finalRows.unshift(headerRow);
        finalRows.unshift(headerGroupRow);
        finalRows.unshift(subtotalRow);

        // Export
        this.insertReportAudit('Download - Spend', fileName + '.csv');
        csvExporter.generateCsv(finalRows);
        this.props.defineScopeLoading(false);
        this.hideModal('alert');
        this.setState({ isSaveInProgress: false, isLoading: false });
    }

    exportCsv() {
        var rowData = this.state.rowData;
        var sortBy = this.state.selectedSortBy;

        // rowData.sort((a, b) => { return a['REF_NUMBER'] - b['REF_NUMBER'] });
        // if (sortBy == 'ENABLEMENT_WAVE') {            
        //     rowData.sort(function (a, b) {
        //         return ('' + a[sortBy]).localeCompare(b[sortBy]);
        //     })
        // }
        // else
        //     rowData.sort((a, b) => { return a[sortBy] - b[sortBy] });

        // //rowData = this.downloadSortedRecords('REF_NUMBEFR','ASC',rowData);
        // var comparer = this.downloadSortedRecords(this.state.gridSortBy,this.state.gridSortDirection);
        // rowData = this.state.gridSortDirection == 'NONE'? rowData : rowData.sort(comparer);

        var self = this;

        let nonSensetiveKeys = this.state.exportNonSensitiveColumns.map(item => { return item.key; });
        let enablementKeys = this.state.exportEnablementInsightColumns.map(item => { return item.key; });
        let filteredCurrentView = this.state.columnDefs.filter(item => nonSensetiveKeys.includes(item.key) || enablementKeys.includes(item.key));

        const exportData = this.state.exportAction === 'currentViewColumns' ?
            filteredCurrentView : this.state.exportAction === 'customerViewColumns' ?
                this.state.exportCustomerViewColumns : this.state.exportAction === 'nonSensitiveColumns' ?
                    this.state.exportNonSensitiveColumns : this.state.exportAction === 'enablementInsightColumns' ?
                        this.state.exportEnablementInsightColumns : this.state.exportAction === 'matchAndClassificationColumns' ?
                            this.state.exportMatchAndClassificationColumns : this.state.exportAction === 'runDMCoutputColumns' ?
                                this.state.exportMatchAndClassificationColumns : this.state.exportAction === 'matchAndClassificationColumnsCSV' ?
                                    this.state.exportMatchAndClassificationColumns : this.state.exportAction === 'matchAndClassificationDirectConnectColumns' ?
                                        this.state.exportMatchAndClassificationDirectConnectColumns : this.state.exportAction === 'matchAndClassificationDirectConnectColumnsCSV' ?
                                            this.state.exportMatchAndClassificationDirectConnectColumns : this.state.exportAction === 'customerViewColumnsCSV' ?
                                                this.state.exportCustomerViewColumns : this.state.exportAction === 'sccCustView' ?
                                                    this.state.exportSccEnableInsightViewColumns : this.state.exportAction === 'sccCustViewCSV' ?
                                                        this.state.exportSccEnableInsightViewColumns : this.state.exportAction === 'sccView' ?
                                                            this.state.exportSccViewColumns : this.state.exportAction === 'sccEnableInsightView' ?
                                                                this.state.exportSccEnableInsightViewColumns : this.state.exportAllColumns;

        // //add file name to sheet
        const fileName = this.state.exportAction === 'currentViewColumns' ?
            'Current View (Internal Only)' : this.state.exportAction === 'customerViewColumns' ?
                'Customer View' : this.state.exportAction === 'customerViewColumnsCSV' ?
                    'Customer View CSV' : this.state.exportAction === 'nonSensitiveColumns' ?
                        'Standard (Internal Only)' : this.state.exportAction === 'enablementInsightColumns' ?
                            'Enablement Insight' : this.state.exportAction === 'matchAndClassificationColumns' ?
                                'M&C Detail (Internal Only)' : this.state.exportAction === 'runDMCoutputColumns' ?
                                    'RunDMC Output (Internal Only)' : this.state.exportAction === 'matchAndClassificationColumnsCSV' ?
                                        'M&C Detail CSV (Internal Only)' : this.state.exportAction === 'matchAndClassificationDirectConnectColumns' ?
                                            'M&C Detail Direct Connect (Internal Only)' : this.state.exportAction === 'matchAndClassificationDirectConnectColumnsCSV' ?
                                                'M&C Detail Direct Connect CSV (Internal Only)' : this.state.exportAction === 'matchedOutputDemo' ?
                                                    'SE Match Output' : this.state.exportAction === 'matchedOutputDemoSDMC' ?
                                                        'SE Match Output Original' : this.state.exportAction === 'matchedOutputDemoEnhanced' ?
                                                            'SE Match Output Enhanced' : this.state.exportAction === 'custFacingMatchedOutputDemo' ?
                                                                'Customer Facing SE Match Output' : this.state.exportAction === 'sccCustView' ?
                                                                    'Supply Chain Collaboration Customer View' : this.state.exportAction === 'sccCustViewCSV' ?
                                                                        'Supply Chain Collaboration Customer View CSV' : this.state.exportAction === 'sccView' ?
                                                                            'Supply Chain Collaboration View' : this.state.exportAction === 'sccEnableInsightView' ?
                                                                            'Supply Chain Collaboration Enablement Insight View' : 'All';

        const csvRows = [];
        rowData.forEach((item) => {
            var row = {}
            exportData.forEach((cols) => {
                row[cols.key] = item[cols.key]
            })

            if (row["ENTERPRISE_ESTIM_SUPP_YIELD"] !== undefined && row["ENTERPRISE_ESTIM_SUPP_YIELD"] !== null && row["ENTERPRISE_ESTIM_SUPP_YIELD"] !== '')
                row["ENTERPRISE_ESTIM_SUPP_YIELD"] = row["ENTERPRISE_ESTIM_SUPP_YIELD"] + "%"

            csvRows.push(row);
        })

        var keys = exportData.map((cols) => {
            return cols.key
        })

        var headers = exportData.map((cols) => {
            return cols.label
        })

        const options = {
            filename: fileName,
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            useTextFile: false,
            keys: keys,
            headers: headers
        };

        const csvExporter = new ExportToCsv(options);

        var finalRows = [];
        var finalFilteredRows = [];
        let isColumnEmpty = {}
        let finalColumn = this.state.finalColumn;
        for (let rowindex = 0; rowindex < csvRows.length; rowindex++) {
            var row = { isCapIQLicesend: self.state.isCapIQLicesend };
            var combineVendorDetails = '';
            var combineIndustryDetails = '';
            for (let Cindex = 0; Cindex < finalColumn.length; Cindex++) {
                const element = finalColumn[Cindex];

                var item = element["key"]
                var itemVal = csvRows[rowindex][item] === null ? '' : csvRows[rowindex][item];

                isColumnEmpty[item] = isColumnEmpty[item] !== undefined ? isColumnEmpty[item] && itemVal === '' : itemVal === ''
                row[item] = itemVal;
            }
            finalRows.push(row);
        }
        this.insertReportAudit('Download - Spend', fileName + '.csv');
        csvExporter.generateCsv(finalRows);
        this.props.defineScopeLoading(false);
        this.hideModal('alert');
        // if (self.props.user.userprofile.Roles[0].indexOf("Export All_Spend Details") > -1)
        //     this.hideModal('alert');        
        this.setState({ isSaveInProgress: false, isLoading: false });
    }

    initializeColumns(data) {
        let columns = []
        for (let index = 0; index < data.length; index++) {
            const fieldConfig = data[index];
            const editableColumns = ExcelUploadColumns.filter(x => {
                return x.field == fieldConfig.key
            });
            var is_editable = editableColumns.length > 0 ? editableColumns[0].is_editable : "No";

            let tableColumn = {
                header: fieldConfig.label,
                key: fieldConfig.key,
                width: fieldConfig.width,
                sortable: fieldConfig.sortable,
                editable: is_editable,
                isNumeric: false,
                // isTextWithLengtLimit : fieldConfig.data_type === 'text' && (!!fieldConfig.textLength),
                // textLength : fieldConfig.textLength,
                screenSeq: fieldConfig.screen_seq,
                mandatory: fieldConfig.mandatory === 'Yes',
                // exportFl: fieldConfig.export_fl === 'Y',
                editProperty: fieldConfig.editable,
                helpText: fieldConfig.helpText,
            }
            columns.push(tableColumn)
        }

        return columns;
    }

    // commonDownload() {
    //     if (this.state.exportAction === 'matchedOutputDemoEnhanced' || this.state.exportAction === 'custFacingMatchedOutputDemo' || this.state.exportAction === 'matchedOutputDemo')
    //         this.ndlDownload();
    //     else if (this.state.exportAction === 'vuf') {
    //         this.hideModal('alert');
    //         this.showModal('vufModal');
    //     }
    //     else
    //         this.handleClick();
    // }

    // handleClick() {
    //     // var excelButton = document.getElementsByClassName("button--accent")[0].parentNode;
    //     // excelButton.style.display = 'none';        
    //     this.setState({ isLoading: true }, this.forceUpdate);

    //     setTimeout(() => {
    //         //this.exportExcel()
    //         if (this.state.exportAction === 'matchAndClassificationColumnsCSV' || this.state.exportAction === 'matchAndClassificationDirectConnectColumnsCSV' || this.state.exportAction === 'customerViewColumnsCSV' || this.state.exportAction === 'sccCustViewCSV')
    //             this.exportCsv();
    //         else if (this.state.exportAction === 'allColumns')
    //             this.exportCsvAllColumns();
    //         else if (this.state.exportAction === 'runDMCoutputColumns'
    //             || this.state.exportAction === 'matchedOutputDemo' 
    //                 || this.state.exportAction === 'custFacingMatchedOutputDemo' 
    //                 || this.state.exportAction === 'matchedOutputDemoEnhanced'
    //         )
    //         {
    //             var request = { DMCID: this.props.spendDetails.currentActiveRequest.DMC_ID, VSID: this.props.spendDetails.currentActiveRequest.VS_ID, Email: this.props.user.user.Email, FileName:this.state.exportAction }

	// 			this.props.RunDmcDownloadSummary(request).then((result) => {
	// 				if (result.status === 200) {
    //                     this.setState({ dmcSummaryData: result.data.Result }, () => {
    //                         this.exportExcel();
    //                     });
    //                 }
    //             });
    //         }
    //         else
    //             this.exportExcel()
    //     }, 2000);
    //     //this.exportExcel()
    // }

    commonDownload = () => {
        if (
          this.state.exportAction === 'matchedOutputDemoEnhanced' ||
          this.state.exportAction === 'custFacingMatchedOutputDemo' ||
          this.state.exportAction === 'matchedOutputDemo' ||
          this.state.exportAction === 'matchedOutputDemoSDMC' ||
          this.state.exportAction === 'custFacingMatchedOutputDemoSDMC'
        ) {
          this.ndlDownload();
        } else if (this.state.exportAction === 'vuf' || this.state.exportAction === 'vufEnhanced') {
            this.props.defineScopeLoading(false);
          this.hideModal('alert');
          this.showModal('vufModal');
        } else {
          this.handleClick();
        }
      };

      handleClick = () => {
        this.setState({ isLoading: true });
    
        //setTimeout(() => {
            if (
                this.state.exportAction === 'matchAndClassificationColumnsCSV' ||
                this.state.exportAction === 'matchAndClassificationDirectConnectColumnsCSV' ||
                this.state.exportAction === 'customerViewColumnsCSV' ||
                this.state.exportAction === 'sccCustViewCSV'
            ) {
                this.exportCsv();
            } 
            else if (this.state.exportAction === 'allColumns') {
                this.exportCsvAllColumns();
            } 
            else if (
                this.state.exportAction === 'runDMCoutputColumns' ||
                this.state.exportAction === 'matchedOutputDemo' ||
                this.state.exportAction === 'custFacingMatchedOutputDemo' ||
                this.state.exportAction === 'matchedOutputDemoEnhanced' ||
                this.state.exportAction === 'matchedOutputDemoSDMC' ||
                this.state.exportAction === 'custFacingMatchedOutputDemoSDMC'
            ) {
    
                const request = {
                    DMCID: this.props.spendDetails.currentActiveRequest.DMC_ID,
                    VSID: this.props.spendDetails.currentActiveRequest.VS_ID,
                    Email: this.props.user.user.Email,
                    FileName: this.state.exportAction
                };
    
                this.props.RunDmcDownloadSummary(request).then((result) => {
                    if (result.status === 200) {
                        this.setState({ dmcSummaryData: result.data.Result }, () => {
                            this.exportExcel();
                        });
                    }
                });
            } 
            else {
                this.exportExcel();
            }
        ///}, 2000);
    };
    
    

    createDynamicWorkSheet(workSheetName, Columns, workbook, rowData, firstRowLabel) {
        let dynamicWorksheet = workbook.addWorksheet(workSheetName);
        let exportData = Columns;
        const columnDetails = this.initializeColumns(exportData);
        dynamicWorksheet.columns = columnDetails;

        dynamicWorksheet.spliceRows(1, 0, []);
        dynamicWorksheet.spliceRows(1, 0, []);
        dynamicWorksheet.spliceRows(1, 0, []);

        let rowDataNew;
        if (workSheetName === "Parent Account Info") {
            rowDataNew = rowData.filter(o => o.DEDUP_KEY.toLowerCase().includes('dedup'));
            rowDataNew.sort((a, b) => a['DEDUP_KEY'].toLowerCase() < b['DEDUP_KEY'].toLowerCase() ? -1 : 1);
        }
        else
            rowDataNew = rowData;

        rowDataNew.forEach((row, rowIndex) => {
            dynamicWorksheet.addRow(row);
            if (exportData.length > 0) {
                exportData.forEach((key, colIndex) => {
                    //console.log("key : " + key + " - value : " + row[key]);
                    if (exportData[colIndex].key != 'REF_NUMBER' && exportData[colIndex].filter_type == 'NumericFilterRenderer') {
                        var formatter = this.excelformatter(exportData[colIndex].alignment);
                        dynamicWorksheet.getRow(rowIndex + 5).getCell(colIndex + 1).numFmt = formatter;
                    }
                    var textFormatter = this.excelTextFormatter(exportData[colIndex].alignment);
                    dynamicWorksheet.getRow(rowIndex + 5).getCell(colIndex + 1).alignment = {
                        horizontal: textFormatter,
                    }
                });
            }
        });

        dynamicWorksheet.getRow(1).values = [firstRowLabel];

        const nonEditableHeader = columnDetails.filter(i => i.editable == "No")
        const editableHeader = columnDetails.filter(i => i.editable == "Yes")

        dynamicWorksheet.columns.forEach((column, index) => {
            // //Set Column Width
            // const lengths = column.values.map(v => v.toString().length);
            // const maxLength = Math.max(...lengths.filter(v => typeof v === 'number'));
            //column.width = maxLength + 4;
            column.width = 25
        });

        nonEditableHeader.map(item => {
            dynamicWorksheet.getRow(4).getCell(item.key).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '0B64A0' }
            };
            dynamicWorksheet.getRow(4).getCell(item.key).font = {
                name: 'BentonSans Book',
                size: 9,
                color: { argb: 'FFFFFF' },
                bold: true,
            };

            for (var rowNo = 3; rowNo <= 4; rowNo++) {
                dynamicWorksheet.getRow(rowNo).getCell(item.key).border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });

        const textColor = (this.state.exportAction === 'enablementInsightColumns' ||
            this.state.exportAction === 'customerViewColumns') ?
            'FFFFFF' : 'e9ff21';

        editableHeader.map(item => {
            dynamicWorksheet.getRow(4).getCell(item.key).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '0B64A0' }
            };
            dynamicWorksheet.getRow(4).getCell(item.key).font = {
                name: 'BentonSans Book',
                size: 9,
                color: { argb: textColor },
                bold: true,
            };

            for (var rowNo = 3; rowNo <= 4; rowNo++) {
                dynamicWorksheet.getRow(rowNo).getCell(item.key).border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        }
        );
    }

    copyExcelWorkSheet(sheetNumber, sourceWorkBook, targetWorkBook, sheetName) {

        let sheetToClone = sourceWorkBook.getWorksheet(sheetNumber);
        let copySheet = targetWorkBook.addWorksheet("Sheet");
        copySheet.model = sheetToClone.model;
        if (sheetName == '')
            copySheet.name = sheetToClone.name;
        else
            copySheet.name = sheetName
    };

    async exportExcel() {
        // this.setState({ isLoading: true });
        //const rowData1 = this.state.rowData;        
        var downloadType = 'Spend';
        var rowData1 = [];
        var sortBy = this.state.selectedSortBy;
        if (this.state.exportAction === 'matchedOutputDemo' || this.state.exportAction === 'matchedOutputDemoSDMC' || this.state.exportAction === 'custFacingMatchedOutputDemo' || this.state.exportAction === 'custFacingMatchedOutputDemoSDMC' || this.state.exportAction === 'matchedOutputDemoEnhanced') {
            rowData1 = this.state.ndlData;
            downloadType = 'NDL';
        }
        else
            rowData1 = this.state.rowData;

        // rowData1.sort((a, b) => { return a['REF_NUMBER'] - b['REF_NUMBER'] });
        // if (sortBy == 'ENABLEMENT_WAVE') {            
        //     rowData1.sort(function (a, b) {
        //         return ('' + a[sortBy]).localeCompare(b[sortBy]);
        //     })
        // }
        // else
        //     rowData1.sort((a, b) => { return a[sortBy] - b[sortBy] });

        // //rowData1 = this.downloadSortedRecords('REF_NUMBEFR','ASC',rowData1);
        // rowData1 = this.downloadSortedRecords(this.state.gridSortBy,this.state.gridSortDirection,rowData1);

        
        // Add Extra Rows Start
        // const repeatedRecords = rowData1.slice(0, 25000);
        //     // Append them to the original 55k
        // rowData1 = rowData1.concat(repeatedRecords)
        // Add Extra Rows End

        //const rowData = JSON.parse(JSON.stringify(rowData1));
        const rowData = cloneDeep(rowData1);
        var self = this;

        let nonSensetiveKeys = this.state.exportNonSensitiveColumns.map(item => { return item.key; });
        let enablementKeys = this.state.exportEnablementInsightColumns.map(item => { return item.key; });
        //let filteredCurrentView = this.state.columnDefs.filter(item => nonSensetiveKeys.includes(item.key) || enablementKeys.includes(item.key));
        let filteredCurrentView = this.state.columnDefs;

        const exportData = this.state.exportAction === 'currentViewColumns' ?
            filteredCurrentView : this.state.exportAction === 'customerViewColumns' ?
                this.state.exportCustomerViewColumns : this.state.exportAction === 'nonSensitiveColumns' ?
                    this.state.exportNonSensitiveColumns : this.state.exportAction === 'enablementInsightColumns' ?
                        this.state.exportEnablementInsightColumns : this.state.exportAction === 'matchAndClassificationColumns' ?
                            this.state.exportMatchAndClassificationColumns : this.state.exportAction === 'runDMCoutputColumns' ?
                                this.state.exportMatchAndClassificationColumns : this.state.exportAction === 'matchAndClassificationDirectConnectColumns' ?
                                    this.state.exportMatchAndClassificationDirectConnectColumns : this.state.exportAction === 'matchedOutputDemo' ?
                                        this.state.ndlColumns : this.state.exportAction === 'matchedOutputDemoSDMC' ?
                                            this.state.ndlColumns : this.state.exportAction === 'matchedOutputDemoEnhanced' ?
                                                this.state.ndlColumnsMatchOutputEnhanced : this.state.exportAction === 'sccCustView' ?
                                                    this.state.exportSccEnableInsightViewColumns : this.state.exportAction === 'sccCustViewCSV' ?
                                                        this.state.exportSccEnableInsightViewColumns : this.state.exportAction === 'sccView' ?
                                                            this.state.exportSccViewColumns : this.state.exportAction === 'sccEnableInsightView' ?
                                                                this.state.exportSccEnableInsightViewColumns : this.state.exportAllColumns;


        var headers = exportData.map((cols) => {
            return { label: cols.label , helpText: cols.helpText }
        })

        this.setState({ responseMsg: "" })
        //create new excel work book

        // //add name to sheet
        const workSheetName = this.state.exportAction === 'currentViewColumns' ?
            'Current View' : this.state.exportAction === 'customerViewColumns' ?
                'Customer View' : this.state.exportAction === 'nonSensitiveColumns' ?
                    'Standard' : this.state.exportAction === 'enablementInsightColumns' ?
                        'Enablement Insight' : this.state.exportAction === 'matchAndClassificationColumns' ?
                            'M&C Detail' : this.state.exportAction === 'runDMCoutputColumns' ?
                                'M&C Detail' : this.state.exportAction === 'matchAndClassificationDirectConnectColumns' ?
                                    'M&C Detail Direct Connect' : this.state.exportAction === 'matchedOutputDemo' ?
                                        'Match Output' : this.state.exportAction === 'matchedOutputDemoSDMC' ?
                                            'Match Output' : this.state.exportAction === 'matchedOutputDemoEnhanced' ?
                                                'Match Output' : this.state.exportAction === 'sccCustView' ?
                                                    'Supply Chain Collaboration Customer View' : this.state.exportAction === 'sccCustViewCSV' ?
                                                        'Supply Chain Collaboration Customer View CSV' : this.state.exportAction === 'sccView' ?
                                                            'Supply Chain Collaboration View' : this.state.exportAction === 'sccEnableInsightView' ?
                                                                'Supply Chain Collaboration Enablement Insight View' : 'All';

        // //add file name to sheet
        const fileName = this.state.exportAction === 'currentViewColumns' ?
            'Current View (Internal Only)' : this.state.exportAction === 'customerViewColumns' ?
                'Customer View' : this.state.exportAction === 'customerViewColumnsCSV' ?
                    'Customer View CSV' : this.state.exportAction === 'nonSensitiveColumns' ?
                        'Standard (Internal Only)' : this.state.exportAction === 'enablementInsightColumns' ?
                            'Enablement Insight' : this.state.exportAction === 'matchAndClassificationColumns' ?
                                'M&C Detail (Internal Only)' : this.state.exportAction === 'runDMCoutputColumns' ?
                                    'RunDMC Output (Internal Only)' : this.state.exportAction === 'matchAndClassificationColumnsCSV' ?
                                        'M&C Detail CSV (Internal Only)' : this.state.exportAction === 'matchAndClassificationDirectConnectColumns' ?
                                            'M&C Detail Direct Connect (Internal Only)' : this.state.exportAction === 'matchAndClassificationDirectConnectColumnsCSV' ?
                                                'M&C Detail Direct Connect CSV (Internal Only)' : this.state.exportAction === 'matchedOutputDemo' ?
                                                    'SE Match Output (AVATAR)' : this.state.exportAction === 'matchedOutputDemoSDMC' ?
                                                        'SE Match Output (SDMC)' : this.state.exportAction === 'custFacingMatchedOutputDemo' ?
                                                            'Customer Facing SE Match Output (AVATAR)' : this.state.exportAction === 'custFacingMatchedOutputDemoSDMC' ?
                                                                'Customer Facing SE Match Output (SDMC)' : this.state.exportAction === 'matchedOutputDemoEnhanced' ?
                                                                    'SE Match Output Enhanced' : this.state.exportAction === 'sccCustView' ?
                                                                        'Supply Chain Collaboration Customer View' : this.state.exportAction === 'sccCustViewCSV' ?
                                                                            'Supply Chain Collaboration Customer View CSV' : this.state.exportAction === 'sccView' ?
                                                                                'Supply Chain Collaboration View' : this.state.exportAction === 'sccEnableInsightView' ?
                                                                                    'Supply Chain Collaboration Enablement Insight View' : 'All';

        // Split into chunks
        const chunkSize = parseInt(this.state.chunkSize);
        const chunks = [];
        for (let i = 0; i < rowData.length; i += chunkSize) {
            chunks.push(rowData.slice(i, i + chunkSize));
        }

        const templateBuffer = await axios.get(path + 'Sample_SE_Match_Output.xlsx', { responseType: 'arraybuffer' })
            .then(res => res.data);
        const workbook1 = await new Workbook().xlsx.load(templateBuffer);

       

        //---------------------Copy Worksheet From Template---------------------        
        // axios.get(path + 'Sample_SE_Match_Output.xlsx', { responseType: 'arraybuffer' })
        //     .then(response => {
        //         const buffer = response.data;
        //         const workbook1 = new Workbook();
        //         return workbook1.xlsx.load(buffer);
        //     })
        //     .then(workbook1 => {
            const exportChunk = async (chunk, idx) => {
                let workbook = new Workbook();

                
                // ---- CREATE READ ME WORKSHEET (TABLE FORMAT) ----
                if (
                    this.state.exportAction !== 'matchedOutputDemo' &&
                    this.state.exportAction !== 'custFacingMatchedOutputDemo' &&
                    this.state.exportAction !== 'matchedOutputDemoEnhanced' &&
                    this.state.exportAction !== 'matchedOutputDemoSDMC' &&
                    this.state.exportAction !== 'custFacingMatchedOutputDemoSDMC'
                ) {
                    const readMeSheet = workbook.addWorksheet('READ ME');

                    // Header row
                    readMeSheet.getRow(3).values = ['Sort', 'Column', 'Headers', 'Definition'];

                    readMeSheet.getRow(3).font = {
                        name: 'BentonSans Book',
                        size: 10,
                        bold: true
                    };

                    readMeSheet.getRow(3).alignment = { horizontal: 'center' };

                    // Column widths
                    readMeSheet.getColumn(1).width = 10; // Sort
                    readMeSheet.getColumn(2).width = 12; // Column
                    readMeSheet.getColumn(3).width = 40; // Headers
                    readMeSheet.getColumn(4).width = 80; // Definition

                    // Populate rows
                    headers.forEach((header, index) => {
                        const rowIndex = index + 4;
                    
                        readMeSheet.getCell(`A${rowIndex}`).value = index + 1;
                        readMeSheet.getCell(`B${rowIndex}`).value = this.getExcelColumnName(index + 1);
                        readMeSheet.getCell(`C${rowIndex}`).value = header.label;
                        readMeSheet.getCell(`D${rowIndex}`).value = header.helpText;
                    
                        readMeSheet.getRow(rowIndex).font = {
                            name: 'Calibri',
                            size: 11
                        };
                    
                        // 👉 WORD WRAP for Definition column
                        readMeSheet.getCell(`D${rowIndex}`).alignment = {
                            wrapText: true,
                            vertical: 'top'
                        };
                    });

                    // Style header row background
                    ['A3', 'B3', 'C3', 'D3'].forEach(cell => {
                        readMeSheet.getCell(cell).fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'D9E1F2' }
                        };
                        readMeSheet.getCell(cell).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    });

                    // Add borders to data rows
                    headers.forEach((_, index) => {
                        const r = index + 4;
                        ['A', 'B', 'C', 'D'].forEach(col => {
                            readMeSheet.getCell(`${col}${r}`).border = {
                                top: { style: 'thin' },
                                left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                right: { style: 'thin' }
                            };
                        });
                    });
                }

                let worksheet = workbook.addWorksheet(workSheetName);

                if (this.state.exportAction === 'runDMCoutputColumns') {
                    this.addRunDMCSummarySheet(workbook);
                }

                // let sheetToClone = workbook1.getWorksheet(4);
                // let copySheet = workbook.addWorksheet("Sheet");
                // copySheet.model = sheetToClone.model;
                // copySheet.name = sheetToClone.name;
                if (this.state.exportAction === 'matchedOutputDemo' || this.state.exportAction === 'matchedOutputDemoSDMC' || this.state.exportAction === 'matchedOutputDemoEnhanced') {
                    this.copyExcelWorkSheet(1, workbook1, workbook, '');
                    this.copyExcelWorkSheet(2, workbook1, workbook, '');
                }

                const columnDetails = this.initializeColumns(exportData);
                worksheet.columns = columnDetails;

                // for (const headerRow of exportData) {
                //     worksheet.addRow(headerRow.label);
                // }

                //    let summationArray = this.sum(rowData);
                //    worksheet.addRow(summationArray);
                worksheet.spliceRows(1, 0, []);
                worksheet.spliceRows(1, 0, []);
                worksheet.spliceRows(1, 0, []);

                let summationArrayKeys = ['AGGREGATE_INVOICE_COUNT', 'AGGREGATE_INVOICE_SPEND', 'AGGREGATE_PO_COUNT', 'AGGREGATE_PO_SPEND', 'AGREEGATE_PAYMENT_COUNT',
                    'ERP_INVOICE_COUNT', 'ERP_PO_COUNT', 'PAYMENT_COUNT', "SAP_ARIBA_DOC_PROXY", "SAP_ARIBA_SPEND_PROXY", "SAP_ARIBA_SPEND_PROXY_USD", "AN_SMP_FEE_EST_BUYER_CURR", "ERP_INV_SPEND_IN_STD_CURR", "ENTERPRISE_ESTIM_SUPP_YIELD", "ENTERPRISE_ESTIM_SPEND_YIELD", "ENTERPRISE_ESTIM_DOC_YIELD", "ERP_DOCUMENT_CNT", "ERP_SPEND", "ESTI_CAPTURABLE_NET_TRNS_FEE_REVENUE"]


                chunk.forEach((row, rowIndex) => {
                    worksheet.addRow(row);

                    if (exportData.length > 0) {
                        exportData.forEach((key, colIndex) => {
                            //console.log("key : " + key + " - value : " + row[key]);
                            if (exportData[colIndex].key != 'REF_NUMBER' && exportData[colIndex].filter_type == 'NumericFilterRenderer') {
                                var formatter = this.excelformatter(exportData[colIndex].alignment);
                                worksheet.getRow(rowIndex + 5).getCell(colIndex + 1).numFmt = formatter;
                            }
                            var textFormatter = this.excelTextFormatter(exportData[colIndex].alignment);
                            worksheet.getRow(rowIndex + 5).getCell(colIndex + 1).alignment = {
                                horizontal: textFormatter,
                            }
                        });
                    }
                });               


                if (this.state.exportAction != 'matchedOutputDemo' && this.state.exportAction != 'matchedOutputDemoSDMC' && this.state.exportAction != 'custFacingMatchedOutputDemo' && this.state.exportAction != 'custFacingMatchedOutputDemoSDMC' && this.state.exportAction != 'matchedOutputDemoEnhanced') {
                    var headerRowMergeRowStart = 1;
                    var headerValue = '';
                    var printHeader = true;
                    var lastColumnHeaderValue = this.state.finalColumn.filter(item => item.key == exportData[exportData.length - 1].key)[0].headerGroup;
                    //var lastColumnHeaderValue = exportData[exportData.length-1].headerGroup;


                    exportData.forEach((key, index) => {
                        //Add header and merge header row.
                        //headerValue = exportData[index].headerGroup;
                        headerValue = self.state.finalColumn.filter(item => item.key == exportData[index].key)[0].headerGroup;
                        if (index == 0 && printHeader)                                                  // First Header
                            worksheet.getRow(3).getCell(index + 1).value = headerValue;
                        else if (headerValue != self.state.finalColumn.filter(item => item.key == exportData[index - 1].key)[0].headerGroup && printHeader) {
                            worksheet.getRow(3).getCell(index + 1).value = headerValue;
                            worksheet.mergeCells(3, headerRowMergeRowStart, 3, index);
                            headerRowMergeRowStart = index + 1;
                        }
                        else if (lastColumnHeaderValue == headerValue && printHeader)  // Last Header
                        {
                            worksheet.mergeCells(3, headerRowMergeRowStart, 3, exportData.length);
                            printHeader = false;
                        }
                        //--------------------------------


                        let colName = this.getExcelColumnName(index + 1);
                        if (exportData[index].key != 'REF_NUMBER' && summationArrayKeys.includes(exportData[index].key) && exportData[index].filter_type == 'NumericFilterRenderer') {
                            //worksheet.getCell(colName + '2').value = { formula: 'SUM(' + colName + '5:' + colName + '100000)' };
                            worksheet.getCell(colName + '2').value = { formula: 'SUBTOTAL(9,' + colName + '5:' + colName + '100000)' };

                            var formatter = this.excelformatter(exportData[index].alignment);
                            worksheet.getRow(2).getCell(index + 1).numFmt = formatter;
                            var textFormatter = this.excelTextFormatter(exportData[index].alignment);
                            worksheet.getRow(2).getCell(index + 1).alignment = {
                                horizontal: textFormatter,
                            }
                        }
                        else if (exportData[index].key == 'REF_NUMBER') {
                            worksheet.getCell(colName + '2').value = 'Totals';
                        }

                    });
                }
                let fname = fileName; //'spend' ;//this.props.content.uploadTemplateFile

                let nonEditableHeader = columnDetails.filter(i => i.editable == "No")
                let editableHeader = columnDetails.filter(i => i.editable == "Yes")

                if (this.state.exportAction === 'matchedOutputDemo' || this.state.exportAction === 'matchedOutputDemoSDMC' || this.state.exportAction === 'custFacingMatchedOutputDemo' || this.state.exportAction === 'custFacingMatchedOutputDemoSDMC' || this.state.exportAction === 'matchedOutputDemoEnhanced') {

                    nonEditableHeader = columnDetails;
                    editableHeader = [];
                }

                const FIXED_COLUMN_WIDTH = 20;
                worksheet.columns.forEach((column, index) => {

                    //Set Column Width
                    // const lengths = column.values.map(v => v.toString().length);
                    // const maxLength = Math.max(...lengths.filter(v => typeof v === 'number'));
                    column.width = FIXED_COLUMN_WIDTH


                    //Set Font and Colour
                    worksheet.getRow(1).getCell(index + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFFF' },
                    };
                    worksheet.getRow(1).getCell(index + 1).font = {
                        name: 'Calibri',
                        size: 11,
                        color: { argb: '000000' },
                        bold: true
                    };


                    if (this.state.exportAction != 'matchedOutputDemo' && this.state.exportAction != 'matchedOutputDemoSDMC' && this.state.exportAction != 'custFacingMatchedOutputDemo' && this.state.exportAction != 'custFacingMatchedOutputDemoSDMC' && this.state.exportAction != 'matchedOutputDemoEnhanced') {
                        worksheet.getRow(2).getCell(index + 1).fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'D9E1F2' }
                        };
                        worksheet.getRow(2).getCell(index + 1).font = {
                            name: 'Calibri',
                            size: 10,
                            color: { argb: '000000' },
                            bold: true,
                        };

                        worksheet.getRow(3).getCell(index + 1).fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: '8EA9DB' }
                        };
                        worksheet.getRow(3).getCell(index + 1).font = {
                            name: 'Calibri',
                            size: 10,
                            color: { argb: 'FFFFFF' },
                            bold: true,
                        };
                    }
                });

                //let summationArray = this.sum(rowData);
                ////worksheet.getRow(2).values = summationArray; 

                const currentRowIdx = worksheet.rowCount; // Find out how many rows are there currently
                const endColumnIdx = worksheet.columnCount; // Find out how many columns are in the worksheet 


                if (this.state.exportAction === 'matchedOutputDemo' || this.state.exportAction === 'matchedOutputDemoSDMC' || this.state.exportAction === 'matchedOutputDemoEnhanced')
                    worksheet.getRow(1).values = ["Some information in this sheet is Internal Only.  Share only the Customer Facing Template tab with external users."];
                else if (this.state.exportAction != 'customerViewColumns')
                    worksheet.getRow(1).values = ["The data contained in this file is for internal use only. Do not distribute outside of SAP/Ariba."];
                // merge by start row, start column, end row, end column
                //worksheet.mergeCells(1, 1, 1, 10);

                // worksheet.getRow(3).values = ["Customer Input Data"];
                // // merge by start row, start column, end row, end column
                // worksheet.mergeCells(3, 1, 3, 10);


                //worksheet.getRow(1).height = 200;       


                nonEditableHeader.map(item => {
                    worksheet.getRow(4).getCell(item.key).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '0B64A0' }
                    };
                    worksheet.getRow(4).getCell(item.key).font = {
                        name: 'BentonSans Book',
                        size: 9,
                        color: { argb: 'FFFFFF' },
                        bold: true,
                    };

                    for (var rowNo = 3; rowNo <= 4; rowNo++) {
                        worksheet.getRow(rowNo).getCell(item.key).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                });

                const textColor = (this.state.exportAction === 'enablementInsightColumns' ||
                    this.state.exportAction === 'customerViewColumns') ?
                    'FFFFFF' : 'e9ff21';

                editableHeader.map(item => {
                    worksheet.getRow(4).getCell(item.key).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: '0B64A0' }
                    };
                    worksheet.getRow(4).getCell(item.key).font = {
                        name: 'BentonSans Book',
                        size: 9,
                        color: { argb: textColor },
                        bold: true,
                    };

                    for (var rowNo = 3; rowNo <= 4; rowNo++) {
                        worksheet.getRow(rowNo).getCell(item.key).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }

                    // // make header row readonly 
                    // worksheet.getRow(4).getCell(item.key).protection = {
                    //     locked: false,
                    //     hidden: false,
                    // };

                    //          // Add autofilter to all column
                    //    worksheet.autoFilter = 'A1:V1';


                    //worksheet.getCell('E2').value = { formula:'E5+E6'};  

                }
                );

                // to make header row frozen
                worksheet.views = [
                    { state: 'frozen', ySplit: 1 }
                ];

                if (this.state.exportAction === 'custFacingMatchedOutputDemo' || this.state.exportAction === 'custFacingMatchedOutputDemoSDMC') {
                    this.copyExcelWorkSheet(8, workbook1, workbook, 'READ ME');
                    this.copyExcelWorkSheet(2, workbook1, workbook, '');
                    workbook.removeWorksheet(1);
                    // -----   Code to add Customer Facing Template tab Start
                    var rowDataCFT = [...chunk];

                    // rowDataCFT.map(a => {
                    //     if (a.EXPOSE_SUPP_SEARCH_RESULT == 'N'
                    //         || a.SUPP_ALLOW_BUYER_CONTACT == 'N'
                    //         || a.SUPP_ALLOW_SEARCH_BUYER == 'No'
                    //         || a.EXPOSE_ADMIN_PERSONAL_CONTACT_INFO == 'No') {
                    //         a.EMAIL = '';
                    //         a.CONTACTNAME = '';
                    //         a.CONTACTPHONE = ''
                    //     }
                    //     return a;
                    // });
                    this.createDynamicWorkSheet('Customer Match Output', this.state.ndlCustFacingColumns, workbook, rowDataCFT, 'Customer Match Output');

                    // -----   Code to add Match Output Enhanced tab Start                    
                    this.createDynamicWorkSheet('Customer Match Output (AVATAR)', this.state.ndlColumnsCustFacingEnhanced, workbook, rowDataCFT, 'Customer Match Output (AVATAR)');

                    //this.createDynamicWorkSheet('Customer Match Output',this.state.ndlCustFacingColumns,workbook,rowData,'Customer Match Output');                      
                    this.createSEMatchOutputSummarySheet(workbook);
                }


                if (this.state.exportAction === 'matchedOutputDemo' || this.state.exportAction === 'matchedOutputDemoSDMC' || this.state.exportAction === 'matchedOutputDemoEnhanced') {
                    let sheetToClone = workbook1.getWorksheet(2);
                    let copySheet = workbook.addWorksheet("Sheet");
                    // Copy Newly created M&C Worksheet in Existing worksheet
                    copySheet.model = worksheet.model;
                    //Delete Newly created M&C Worksheet
                    // workbook.removeWorksheet(1);
                    //Rename Existing worksheet
                    copySheet.name = workSheetName;

                    //this.copyExcelWorkSheet(4,workbook1,workbook,'');

                    // // // let copySheet1 = workbook.addWorksheet("Sheet");                        
                    // // // // Copy Newly created M&C Worksheet in Existing worksheet
                    // // // copySheet1.model = worksheet.model;
                    //Delete Newly created M&C Worksheet
                    workbook.removeWorksheet(1);
                    // // // //Rename Existing worksheet
                    // // // copySheet1.name = 'Customer Facing Template Remove';


                    // -----   Code to add Match Output Enhanced tab Start                    
                    this.createDynamicWorkSheet('Match Output (AVATAR)', this.state.ndlColumnsMatchOutputEnhanced, workbook, chunk, 'Match Output (AVATAR)');


                    // -----   Code to add Do-Not-Share Suppliers tab Start
                    // var rowDataDNS = [...chunk];
                    // rowDataDNS = rowDataDNS.filter(a => a.EXPOSE_SUPP_SEARCH_RESULT == 'N'
                    //     || a.SUPP_ALLOW_BUYER_CONTACT == 'N'
                    //     || a.SUPP_ALLOW_SEARCH_BUYER == 'No'
                    //     || a.EXPOSE_ADMIN_PERSONAL_CONTACT_INFO == 'No');
                    this.createDynamicWorkSheet('Do-Not-Share Suppliers', this.state.ndlColumnsDoNotShareWithCustomer, workbook, this.state.ndlDNS_Data, 'This sheet contains protected PII.  Data contained in this sheet is for internal use only.');


                    //----------------------------------------------------------

                    // -----   Code to add Customer Facing Template tab Start

                    var rowDataCFT = [...chunk];

                    rowDataCFT.map(a => {
                        if (a.EXPOSE_SUPP_SEARCH_RESULT == 'N'
                            || a.SUPP_ALLOW_BUYER_CONTACT == 'N'
                            || a.SUPP_ALLOW_SEARCH_BUYER == 'No'
                            || a.EXPOSE_ADMIN_PERSONAL_CONTACT_INFO == 'No') {
                            a.EMAIL = '';
                            a.CONTACTNAME = '';
                            a.CONTACTPHONE = ''
                        }
                        return a;
                    });
                    this.createDynamicWorkSheet('Customer Match Output', this.state.ndlCustFacingColumns, workbook, rowDataCFT, 'Customer Match Output');


                    // // // workbook.removeWorksheet(6);

                    //------   Code to add Customer Facing Template tab End

                    // -----   Code to add Parent Account Info tab Start
                    this.createDynamicWorkSheet('Parent Account Info', this.state.ndlParentAccountInfoColumns, workbook, chunk, 'Parent Account Info');

                    // Add Input Data Quality worksheet
                    workbook.addWorksheet("Input Data Quality");

                    this.createSEMatchOutputSummarySheet(workbook);

                    // -----   Code to add Parent Account Info tab End.
                }

                // // below column used internally 		
                // worksheet.getColumn('SAP_ARIBA_DOC_PROXY').hidden = true;    
                // worksheet.getColumn('SAP_ARIBA_SPEND_PROXY').hidden = true;     
                // worksheet.getColumn('V').hidden = true;

                ////add data and file name and download
                // workbook.xlsx.writeBuffer().then((data) => {
                //     let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                //     FileSaver.saveAs(blob, fname + '.xlsx');
                //     this.setState({ isSaveInProgress: false, isLoading: false });
                //     // var excelButton = document.getElementsByClassName("button--accent")[0].parentNode;
                //     // excelButton.style.display = 'block';
                //     // if(this.state.exportAction === 'matchedOutputDemo' || this.state.exportAction === 'custFacingMatchedOutputDemo' || this.state.exportAction === 'matchedOutputDemoEnhanced')
                //     //     this.hideModal('ndlAlert');
                //     // else
                //     //     this.hideModal('alert');
                //     this.hideModal('alert');
                //     this.insertReportAudit('Download - ' + downloadType, fname + '.xlsx');
                // });

                // if (this.state.exportAction === 'runDMCoutputColumns') {
                //     this.addRunDMCSummarySheet(workbook);
                // }

                if (this.state.exportAction === 'runDMCoutputColumns') {
                    const summarySheet = workbook.getWorksheet('Summary');
                    if (summarySheet) {
                        // ExcelJS doesn’t support direct reorder in the array
                        // So we remove and re-add it in the right place using internal properties
                        const sheets = workbook.worksheets;
                        const currentIndex = sheets.findIndex(s => s.name === 'Summary');
                
                        if (currentIndex > 0) {
                            // Remove it from current index
                            const [sheet] = sheets.splice(currentIndex, 1);
                            // Insert it at index 0
                            sheets.splice(0, 0, sheet);
                
                            // Also update internal orderNo (important for Excel)
                            sheets.forEach((ws, i) => {
                                ws.orderNo = i + 1;
                            });
                        }
                    }
                }


                // ✅ Highlight Enablement Segment based on value
                const getCellText = (cell) => {
                    if (!cell || cell.value === null || cell.value === undefined) return '';
                    if (typeof cell.value === 'object') {
                        return cell.value.text || cell.value.result || '';
                    }
                    return cell.value.toString();
                };

                const dnsVendorIds = new Set(
                    (this.state.ndlDNS_Data || []).map(v => v.VENDOR_ID)
                );

                workbook.worksheets.forEach(ws => {
                    if (ws.name !== 'Match Output' && ws.name !== 'Match Output (AVATAR)') return;

                    let enablementColNumber = null;
                    let vendorColNumber = null;

                    // detect columns from header row
                    ws.getRow(4).eachCell((cell, colNumber) => {
                        const header = getCellText(cell).trim();

                        if (header === 'Enablement Segment')
                            enablementColNumber = colNumber;

                        if (header === 'Vendor ID')
                            vendorColNumber = colNumber;
                    });

                    // ❗ Skip sheets without ENABLEMENT_SEGMENT
                    if (!enablementColNumber) return;

                    for (let r = 5; r <= ws.rowCount; r++) {

                        const enableCell = ws.getRow(r).getCell(enablementColNumber);
                        const vendorCell = vendorColNumber ? ws.getRow(r).getCell(vendorColNumber) : null;

                        const value = getCellText(enableCell).trim();
                        const vendorId = getCellText(vendorCell).trim();

                        let color = null;

                        if (value === 'Primary Enablement ANID' || value === 'Treat as Proactive')
                            color = '99FF99'; // green
                        else if (value === 'Multiple ANIDs - if n/a, Review Global Account Profile' ||
                            value === 'Multiple ANIDs - if n/a, Treat as Proactive' || value === 'Multiple ANIDs – if n/a Review GA Profile before TRR send')
                            color = 'FFFF9C'; // yellow
                        else if (value === 'Buyer Action Required Before TRR - Review Global Account' ||
                            value === 'Contact Buyers Account Manager' ||
                            value === 'Review Global Account Profile')
                            color = 'FF7B84'; // red

                        if (color) {

                            enableCell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: color }
                            };

                            // remove text if vendor exists in DNS
                            if (dnsVendorIds.has(vendorId) && self.state.exportAction == 'matchedOutputDemoSDMC') {
                                enableCell.value = '';
                            }
                        }
                    }
                });


                // ---- MOVE READ ME TO FIRST POSITION ----
                if (
                    this.state.exportAction !== 'matchedOutputDemo' &&
                    this.state.exportAction !== 'custFacingMatchedOutputDemo' &&
                    this.state.exportAction !== 'matchedOutputDemoEnhanced' && 
                    this.state.exportAction !== 'matchedOutputDemoSDMC' &&
                    this.state.exportAction !== 'custFacingMatchedOutputDemoSDMC'
                ) {
                    const sheets = workbook.worksheets;
                    const idx = sheets.findIndex(ws => ws.name === 'READ ME');

                    if (idx > 0) {
                        const [sheet] = sheets.splice(idx, 1);
                        sheets.splice(0, 0, sheet);
                        sheets.forEach((ws, i) => ws.orderNo = i + 1);
                    }
                }                

                const chunkNumber = idx + 1;
                const finalName = `${fname}_${chunkNumber}.xlsx`;
                const dataBuffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([dataBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                FileSaver.saveAs(blob, finalName);
                this.insertReportAudit(`Download - ${downloadType}`, finalName);

                console.log('reading Excel done');
                
            }
        //}.bind(this), 10000)
        //----------------------------------------------------

        this.setState({ isLoading: true, isSaveInProgress: true }, async () => {
            try {
                for (let i = 0; i < chunks.length; i++) {
                    this.setState({ currentChunkIndex: i + 1, totalChunks: chunks.length, isLoading: true, isSaveInProgress: true }, this.forceUpdate); // Update before/after export
                    await exportChunk(chunks[i], i);
                }
            } catch (error) {
                console.error("Export failed", error);
            } finally {
                // 8️⃣ Final clean-up
                this.props.defineScopeLoading(false);
                this.setState({ isSaveInProgress: false, isLoading: false, currentChunkIndex: null, totalChunks: null });
                this.hideModal('alert');
            }         
        });
    }

    addRunDMCSummarySheet(workbook) {
        var dmcSummaryData = this.state.dmcSummaryData;
        if (!dmcSummaryData) return;
    
        var analysisCriteria = dmcSummaryData.Table || [];
        var spendOverview = dmcSummaryData.Table1 || [];
        var classificationDetails = dmcSummaryData.Table2 || [];
        var supplierNetworkParams = dmcSummaryData.Table3 || []; // 4th result set
    
        var sheet = workbook.addWorksheet("Summary");
    
        sheet.columns = [
            { key: "spacer", width: 2 },
            { key: "field", width: 40 },
            { key: "value", width: 60 }
        ];
    
        // === Main Header ===
        sheet.mergeCells("B1:C1");
        var headerCell = sheet.getCell("B1");
        headerCell.value = "Spend Data Overview";
        headerCell.font = { color: { argb: "FFFFFFFF" }, bold: true, size: 14 };
        headerCell.alignment = { horizontal: "left", vertical: "middle" };
        headerCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
        sheet.getCell("C1").fill = headerCell.fill;
        sheet.getRow(1).height = 25;
    
        // === Disclaimer ===
        var disclaimer1 =
        "The data contained in this file is for internal use only. Do not distribute outside of SAP/Ariba. ";
    sheet.getCell("B2").value = disclaimer1;
    sheet.getCell("B2").font = { color: { argb: "FF0000" }, bold: true, size: 11 };
    sheet.getCell("B2").alignment = { wrapText: false, horizontal: "left", vertical: "middle" };
    sheet.getRow(2).height = 20;

    var disclaimer2 =
        "Data Retention Policy: This file, along with all data within, must be deleted within 12 months of receipt.";
    sheet.getCell("B3").value = disclaimer2;
    sheet.getCell("B3").font = { color: { argb: "FF0000" }, bold: true, size: 11 };
    sheet.getCell("B3").alignment = { wrapText: false, horizontal: "left", vertical: "middle" };
    sheet.getRow(2).height = 20;
    
        var currentRow = 4;
    
        // === Helper to Add Sections ===
        function addSection(title, dataArray, valueAlign) {
            if (!dataArray || dataArray.length === 0) return;
    
            currentRow++;
    
            sheet.getCell("B" + currentRow).value = title;
            sheet.mergeCells(currentRow, 2, currentRow, 3);
            sheet.getRow(currentRow).font = { color: { argb: "FFFFFFFF" }, bold: true, size: 12 };
            sheet.getRow(currentRow).alignment = { horizontal: "left", vertical: "middle" };
            sheet.getCell("B" + currentRow).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "4472C4" }
            };
            sheet.getCell("C" + currentRow).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "4472C4" }
            };
    
            currentRow++;
    
            for (var i = 0; i < dataArray.length; i++) {
                var record = dataArray[i];
                var keys = Object.keys(record);
                for (var j = 0; j < keys.length; j++) {
                    var key = keys[j];
                    var val = record[key];
    
                    var row = sheet.getRow(currentRow);
                    row.getCell(2).value = key;
                    row.getCell(3).value = val;
    
                    row.getCell(2).alignment = { horizontal: "left", vertical: "middle" };
                    row.getCell(3).alignment = { horizontal: valueAlign, vertical: "middle" };
    
                    for (var c = 2; c <= 3; c++) {
                        row.getCell(c).border = {
                            top: { style: "thin" },
                            left: { style: "thin" },
                            bottom: { style: "thin" },
                            right: { style: "thin" }
                        };
                    }
    
                    currentRow++;
                }
            }
        }
    
        // === Existing sections ===
        addSection("Analysis Criteria", analysisCriteria, "left");
        addSection("Spend Overview", spendOverview, "right");
        addSection("Classification Details", classificationDetails, "right");
    
        // === 4️⃣ Add Supplier Network Account Parameters Section ===
        if (supplierNetworkParams && supplierNetworkParams.length > 0) {
            // Adjust width of E,F,G by 30%
            sheet.getColumn("E").width = 40 * 0.5;
            sheet.getColumn("F").width = 40 * 0.5;
            sheet.getColumn("G").width = 40 * 0.5;
            sheet.getColumn("H").width = 25;
            sheet.getColumn("I").width = 25;
    
            // Header row (E5:I5)
            sheet.mergeCells("E5:I5");
            var mainHeader = sheet.getCell("E5");
            mainHeader.value = "User Input";
            mainHeader.font = { color: { argb: "FFFFFFFF" }, bold: true, size: 12 };
            mainHeader.alignment = { horizontal: "center", vertical: "middle" };
            mainHeader.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
    
            // Row 6 column labels
            sheet.getCell("H6").value = "Default";
            sheet.getCell("H6").font = { bold: true };
            sheet.getCell("I6").value = "User Input";
            sheet.getCell("I6").font = { bold: true };
    
            // Data starts from E7
            var startRow = 7;
    
            for (var i = 0; i < supplierNetworkParams.length; i++) {
                var item = supplierNetworkParams[i];
                var param = "";
                if (item && item.PARAMETER) {
                    param = String(item.PARAMETER).trim();
                }
    
                // Blank row before specific parameters
                if (param === "Product Scope Assignments" || param === "Working Capital Scope") {
                    startRow++;
                }
    
                var rowIdx = startRow++;
    
                // Merge E,F,G for PARAMETER
                sheet.mergeCells("E" + rowIdx + ":G" + rowIdx);
                
                var param = item && item.PARAMETER ? String(item.PARAMETER).trim() : "";
                var def = (item && item.DEFAULT !== undefined && item.DEFAULT !== null) ? item.DEFAULT : "";
                var usr = (item && item.USER_INPUT !== undefined && item.USER_INPUT !== null) ? item.USER_INPUT : "";
                sheet.getCell("E" + rowIdx).value = param;
                sheet.getCell("H" + rowIdx).value = def;
                sheet.getCell("I" + rowIdx).value = usr;
    
                // Alignment
                sheet.getCell("E" + rowIdx).alignment = { horizontal: "left", vertical: "middle" };
                sheet.getCell("H" + rowIdx).alignment = { horizontal: "center", vertical: "middle" };
                sheet.getCell("I" + rowIdx).alignment = { horizontal: "center", vertical: "middle" };
    
                // Borders E–I
                var cols = ["E", "F", "G", "H", "I"];
                for (var c = 0; c < cols.length; c++) {
                    var col = cols[c];
                    sheet.getCell(col + rowIdx).border = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    };
                }
    
                // Highlight specific rows
                if (
                    param === "Supplier Network Account Parameters" ||
                    param === "Product Scope Assignments" ||
                    param === "Working Capital Scope"
                ) {
                    for (var c = 0; c < cols.length; c++) {
                        var cell = sheet.getCell(cols[c] + rowIdx);
                        cell.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFD9D9D9" } // light grey
                        };
                        cell.font = { bold: true, color: { argb: "FF000000" } }; // black text
                    }
                }
                else {
                    for (var c = 0; c < cols.length; c++) {
                        var cell = sheet.getCell(cols[c] + rowIdx);
                        cell.font = { color: { argb: "FF000000" } }; // black text for normal rows
                    }
                }
            }
        }
    
        // === Freeze header rows ===
        sheet.views = [{ state: "frozen", ySplit: 3 }];
    }


    createSEMatchOutputSummarySheet(workbook) {
        const sheet = workbook.getWorksheet("Summary");
        const data = this.state.dmcSummaryData;
    
        // ----------------------------------------------
        // REMOVE OLD MERGES (SAFELY)
        // ----------------------------------------------
        Array.from(sheet._merges).forEach(m => {
            try { sheet.unMergeCells(m); } catch (e) {}
        });
    
        function safeMerge(sheet, r1, c1, r2, c2) {
            try { sheet.unMergeCells(r1, c1, r2, c2); } catch (e) {}
            sheet.mergeCells(r1, c1, r2, c2);
        }
    
        // ----------------------------------------------
        // MAIN TITLE
        // ----------------------------------------------
        sheet.getCell("B1").value = "SAP Business Network Match Overview";
        sheet.getCell("B1").font = { name: "Arial", bold: true, size: 14 };
    
    
        // ---------------------------------------------------------
        // TABLE-WRITING FUNCTION (handles titles, headers, data)
        // ---------------------------------------------------------
        function writeTable(sheet, tableData, startRow, startCol, titleText, options = {}) {

            const isVertical = options.vertical === true;
        
            // =====================================================
            // VERTICAL KEY/VALUE MODE (NEW)
            // =====================================================
            if (isVertical) {

                if (!tableData || tableData.length === 0) return startRow;
            
                let headers, values;
            
                // Handle single-row data
                if (tableData.length === 1) {
                    values = tableData[0];
                    headers = Object.keys(values).reduce((acc, k) => {
                        acc[k] = k; // keep original column name
                        return acc;
                    }, {});
                } else {
                    headers = tableData[0];
                    values  = tableData[1];
                }
            
                const keys = Object.keys(values);
            
                const lightBlue = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFF2F9FF" }
                };
            
                // ---------------------
                // TITLE (same as horizontal)
                // ---------------------
                if (titleText) {
                    safeMerge(sheet, startRow, startCol, startRow, startCol + 1);
            
                    const titleCell = sheet.getCell(startRow, startCol);
                    titleCell.value = titleText;
                    titleCell.font = {
                        bold: true,
                        size: 16,
                        underline: { style: 'single', color: { argb: 'FFD700' } }
                    };
                    titleCell.alignment = { horizontal: "left", vertical: "middle" };
                    titleCell.border = {
                        bottom: { style: "thin", color: { argb: "FFD700" } }
                    };
            
                    sheet.getRow(startRow).height = 24;
                    startRow++;
                }
            
                // Column widths (Category / Count analogy)
                sheet.getColumn(startCol).width = 45; // Label (Category)
                sheet.getColumn(startCol + 1).width = 25; // Value (Count)
            
                let rowIndex = startRow;
            
                keys.forEach((k, idx) => {
            
                    const labelCell = sheet.getCell(rowIndex, startCol);
                    const valueCell = sheet.getCell(rowIndex, startCol + 1);
            
                    // Label column = header styling
                    labelCell.value = headers[k] || k;
                    labelCell.font = { bold: true };
                    labelCell.alignment = { horizontal: "left", vertical: "middle" };
                    labelCell.border = {
                        top:    { style: idx === 0 ? "medium" : "thin", color: { argb: "FFD700" } },
                        bottom: { style: "thin", color: { argb: "FF888888" } }
                    };
            
                    // Value column = data styling
                    valueCell.value = values[k];
                    valueCell.alignment = { horizontal: "left", vertical: "middle" };
                    valueCell.fill = lightBlue;
                    valueCell.border = {
                        top:    { style: idx === 0 ? "medium" : "thin", color: { argb: "FFD700" } },
                        bottom: { style: "thin", color: { argb: "FF888888" } }
                    };
            
                    rowIndex++;
                });
            
                return rowIndex;
            }
            
        
            // =====================================================
            // EXISTING HORIZONTAL TABLE (UNCHANGED)
            // =====================================================
        
            sheet.getColumn(startCol).width = 45;
            sheet.getColumn(startCol + 1).width = 15;
            sheet.getColumn(startCol + 2).width = 12;
        
            safeMerge(sheet, startRow, startCol, startRow, startCol + 2);
        
            const titleCell = sheet.getCell(startRow, startCol);
            titleCell.value = titleText;
            titleCell.font = {
                bold: true,
                size: 16,
                underline: { style: 'single', color: { argb: 'FFD700' } }
            };
            titleCell.alignment = { horizontal: "left", vertical: "middle" };
            titleCell.border = {
                bottom: { style: "thin", color: { argb: "FFD700" } }
            };
        
            sheet.getRow(startRow).height = 24;
        
            const headerRow = startRow + 1;
            sheet.getRow(headerRow).height = 22;
        
            sheet.getCell(headerRow, startCol).value = "Category";
            sheet.getCell(headerRow, startCol + 1).value = "Count";
            sheet.getCell(headerRow, startCol + 2).value = "%";
        
            const lightBlue = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFF2F9FF" }
            };
        
            for (let c = 0; c < 3; c++) {
                const cell = sheet.getCell(headerRow, startCol + c);
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = {
                    top: { style: "medium", color: { argb: "FFD700" } },
                    bottom: { style: "medium", color: { argb: "FF000000" } }
                };
            }
        
            sheet.getCell(headerRow, startCol + 1).fill = lightBlue;
            sheet.getCell(headerRow, startCol + 2).fill = lightBlue;
        
            let rowIndex = headerRow + 1;
        
            tableData.forEach(row => {
        
                const cat = sheet.getCell(rowIndex, startCol);
                const count = sheet.getCell(rowIndex, startCol + 1);
                const pct = sheet.getCell(rowIndex, startCol + 2);
        
                count.value = row.COUNT;
                count.numFmt = '#,##0';
                pct.value = row["%"];
        
                if (row.PARENT_CHILD_LEVEL === 2) {
                    cat.value = `- ${row.CATEGORY}`;
                    cat.alignment = { horizontal: "left", indent: 2 };
                } else {
                    cat.value = row.CATEGORY;
                    cat.alignment = { horizontal: "left" };
                }
        
                count.alignment = { horizontal: "center" };
                pct.alignment = { horizontal: "center" };
        
                count.fill = lightBlue;
                pct.fill = lightBlue;
        
                rowIndex++;
            });
        
            return rowIndex;
        }
        
        // ---------------------------------------------------------
        // TABLE 1
        // ---------------------------------------------------------
        let nextRow = writeTable(
            sheet,
            data.Table,
            3,
            2,
            "SAP Business Network Match Input Summary",
            { vertical: false }
        );
    
        // ---------------------------------------------------------
        // TABLE 2
        // ---------------------------------------------------------
        nextRow += 2;
    
        let nextRow2 = writeTable(
            sheet,
            data.Table1,
            nextRow,
            2,
            "SAP Business Network Match Result Summary",
            { vertical: false }
        );
    
        // ---------------------------------------------------------
        // TABLE 3 (with normalization)
        // ---------------------------------------------------------
        const table3 = data.Table2.map(r => ({
            CATEGORY: r.CATEGORY || r.SUPPLIER_CATEGORY || r.NAME || "",
            COUNT: r.COUNT || r.SUPPLIER_COUNT || r.TOTAL || r.COUNT_SUPPLIERS || 0,
            "%": r["%"] || r.PERCENT || r.PERCENTAGE || r.RATIO || 0
        }));
    
        const lastRow3 = writeTable(
            sheet,
            table3,
            nextRow,
            6,
            "Supplier Integration Summary",
            { vertical: false }
        );

        const lastRow4 = writeTable(
            sheet,
            data.Table3,
            3,      // F3
            6,      // Column F
            "Request File Details",
            { vertical: true }
        );
    
        // ==================================================================================
        // FINAL STEP — MAKE ALL NON-TABLE AREA WHITE BORDER until last table row
        // ==================================================================================
        const lastUsedRow = Math.max(nextRow, nextRow2, lastRow3, lastRow4);
    
        const MAX_WHITE_COLS = 26; // A–Z
    
        for (let r = 1; r <= lastUsedRow; r++) {
            for (let c = 1; c <= MAX_WHITE_COLS; c++) {
    
                const cell = sheet.getCell(r, c);
    
                // Skip table cells — we DO NOT overwrite table formatting
                if (cell.border && cell.border.top && cell.border.top.color.argb !== "FFFFFFFF")
                    continue;
    
                cell.border = {
                    top:    { style: "thin", color: { argb: "FFFFFFFF" } },
                    bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
                    left:   { style: "thin", color: { argb: "FFFFFFFF" } },
                    right:  { style: "thin", color: { argb: "FFFFFFFF" } }
                };
            }
        }
    }
    
    getExcelColumnName(columnNumber) {
        // To store result (Excel column name)
        let columnName = [];

        while (columnNumber > 0) {
            // Find remainder
            let rem = columnNumber % 26;

            // If remainder is 0, then a
            // 'Z' must be there in output
            if (rem == 0) {
                columnName.push("Z");
                columnNumber = Math.floor(columnNumber / 26) - 1;
            }
            else // If remainder is non-zero
            {
                columnName.push(String.fromCharCode((rem - 1) + 'A'.charCodeAt(0)));
                columnNumber = Math.floor(columnNumber / 26);
            }
        }

        // Reverse the string
        return columnName.reverse().join("")
    }

    excelformatter = (formatterName) => {
        switch (formatterName) {
            case 'LeftAlignFormatter':
                return '#,##0'
            case 'AlignFormatter':
                return '#,##0'//formatThousandsWithBlank(roundFixWithBlank(value, 0))
            case 'RoundFormatter':
                return '#,##0.0000'//formatThousandsWithBlank(roundFixWithBlank(value, 4))
            case 'CenterAlignFormatter':
                return '#,##0'
            case 'RightAlignFormatter':
                return '#,##0'
            case 'AlignCurrencyFormatter':
                return '#,##0'//formatThousandsWithBlank(roundFixWithBlank(value, 0))
            case 'RoundCurrencyFormatter':
                return '#,##0.0000'//formatThousandsWithBlank(roundFixWithBlank(value, 4))
            case 'LinkFormatter':
                return '#,##0'
            case 'RoundFormatter2':
                return '#,##0.00'//formatThousandsWithBlank(roundFixWithBlank(value, 2))
            case 'IntegralpartFormatter':
                return '#,##0'//vformatThousandsWithBlank(integralPartWithBlank(value))
            case 'IntegralpartPercentFormatter':
                return '#,##0'//formatThousandsWithBlank(integralPartWithBlank(value))
            default:
                return undefined;
        }
    }

    excelTextFormatter = (formatterName) => {
        switch (formatterName) {
            case 'LeftAlignFormatter':
                return 'left'
            case 'AlignFormatter':
                return 'right'
            case 'RoundFormatter':
                return 'right'
            case 'CenterAlignFormatter':
                return 'center'
            case 'RightAlignFormatter':
                return 'right'
            case 'AlignCurrencyFormatter':
                return 'right'
            case 'RoundCurrencyFormatter':
                return 'right'
            case 'LinkFormatter':
                return 'left'
            case 'RoundFormatter2':
                return 'right'
            case 'IntegralpartFormatter':
                return 'right'
            case 'IntegralpartPercentFormatter':
                return 'right'
            default:
                return 'right';
        }
    }

    industryOverride() {
        if (this.props.overridedIndustryDetails !== undefined && this.props.overridedIndustryDetails !== null
            && this.props.overridedIndustryDetails.INDUSTRY_ID !== undefined && this.props.overridedIndustryDetails.INDUSTRY_ID !== null) {
            this.onGridRowsUpdated({ fromRow: this.state.industryOverrideRowNo, toRow: this.state.industryOverrideRowNo, updated: { 'OVERRIDE_INDUSTRY_ID': this.props.overridedIndustryDetails.INDUSTRY_ID } })
            this.props.selectedIndustryDetails(null)//Clear the previous selection
            this.setState({ open: !this.state.open })
        }
    }

    clearIndustryOverride() {
        this.onGridRowsUpdated({ fromRow: this.state.industryOverrideRowNo, toRow: this.state.industryOverrideRowNo, updated: { 'OVERRIDE_INDUSTRY_ID': '' } })
        this.setState({ open: !this.state.open })
    }

    closePopUp() {
        this.setState({ open: !this.state.open })
    }

    outsidePopupClick() {
        this.setState({ open: false })
    }

    enablementWaveInput() {
        if (this.props.enablementWaveInputDetails !== undefined && this.props.enablementWaveInputDetails !== null) {
            this.onGridRowsUpdated({ fromRow: this.state.enablementWaveInputRowNo, toRow: this.state.enablementWaveInputRowNo, updated: { 'ENABLEMENT_WAVE': this.props.enablementWaveInputDetails == '' || this.props.enablementWaveInputDetails == 0 ? 1 : this.props.enablementWaveInputDetails } })
            this.props.selectedEnablementWaveDetails(null)//Clear the previous selection
            //this.setState({ openEnablementInsightPopUp: !this.state.openEnablementInsightPopUp })
        }
        this.setState({ openEnablementInsightPopUp: !this.state.openEnablementInsightPopUp })
    }

    clearEnablementWaveOverride() {
        this.onGridRowsUpdated({ fromRow: this.state.enablementWaveInputRowNo, toRow: this.state.enablementWaveInputRowNo, updated: { 'ENABLEMENT_WAVE': '' } })
        this.setState({ openEnablementInsightPopUp: !this.state.openEnablementInsightPopUp })
    }

    closeEnablementInsightPopUp() {
        this.setState({ openEnablementInsightPopUp: !this.state.openEnablementInsightPopUp })
    }

    outsideEnablementInsightPopupClick() {
        this.setState({ openEnablementInsightPopUp: false })
    }

    addUserComments(comments) {
        this.onGridRowsUpdated({ fromRow: this.state.userCommentsRowNo, toRow: this.state.userCommentsRowNo, updated: { 'USER_COMMENT': comments } })
        this.setState({ openUserCommentsPopUp: !this.state.openUserCommentsPopUp })
    }

    clearUserComments() {
        if (moment(this.state.userCommentInsideCell, 'MM/DD/YYYY', true).isValid() === false) {
            this.onGridRowsUpdated({ fromRow: this.state.userCommentsRowNo, toRow: this.state.userCommentsRowNo, updated: { 'USER_COMMENT': '' } })
        }
        this.setState({ openUserCommentsPopUp: !this.state.openUserCommentsPopUp })
    }

    closeUserCommentsPopUp() {
        this.setState({ openUserCommentsPopUp: !this.state.openUserCommentsPopUp })
    }

    outsideUserCommentsPopupClick() {
        this.setState({ openUserCommentsPopUp: false })
    }

    capIqIdOverride() {
        //console.log("from details file props data: ", this.props.overridedCapIqIdDetails)
        if (this.props.overridedCapIqIdDetails !== undefined && this.props.overridedCapIqIdDetails !== null
            && this.props.overridedCapIqIdDetails.COMPANY_ID !== undefined && this.props.overridedCapIqIdDetails.COMPANY_ID !== null) {
            this.onGridRowsUpdated({
                fromRow: this.state.capIqIdOverrideRowNo, toRow: this.state.capIqIdOverrideRowNo,
                updated: { 'CAPIQ_COMPANY_ID': this.props.overridedCapIqIdDetails.COMPANY_ID }
            })
            this.props.selectedCapIqIdDetails(null)// Clear the previous selection
            this.setState({ openCapIq: !this.state.openCapIq })
        }
    }

    clearCapIqIdOverride() {
        this.onGridRowsUpdated({ fromRow: this.state.capIqIdOverrideRowNo, toRow: this.state.capIqIdOverrideRowNo, updated: { 'CAPIQ_COMPANY_ID': '' } })
        this.setState({ openCapIq: !this.state.openCapIq })
    }

    closeCapIqIdPopUp() {
        this.setState({ openCapIq: !this.state.openCapIq })
    }

    outsideCapIqIdPopupClick() {
        this.setState({ openCapIq: false })
    }

    filterValidationRecords(e, skeys, recordType) {
        const rowData = this.state.rowData;
        const filteredRows = [];
        skeys.forEach((item) => {
            rowData.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })  // binary search work with sorted array only
            var rowIdx = binarySearchIndex(rowData, item, 'DATA_COLLECTIONS_SKEY')
            var idx = filteredRows.findIndex((item) => {
                return item['DATA_COLLECTIONS_SKEY'] === rowData[rowIdx]['DATA_COLLECTIONS_SKEY']
            })

            if (rowIdx !== -1 && idx === -1) {
                filteredRows.push(rowData[rowIdx]);
            }
        })
        let newFilters = { ...this.state.filters };
        newFilters[recordType] = { filteredRows: [...filteredRows], filterTerm: 'Yes', 'rawValue': skeys.length, type: 'global', column: { name: recordType, key: recordType } };

        this.props.detailedFileFilters(newFilters)

        this.setState({ filters: newFilters }, () => {
            this.getRows(this.state.rowData, newFilters)
        })
        e.stopPropagation();
    }

    //Remove this after ticket 319 is done
    // snapFilters() {
    //     this.getAppliedFilters()
    // }

    // clearFilter(e){
    //     let filter = this.state.filters
    //     let rows = [...this.state.rowData];
    //     console.log(e.target.value)
    //     let key = e.target.value;
    //     delete filter[key];
    //     this.setState({filter: filter}, this.getRows(rows, filter))
    // }

    // getAppliedFilters() {
    //     let filters = this.state.filters;
    //     let filterArray = [];
    //     const colConfig = this.props.content.detailedFileFields;
    //     const colConfigArr = [];
    //     colConfig.forEach((item, index) => {
    //         for (var key in item) {
    //             if (key === 'field') {
    //                 colConfigArr[item[key]] = item;
    //                 break;
    //             }
    //         }
    //     })

    //     for (let [key, value] of Object.entries(filters)) {
    //         if (typeof (value.filterTerm) != 'string') {
    //             filterArray.push({ "key": colConfigArr[key].screen_field_name, "value": value.filterTerm[0].value })
    //         } else {
    //             filterArray.push({ "key": colConfigArr[key].screen_field_name, "value": value.filterTerm })
    //         }
    //     }//(`${key}: ${value}`)
    //     let result = []
    //     if (filterArray.length > 0) {
    //         result = (<React.Fragment>
    //             <div onClick={this.filterToggle} className="float-left plus-icon medium-1">
    //                 {!this.state.filterFlag ? <img width="10" src="images/minus-inactive.svg" /> : <img width="10" src="images/add.svg" />}
    //             </div>
    //             <p>{"Applied filters are: "}</p>
    //             {this.state.filterFlag ? null :
    //                 filterArray.map(item => (
    //                     <div>
    //                         <ol>
    //                             <li>{item.key}: {item.value}</li>
    //                             {/* <button value={item.key} onClick={e => this.clearFilter(e)}>clear</button> */}
    //                         </ol>
    //                     </div>
    //                 )
    //                 )}
    //         </React.Fragment>)
    //     } else {
    //         result = (<React.Fragment>
    //             <div id="col1">{"No filters are applied"}</div>
    //         </React.Fragment>)
    //     }
    //     this.setState({ filterDiv: result })
    // }

    filterToggle() {
        this.setState((previousState) => { return { filterFlag: !previousState.filterFlag } })
    }

    getValidationDiv() {
        const pendingRecords = this.state.pendingRecords;
        const warningRecords = this.state.warningRecords;
        const errorRecords = this.state.errorRecords;
        if (pendingRecords.length === 0) {
            this.props.pendingChanges(null)
            return '';
        } else {
            this.props.pendingChanges(pendingRecords)
        }

        var warningRecordSize = 0;
        var totalWarningRecords = []
        Object.values(warningRecords).forEach((item) => {
            totalWarningRecords = totalWarningRecords.concat(item);
        })
        var warningDiv = Object.keys(warningRecords).map((key, index) => (
            warningRecords[key].length !== 0 ?
                <div className="grid-x medium-12 message-sub-row hand-cursor" onClick={(e) => this.filterValidationRecords(e, warningRecords[key], 'warning(s)')}>
                    <span>
                        <img width="10" src="images/Dot.svg" />
                    </span>
                    <div className="medium-10">
                        {key} {this.props.content.validationForText}
                        <span className="review-warning"> {formatThousands(warningRecords[key].length)} {this.props.content.validationRowsText}
                        </span>
                    </div>
                </div> : ''
        ))

        var errorRecordSize = 0;
        var totalErrorRecords = []
        Object.values(errorRecords).forEach((item) => {
            totalErrorRecords = totalErrorRecords.concat(item);
        })

        var errorDiv = Object.keys(errorRecords).map((key, index) => (
            errorRecords[key].length !== 0 ?
                <div className="grid-x medium-12 message-sub-row hand-cursor" onClick={(e) => this.filterValidationRecords(e, errorRecords[key], 'error(s)')}>
                    <span>
                        <img width="10" src="images/Dot.svg" />
                    </span>
                    <div className="medium-10">
                        {key} {this.props.content.validationForText}
                        <span className="review-errors"> {formatThousands(errorRecords[key].length)} {this.props.content.validationRowsText}
                        </span>
                    </div>
                </div> : ''
        ))

        var validationDiv = (
            <div className="validation-messages medium-12">
                <div className="grid-x">
                    <div className="medium-12 message-row hand-cursor" onClick={(e) => this.filterValidationRecords(e, pendingRecords, 'pending')}>
                        <span className="pending-changes">
                            <img width="15" src="images/Dot.svg" />{formatThousands(pendingRecords.length)} {this.props.content.validationRecordText} </span>
                        {this.props.content.pendingChangeMessage}
                    </div>
                    {totalWarningRecords.length > 0 ?
                        <div className="grid-x medium-12 message-row">
                            <div className="medium-11 hand-cursor" onClick={(e) => this.filterValidationRecords(e, totalWarningRecords, 'warning(s)')}>
                                <span className="review-warning">
                                    <img width="15" src="images/Dot.svg" />{formatThousands(totalWarningRecords.length)} {this.props.content.validationWarningText} </span>{this.props.content.warningChangeMessage}
                            </div>
                            <div onClick={this.warningToggle} className="float-right plus-icon medium-1">
                                {this.state.warningDiv ? <img width="10" src="images/minus-inactive.svg" /> : <img width="10" src="images/add.svg" />}
                            </div>
                            {this.state.warningDiv ? warningDiv : ''}
                        </div> : ''}
                    {totalErrorRecords.length > 0 ?
                        <div className="grid-x medium-12 message-row">
                            <div className="medium-11 hand-cursor" onClick={(e) => this.filterValidationRecords(e, totalErrorRecords, 'error(s)')}>
                                <span className="review-errors">
                                    <img width="15" src="images/Dot.svg" />{formatThousands(totalErrorRecords.length)} {this.props.content.validationErrorText} </span>{this.props.content.validationThatText}<span className="font-bold"> {this.props.content.validationMustText} </span>{this.props.content.errorChangeMessage}
                            </div>
                            <div onClick={this.errorToggle} className="float-right plus-icon medium-1">
                                {this.state.errorDiv ? <img width="10" src="images/minus-inactive.svg" /> : <img width="10" src="images/add.svg" />}
                            </div>
                            {this.state.errorDiv ? errorDiv : ''}
                        </div> : ''}
                </div>
            </div>)

        return validationDiv;
    }

    warningToggle() {
        this.setState((previousState) => { return { warningDiv: !previousState.warningDiv } })
    }

    errorToggle() {
        this.setState((previousState) => { return { errorDiv: !previousState.errorDiv } })
    }

    showModal(action) {
        this.refs[action].show()
    }

    hideModal(action) {
        this.refs[action].hide()
    }

    closeColumnFieldPopup() {
        this.setState({ columns: cloneDeep(this.originalColumns) });
        this.hideModal('ColumnFields');
    }

    // closeUploadFieldPopup() {
    //     this.setState({ columns: cloneDeep(this.originalColumns) });
    //     this.hideModal('UploadUserDefinedFields');
    // }
    closeUploadFieldPopup() {

        if (this.state.isBlocking) return;
     
        this.hideModal('UploadUserDefinedFields')
     }

    removeFilter(filter, item1, removeAll = false) {
        var breadCrumbsArray = this.state.filters;
        if (breadCrumbsArray) {
            Object.values(breadCrumbsArray).forEach(item => {
                if (item.type !== NumericFilterRenderer && item.type !== TextfilterRenderer && item.type !== 'global') {
                    if (item.clear) {
                        item.clear()
                    }

                    if (removeAll) {
                        item.filterTerm.length = 0;
                        return;
                    }
                    var idx = item.filterTerm.findIndex(t => t.value === item1 && item.column.key === filter.column.key)
                    if (idx !== -1) {
                        if (item.clear) {
                            item.clear()
                        }
                        item.filterTerm.splice(idx, 1)

                        if (item.filterTerm.length === 0) {
                            delete breadCrumbsArray[filter.column.key]
                        }
                    }
                } else if (removeAll || (item.column.key === filter.column.key && item.rawValue === item1)) {
                    if (item.clear) {
                        item.clear()
                    }

                    if (!removeAll)
                        delete breadCrumbsArray[filter.column.key]
                }
            })
        }

        if (removeAll) {
            breadCrumbsArray = {}
        }


        var rows = [...this.state.rowData];
        this.setState({ filters: breadCrumbsArray }, () => {
            this.getRows(rows, breadCrumbsArray)
        })
    }

    expandFilter(item) {
        let filters;
        (item.type === NumericFilterRenderer || item.type === TextfilterRenderer || item.type === 'global') ?
            filters = (<div className='breadcrumbsClose float-left'
                content={item.rawValue} onClick={() => this.removeFilter(item, item.rawValue)}
                color
            >{item.rawValue}
                <img className="ml5" width="10" src="images/close_inactive.svg" />
            </div>) :
            filters = item.filterTerm.map((item1) => (
                (<div className='breadcrumbsClose float-left'
                    content={item1.value} onClick={() => this.removeFilter(item, item1.value)}
                    color
                >{item1.value}
                    <img className="ml5" width="10" src="images/close_inactive.svg" />
                </div>)
            ))

        return filters
    }

    sum(finalRows, colDefs = this.state.columnDefs) {
        if (finalRows.length >= 1) {
            let arr2 = cloneDeep(finalRows[0]);
            for (const key in arr2) {
                arr2[key] = ''
            }

            arr2['REF_NUMBER'] = 'Total :'

            let summationArrayKeys = ['AGGREGATE_INVOICE_COUNT', 'AGGREGATE_INVOICE_SPEND', 'AGGREGATE_PO_COUNT', 'AGGREGATE_PO_SPEND', 'AGREEGATE_PAYMENT_COUNT',
                'ERP_INVOICE_COUNT', 'ERP_PO_COUNT', 'PAYMENT_COUNT', "SAP_ARIBA_DOC_PROXY", "SAP_ARIBA_SPEND_PROXY", "SAP_ARIBA_SPEND_PROXY_USD", "AN_SMP_FEE_EST_BUYER_CURR", "ERP_INV_SPEND_IN_STD_CURR", "ENTERPRISE_ESTIM_SUPP_YIELD", "ENTERPRISE_ESTIM_SPEND_YIELD", "ENTERPRISE_ESTIM_DOC_YIELD", "ERP_DOCUMENT_CNT", "ERP_SPEND", "ESTI_CAPTURABLE_NET_TRNS_FEE_REVENUE"]

            summationArrayKeys.forEach(key => arr2[key] = 0)

            finalRows.forEach(item => {
                summationArrayKeys.forEach(key => {
                    arr2[key] += (item[key] === '' ? 0 : item[key])
                })
            })

            arr2['ENTERPRISE_ESTIM_SUPP_YIELD'] = arr2['ENTERPRISE_ESTIM_SUPP_YIELD'] / 100;
            return arr2;
        }
    }

    capIqDataCleared() {
        var array2 = [];
        let currencyCodes = this.props.discovery.currencyCodes;
        for (let i = 1; i < currencyCodes.length; i++) {
            let obj = { label: currencyCodes[i], value: currencyCodes[i].split(' - ')[0] }
            array2.push(obj);
        }
        this.setState({ currencyOption: array2 });
        let idx = array2.findIndex((element) => {
            return element.value === 'USD'
        })


        let selectedCurrencySym = this.props.currencySymbols[array2[idx].value];

        this.getCurrency({ label: selectedCurrencySym, value: array2[idx].value })


        //this.dispatchUpdateCurrency(selectedCurrencySym);

        this.setState({ selectedCurrencySymbol: selectedCurrencySym });
        // set default value for currency 
        this.setState({ selectedCurrency: array2[idx] });
        this.props.dispatchCapIQChange('clear')
        this.setState({ capIQId: '', selectedCapIQCompanyId: '', selectedLocation: this.props.discovery.locations[0], selectedIndustry: this.props.discovery.industries[0] })
    }

    capIqRadioButtonClicked(data) {
        this.props.userData.CapIQId = data.COMPANY_ID
        this.props.userData.CapIQCompany = data.COMPANY_NAME
        this.props.userData.Organization = data.COMPANY_NAME
        //this.bindIndustryAndLocation()
        //this.formDispatch(actions.change('discovery.Organization', data.COMPANY_NAME));
        if (this.props.userData.CapIQCompany) {
            this.setState({ selectedCapIQCompanyId: this.props.userData.CapIQCompany + ' | ' + this.props.userData.CapIQId, organization: data.COMPANY_NAME }, this.callCapIQProcedure);
        } else {
            this.setState({ selectedCapIQCompanyId: '' })
        }

        this.props.userData.AnnualRevenue = data.COMPANY_REVENUE ? data.COMPANY_REVENUE + '' : null;
        //this.dispatchAddRevenue(this.props.userData.AnnualRevenue)
        //this.props.userData.Location = data.COUNTRY_NAME
        let idx = this.props.discovery.locations.findIndex(item => data.COUNTRY_NAME.toLowerCase() === item.toLowerCase())
        if (idx !== -1) {
            this.props.userData.Location = idx;
            this.setState({ selectedLocation: this.props.discovery.locations[idx] });
        } else {
            this.setState({ selectedLocation: this.props.discovery.locations[0] })
        }

        if (data.AVATAR_INDUSTRY) {
            const industryIdx = this.props.discovery.industries.findIndex(item => data.AVATAR_INDUSTRY.toLowerCase() === item.toLowerCase());
            if (industryIdx !== -1) {
                this.props.userData.Industry = industryIdx;
                //this.formDispatch(actions.change('discovery.Industry', this.props.content.industries[industryIdx]));
                this.setState({ selectedIndustry: this.props.discovery.industries[industryIdx] });
            } else {
                this.setState({ selectedIndustry: this.props.discovery.industries[0] });
            }
        }
    }

    closeCapIqPopUp() {
        this.setState({ openCapIq: !this.state.openCapIq })
    }

    listenScrollEvent() {
        if (this.state.actualScroll) {
            this.setState({ actualScroll: false })
            return
        }

        this.setState({ dummyScroll: true }, () => {
            const canvas = document.getElementsByClassName('react-grid-Canvas')[0]
            const dummy = document.getElementsByClassName('scroll-dummy')[0]
            const length = this.state.columnDefs.length * 120
            const dummyScrollRatio = length / document.documentElement.clientWidth
            canvas.scrollLeft = dummy.scrollLeft //* dummyScrollRatio
        })
    }

    getHeaderGroups(columnDefs) {
        let headerToColumn = {}
        columnDefs.forEach(item => {
            if (item.headerGroup in headerToColumn) {
                let columns = headerToColumn[item.headerGroup]
                columns.push({ name: item.name, width: item.width })
            } else {
                if (item.headerGroup === null) {
                    headerToColumn[item.name] = { name: null, width: item.width }
                } else {
                    headerToColumn[item.headerGroup] = [{ name: item.name, width: item.width }]
                }
            }
        })

        return headerToColumn
    }

    // reload grid data when user defined excel upload
    reloadGrid() {
        this.loadData();
        this.loadVendorData();
        this.loadVendorDataEnhanced();        
    }

    componentWillUnmount() {

    }
    //excel export

    loadVendorData() {
        let dmcId = this.props.spendDetails.currentActiveRequest.DMC_ID;
        let vsId = this.props.spendDetails.currentActiveRequest.VS_ID;
        let user = this.props.user.user.Email;
        // this.props.defineScopeLoading(true)
        this.props.getVendorFiles(dmcId, vsId, user)
            .then((response) => {
                if (response.data.Result.length > 0) {
                    this.setState({ vufData: response.data.Result })
                } else {
                    // this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: 'No result found. Please try reimporting the file.', isError: 'Yes', isLoading: false })
                }

            }).catch((error) => {
                if (error.stack.includes('Network Error')) {
                    // this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: 'API service is down. Please contact administrator.', isError: 'Yes', isLoading: false })
                }
                else {
                    // this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false })
                }
            })
    }

    loadVendorDataEnhanced() {
        let dmcId = this.props.spendDetails.currentActiveRequest.DMC_ID;
        let vsId = this.props.spendDetails.currentActiveRequest.VS_ID;
        let user = this.props.user.user.Email;
        // this.props.defineScopeLoading(true)
        this.props.getVendorFilesEnhanced(dmcId, vsId, user)
            .then((response) => {
                if (response.data.Result.length > 0) {
                    this.setState({ vufDataEnhanced: response.data.Result })
                } else {
                    // this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: 'No result found. Please try reimporting the file.', isError: 'Yes', isLoading: false })
                }

            }).catch((error) => {
                if (error.stack.includes('Network Error')) {
                    // this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: 'API service is down. Please contact administrator.', isError: 'Yes', isLoading: false })
                }
                else {
                    // this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false })
                }
            })
    }

    insertReportAudit(logType, fileName) {
        let dmcId = this.props.spendDetails.currentActiveRequest.DMC_ID;
        let vsId = this.props.spendDetails.currentActiveRequest.VS_ID;
        let user = this.props.user.user.Email;
        this.props.insertReportLogDetails(dmcId, vsId, user, logType, fileName)
            .then((response) => {
                //this.setState({ isLoading: false });
            }).catch((error) => {
                if (error.stack.includes('Network Error')) {
                    this.setState({ responseMsg: 'API service is down. Please contact administrator.', isError: 'Yes', isLoading: false })
                }
                else {
                    this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false })
                }
            })
    }

    exportCsvForVUF(rowData) {

        var keys = Object.keys(rowData[0]).filter((cols) => {
            return cols
        })

        var headers = Object.keys(rowData[0]).map((cols) => {
            return cols.includes(',') ? cols.replace(",", "?") : cols
            //return cols.label
        })

        const options = {
            filename: this.state.exportAction == 'vuf' ? 'Vendor Details' : 'Vendor Details Enhanced',
            decimalSeparator: '.',
            showLabels: false,
            showTitle: false,
            useTextFile: false,
            keys: keys,
            headers: headers
        };

        const csvExporter = new ExportToCsv(options);

        csvExporter.generateCsv(rowData);
        this.props.defineScopeLoading(false);
        this.setState({ exportFlag: true })
        this.insertReportAudit('Download - VUF', 'Vendor Details.csv');
        this.setState({ isSaveInProgress: false, isLoading: false });
    }

    redirect() {
        this.props.history.push('/yourSpend');
        this.props.redirectFromEnablementTab(true);
        // this.props.dispatchTabChange(1)
        // this.props.reDir()
    }

    // callback = () => {
    //     if (this.state.isBlocking) return;
    //     this.closeUploadFieldPopup();
    //  }

    render() {
        const isBusinessCase = this.props.user.userprofile.Roles[0].includes('Business Case') > 0;

        const paginatedRows = this.state.filteredRows.slice(this.state.paginatedRowFrom, this.state.paginatedRowTo);
        paginatedRows.splice(0, 0, { superHeader: this.state.headerToColumn })
        paginatedRows.splice(1, 0, this.state.filteredSummationArray)
        const validationDiv = this.getValidationDiv();
        var columnDefs = this.setColumnHelpTextAndHardRefresh(paginatedRows, this.state.columnDefs)
        var filter = this.state.filters ? Object.entries(cloneDeep(this.state.filters)) : []
        var self = this;
        return (
            <div className={`medium-12 detailed-file-grid ${isBusinessCase ? 'SpendBusinessCaseDetailedFileGrid' : ''}`}>               
                <div className="grid-x grid-padding-x">
                    <div className="medium-12">
                        {(this.state.isLoading) ?
                            <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', paddingTop: '5px' }} src={path + `images/ajax-loader.gif`} alt="" />
                            : null
                        }
                        {(this.state.isError === 'Yes') ?
                            <div style={{ color: 'red', textAlign: 'center' }} className="cell pt5">{this.state.responseMsg}</div>
                            : <div style={{ color: 'green', textAlign: 'center' }} className="cell pt5">{this.state.responseMsg}</div>
                        }
                    </div>
                </div>
                <div className='grid-x grid-padding-x'>
                    <div className='medium-8'>

                        <div className="tab-title">
                            <Popup className="report-tooltip"
                                trigger={<img style={{ marginLeft: '5px' }} className="info-icon" src="images/info-icon.svg" width="15" />}
                                position="bottom left"
                                on="hover"
                            >
                                <div>
                                    {this.props.content.subHeader}
                                </div>
                            </Popup>
                            {this.props.content.subTitle}{<VideoHelp screen={{ module: 'Spend', screenName: 'Spend File Details' }} />}   </div>

                        {/* <div className="tab-description width-auto">{this.props.content.subHeader}</div> */}

                    </div>
                    {/* <div className="medium-5">
                        {validationDiv} 
                    </div> */}
                    <div style={{ paddingRight: '27px', fontSize: '12px' }} className="medium-4 legend2 defineScope text-align-right">
                        {/* <span className="key-dot outScope"></span>{this.props.content.editableColumns} */}
                        <a className="redirectButton" onClick={!this.state.isLoading && !this.state.isBlocking ? this.redirect : null}
                            style={{
                                pointerEvents: this.state.isLoading ? "none" : "auto",
                                color: this.state.isLoading ? "gray" : "",
                                cursor: this.state.isLoading ? "not-allowed" : "pointer"
                            }}>
                            {"< Back to Enablement Strategy Wizard"}
                        </a>
                    </div>
                    <div className="medium-12">
                        <div className="grid-x hideBorder">
                            <div className="medium-1 large-1">
                                <PopupE className="override-large-popup"
                                    position="right center"
                                    open={this.state.open}
                                    onClose={this.outsidePopupClick}
                                    closeOnDocumentClick
                                >
                                    <div>
                                        <IndustryOverridePopUp
                                            close={this.closePopUp}
                                        />
                                    </div>
                                    <div className="popupOkBtn">
                                        <Button onClick={this.industryOverride} float type="submit" content={this.props.ui.ok} />
                                        <Button onClick={this.clearIndustryOverride} type="submit" content={this.props.content.clearOverridenIndustry} />
                                    </div>
                                </PopupE>
                            </div>
                            <div className="medium-1 large-1">
                                <PopupE className="override-large-popup"
                                    position="right center"
                                    open={this.state.openUserCommentsPopUp}
                                    onClose={this.outsideUserCommentsPopupClick}
                                    closeOnDocumentClick
                                >
                                    <div>
                                        <UserCommentsPopUp
                                            close={this.closeUserCommentsPopUp}
                                            addUserComments={this.addUserComments}
                                            clearUserComments={this.clearUserComments}
                                            userCommentInsideCell={this.state.userCommentInsideCell}
                                            DMC_ID={this.props.spendDetails.currentActiveRequest.DMC_ID}
                                            VS_ID={this.props.spendDetails.currentActiveRequest.VS_ID}
                                            SKEY={this.state.selectedSupplier}
                                        />
                                    </div>
                                </PopupE>
                            </div>
                            <div className="medium-1 large-1">
                                <PopupE className="override-large-popup2"
                                    position="right center"
                                    open={this.state.openEnablementInsightPopUp}
                                    onClose={this.outsideEnablementInsightPopupClick}
                                    closeOnDocumentClick
                                >
                                    <div>
                                        <EnablementWavePopUp
                                            enablementWaveInputValue={this.state.enablementWaveInputValue}
                                            close={this.closeEnablementInsightPopUp}
                                        />
                                    </div>
                                    <div className="popupOkBtn">
                                        <Button onClick={this.enablementWaveInput} float type="submit" content={this.props.ui.ok} />
                                        <Button onClick={this.clearEnablementWaveOverride} type="submit" content={this.props.ui.clearOverride} />
                                    </div>
                                </PopupE>
                            </div>
                            {this.state.currentScopeSource === "Industry" && this.state.industryDesc !== "Unclassified" && (this.state.currentDMCIndstryId !== null || this.state.currentDMCIndstryId >= 1000) ?
                                <div className="medium-1 large-1">
                                    <PopupE className="override-large-popup"
                                        position="right center"
                                        open={this.state.openCapIq}
                                        onClose={this.outsideCapIqIdPopupClick}
                                        closeOnDocumentClick
                                    >
                                        <div>
                                            <CapIQSearch
                                                contentData={this.props.discovery}
                                                capIqRadioButtonClicked={this.capIqRadioButtonClicked}
                                                capIqDataCleared={this.capIqDataCleared}
                                                close={this.closeCapIqPopUp}
                                                capIqIdOverride={this.capIqIdOverride}
                                                doubleCapIqId={this.state.currentCapIqId}
                                            />
                                        </div>
                                    </PopupE>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>

                <div className='grid-x grid-padding-x'>
                    <div className='medium-3'>
                        {/* <div style = {{float: 'left',	width: '20%'}}> */}
                        <div className="font-bold underline">{this.props.content.currentFilterSelection}</div>
                        <div className="defineScope">
                            {filter.length === 0 ? 'No filter currently selected' :
                                filter.map((item) => {
                                    return (
                                        (item.length === 0 || item[1].filterTerm.length === 0) ? '' :
                                            <div className="grid-x"><span className="font-small font-bold float-left pr10">{item[1].column.name}: </span><div className="medium-9">{this.expandFilter(item[1])}</div></div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {/* <div style = {{float: 'left',	width: '40%'}}> */}
                    <div className='medium-3'>
                        {this.state.rowData.length === 0 ? '' :
                            <div><span className="font-bold underline">{this.props.content.currentFilterRows}</span> {formatThousands(this.state.filteredRows.length)}/{formatThousands(this.state.rowData.length)} {this.props.content.totalText}</div>}

                    </div>
                    {/* <div style = {{float: 'left',	width: '40%'}}> */}
                    <div className='medium-6'>
                        <div className="grid-x medium-12 pr15">
                            <div className="medium-12">
                                {validationDiv}
                                {/* <div className="dropDownHeader font-bold underline" style={{ width: '20%', float: 'left' }}>{"Sort By :"} </div>

                                    <div className="control-wrapper" style={{ width: '80%', float: 'right' }}>
                                        <SelectE
                                            className="border-with-DD"
                                            autocomplete='true'
                                            //placeholder={this.props.content.notConfirmed}
                                            value={this.state.sortByOption.filter(
                                                option => option.value === this.state.selectedSortBy
                                            )}
                                            noOptionsMessage={() => null}
                                            onChange={value => this.handleSortByChange(value)}
                                            options={this.state.sortByOption}
                                            isSearchable={false}
                                            styles={dropdownColourStyles}
                                            isDisabled={this.state.isLoading}
                                        />
                                    </div> */}



                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid-x grid-padding-x">
                <div className="medium-12 clearfix">
  {/* Single-row toolbar */}
  <div style={styles.toolbarRow}>
    {/* Left: Page size + Pagination */}
    <div style={styles.toolbarGroup}>
      <Select
        className="border-with-DD page-number-dd dropDownContent"
        placeholder="Page Count"
        value={this.state.pageCountOption.filter(option => option.value === this.state.perPage)}
        onChange={(value) => this.handlePageCountChange(value.value)}
        options={this.state.pageCountOption}
        isSearchable={false}
        menuPortalTarget={document.body}
      />
      <ReactPaginate
        previousLabel={'<'}
        nextLabel={'>'}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={this.state.pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={this.handlePageClick}
        containerClassName={'pagination'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
        pageClassName={'page-li'}
        previousClassName={'previousClassName'}
        nextClassName={'nextClassName'}
        pageLinkClassName={'pageLinkClassName'}
        activeLinkClassName={'activeLinkClassName'}
      />
    </div>

    {/* Middle: Sort By */}
    <div style={{ ...styles.toolbarGroup, ...styles.sortGroup }}>
      <div style={styles.sortLabel}>Sort By :</div>
      <div style={styles.sortControl} title="1)Buyer Value               : Sort by Value to the Buyer (Intelligent Enablement Match, Spend & Document Score)
2)Enablement Strategy Value : Sort by Value to Buyer including Enablement Strategy Wizard (Intelligent Combined Priority Score)
3)Enablement Wave           : Sort by Enablement Wave (Enablement Wave)
4)Original Order            : Sort by Spend File Order (Ref. #)">
        <SelectE
          className="border-with-DD"
          value={this.state.sortByOption.filter(option => option.value === this.state.selectedSortBy)}
          onChange={value => this.handleSortByChange(value)}
          options={this.state.sortByOption}
          isSearchable={false}
          styles={dropdownColourStyles}
          isDisabled={this.state.isLoading}
          menuPortalTarget={document.body}
        />
      </div>
    </div>

    {/* Spacer pushes right group to the end */}
    {/* <div style={{ flex: 1 }} /> */}

    {/* Right group: Legend + Action Buttons + Filter button */}
    <div style={{ ...styles.toolbarGroup, ...styles.actionsGroup }}>
      <div className="legend2 defineScope" style={{...styles.legendDefineScope,...styles.actionButton}}>
        <span className="key-dot outScope"></span>
        {this.props.content.editableColumns}
      </div>

      {/* Save */}
      <button style={styles.actionButton}
        className={classNames({
          'hand-cursor': this.state.isSaveInProgress ? false : !(this.hasRecordErrors() || this.state.pendingRecords.length === 0),
          'gray-scale': this.state.isSaveInProgress ? true : (this.hasRecordErrors() || this.state.pendingRecords.length === 0)
        })}
        onClick={this.onSave}
        disabled={this.state.isSaveInProgress ? true : this.hasRecordErrors() || this.state.pendingRecords.length === 0}
        title={this.props.ui.save}
      >
        <img width="20" src="images/save_active.svg" alt="Save" />
      </button>

      {/* Export */}
      <button style={styles.actionButton}
        className={classNames({
          'hand-cursor': this.state.pendingRecords.length === 0 && !this.state.isLoading,
          'gray-scale': this.state.pendingRecords.length !== 0 || this.state.isLoading
        })}
        onClick={() => this.openDownloadPopup()}
        disabled={this.state.pendingRecords.length !== 0 || this.state.isLoading}
        title={this.props.content.export}
      >
        <img className="rotateimg180" width="20" src="images/export_active.svg" alt="Export" />
      </button>

      {/* Upload */}
      <button style={styles.actionButton}
        className={classNames({
          'hand-cursor': this.state.pendingRecords.length === 0 && !this.state.isLoading,
          'gray-scale': this.state.pendingRecords.length !== 0 || this.state.isLoading
        })}
        disabled={this.state.isLoading}
        onClick={() => this.showModal('UploadUserDefinedFields')}
        title={this.props.content.uploadExcel}
      >
        <img className="hand-cursor" width="20" src="images/export_active.svg" alt="Upload" />
      </button>

      {/* Columns */}
      <button style={styles.actionButton}
        className={classNames({
          'hand-cursor': this.state.pendingRecords.length === 0 && !this.state.isLoading,
          'gray-scale': this.state.pendingRecords.length !== 0 || this.state.isLoading
        })}
        disabled={this.state.isLoading}
        onClick={() => this.showModal('ColumnFields')}
        title={this.props.content.columnSelect}
      >
        <img className="hand-cursor" width="20" src="images/column_active.svg" alt="Columns" />
      </button>

      {/* VUF */}
      {/* <button
        className={classNames({
          'hand-cursor': this.state.pendingRecords.length === 0 && !this.state.isLoading,
          'gray-scale': this.state.pendingRecords.length !== 0 || this.state.isLoading
        })}
        disabled={this.state.isLoading}
        onClick={() => this.showModal('vufModal')}
        title="Download Vendor File"
      >
        <label className="vufClass">VUF</label>
      </button> */}      
    </div>
  </div>

  {/* ========== MODALS (unchanged) ========== */}
  {/* Export options modal */}
  <Modal ref="alert" modalStyle={alertModalStyle} contentStyle={changeModalContentStyle} backdropStyle={changeBackdropStyle}>
    <div className="grid-x change-popup">
      <div className="medium-12">
        <button onClick={() => this.hideModal("alert")} className="close" />
      </div>
      <div style={{ marginLeft: '20%' }}><h4>Select Output Type</h4></div>
      <div className="medium-12 pt10" style={{ marginBottom: '10px' }}>
        {this.props.spendDetails.currentActiveRequest.Number_Of_Records < downloadThreshold ?
          this.props.content.exportAlertMessage.replaceAll("7000", this.state.chunkSize)
          : this.props.content.exportAlertMessageAboveThreshold}
      </div>
      <div className="modalContainer">
        {this.renderMenu()}
        <Popup open={this.state.showFileTypePopup} modal closeOnDocumentClick onClose={() => this.setState({ showFileTypePopup: false })}>
          <div style={styles.popupContainer}>
            <div style={styles.header}>Select File Type</div>
            <div style={styles.body}>
              <label style={styles.radioLabel}>
                <input type="radio" name="fileType" value="excel"
                  checked={this.state.selectedFileType === 'excel'}
                  onChange={(e) => this.setState({ selectedFileType: e.target.value })} />
                <span style={styles.radioText}>Excel (.xlsx)</span>
              </label>
              <label style={styles.radioLabel}>
                <input type="radio" name="fileType" value="csv"
                  checked={this.state.selectedFileType === 'csv'}
                  onChange={(e) => this.setState({ selectedFileType: e.target.value })} />
                <span style={styles.radioText}>CSV (.csv)</span>
              </label>
            </div>
            <div style={styles.footer}>
              <button style={styles.closeBtn} onClick={() => this.setState({ showFileTypePopup: false })}>Close</button>
            </div>
          </div>
        </Popup>
      </div>
      {this.state.isLoading &&
        <div style={{
          backgroundColor: '#f0f8ff', borderLeft: '5px solid #007bff', color: '#003366',
          padding: '15px 20px', fontSize: '18px', fontFamily: 'Arial, sans-serif',
          width: 'fit-content', margin: '20px auto', boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          borderRadius: '4px'
        }}>
          Downloading {this.state.currentChunkIndex}/{this.state.totalChunks} file(s)... Please wait.
        </div>
      }
      <div style={{ paddingRight: '15px' }} className="medium-12 popupOkBtn pt10">
        {this.state.isLoading && <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', paddingTop: '5px' }} src={path + `images/ajax-loader.gif`} alt="" />}
      </div>
    </div>
  </Modal>

  {/* Upload User Defined Fields modal */}
  <Modal className="column-field-modal" ref={'UploadUserDefinedFields'}
    backdropStyle={{ ...backdropStyle, pointerEvents: this.state.isBlocking ? 'none' : 'auto' }}
    keyboard={() => { if (this.state.isBlocking) return; this.closeUploadFieldPopup(); }}
    modalStyle={columnFieldModalStyle} contentStyle={suggestedValueContentStyle}>
    <UploadUserDefinedFields
      columnData={this.state.finalColumn}
      rowData={this.state.rowData}
      reloadGrid={() => this.reloadGrid()}
      closePopup={() => this.closeUploadFieldPopup()}
      setBlocking={(val) => this.setState({ isBlocking: val })} />
    {!this.state.isBlocking && (
      <button onClick={() => { if (this.state.isBlocking) return; this.closeUploadFieldPopup(); }}
        className='close'
        style={{ pointerEvents: this.state.isBlocking ? 'none' : 'auto', opacity: this.state.isBlocking ? 0.5 : 1, cursor: this.state.isBlocking ? 'not-allowed' : 'pointer' }} />
    )}
  </Modal>

  {/* Column Fields modal */}
  <Modal className="column-field-modal" ref={'ColumnFields'} backdropStyle={backdropStyle}
    keyboard={() => this.callback()} modalStyle={columnFieldModalStyle} contentStyle={suggestedValueContentStyle}>
    <ColumnFields columnOptions={this.state.columns} onColumnSelection={this.onColumnSelection} closePopup={() => this.closeColumnFieldPopup()} />
    <button onClick={() => this.closeColumnFieldPopup()} className='close' />
  </Modal>

  {/* VUF modal */}
  <Modal className="column-field-modal vufModal" ref={'vufModal'} keyboard={() => this.callback()}
    modalStyle={changeModalStyle} contentStyle={changeModalContentStyle}>
    <VendorUploadFilesModalContainer
      rowData={this.state.exportAction === 'vuf' ? this.state.vufData : this.state.vufDataEnhanced}
      waves={this.state.vufWaves}
      exportCsvForVUF={this.exportCsvForVUF.bind(this)}      
      closePopup={() => this.hideModal('vufModal')}      
      content={this.props.content.export} />
    <button onClick={() => this.hideModal('vufModal')} className='close' />
  </Modal>
</div>
                    <div className="grid-x grid-padding-x">
                        <div
                            id="myGrid"
                            className={`medium-12 react-data-grid bottom-space ${isBusinessCase ? 'SpendBusinessCaseDetailedFileGrid' : ''}`}>
                            <div class="scroll-dummy" onScroll={this.listenScrollEvent.bind(this)}>
                                {/* <div class="scroll-dummy-child"></div> */}
                            </div>
                            <ReactDataGrid
                                ref={(dataGrid) => { this.myOpenGrid = dataGrid; }}
                                columns={columnDefs}
                                minWidth={'100%'}
                                rowsCount={paginatedRows.length}
                                minHeight={500}
                                onGridRowsUpdated={this.onGridRowsUpdated}
                                enableCellSelect={true}
                                onGridSort={this.sortRows}
                                rowGetter={i => paginatedRows[i]}
                                toolbar={<Toolbar enableFilter onToggleFilter={() => this.handleFilterChange(null)} numberOfRows={this.state.rowData.length} filterRowsButtonText={<span onClick={this.filterChange}>{<img className={classNames('hand-cursor',
                                    {
                                        'hand-cursor': !this.state.isLoading,
                                        'gray-scale': this.state.isLoading
                                    })} title={this.props.content.filter} width="20" src="images/filter_active.svg" />}</span>} />}
                                onAddFilter={filter => this.handleFilterChange(filter)}
                                onClearFilters={() => this.handleFilterChange(null)}
                                onFilterChange={filter => this.handleFilterChange(filter)}
                                getValidFilterValues={this.getValidFilterValues}
                                RowsContainer={ContextMenuTrigger}
                                rowRenderer={this.RowRenderer}
                                onCheckCellIsEditable={this.isCellEditable}
                                onColumnResize={(idx, width) => this.columnResize(`${idx}`, `${width}`)}
                                headerRowHeight={70}
                                disabled = {this.state.isLoading}
                            />
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

const styles = {

    popupContainer: {
        width: '320px',
        padding: '20px',
        borderRadius: '10px',
        background: '#fff',
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
        textAlign: 'center'
    },

    popupStyle: {
        position: "fixed",
  top: "20%",
  left: "30%",
  zIndex: 900,
  background: "#fff",
  border: "1px solid #ccc",
  padding: "20px"
    },

    overlayPopupStyle: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)", // center align
        zIndex: 1000,
        background: "#fff",
        border: "2px solid #000",
        padding: "20px",
        minWidth: "300px",
        textAlign: "center"
    },    
    
    actionButton: {marginTop : "10%"},

    buttonRowStyle : {
        display: "flex",
        justifyContent: "center",
        gap: "10px", // space between buttons
        marginTop: "15px"
      },
      
      labelStyle : {
        display: "block",
        marginBottom: "10px" // space between labels
      },

    header: {
        fontSize: '18px',
        fontWeight: '600',
        marginBottom: '15px',
        borderBottom: '1px solid #eee',
        paddingBottom: '10px'
    },

    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginBottom: '20px',
        textAlign: 'left'
    },

    radioLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        cursor: 'pointer',
        fontSize: '14px'
    },

    radioText: {
        fontSize: '14px'
    },

    footer: {
        display: 'flex',
        justifyContent: 'center'
    },

    closeBtn: {
        padding: '8px 20px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px'
    },
      
        // ========== FORCE SINGLE ROW ==========
        
            // Toolbar styles (enforce single row)
            toolbarRow: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center',
                gap: '1rem',
                overflowX: 'auto',        // horizontal scroll on zoom
                marginBottom: '1rem',
                width: '95%', 
              },
              toolbarGroup: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                flexWrap: 'nowrap',
                whiteSpace: 'nowrap',
                alignItems: 'center',                
              },
              sortGroup: {
                flex: '0 1 auto',
                marginLeft: '10%',        // 👈 moves Sort By 20% to the right
              },
              sortLabel: {
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                paddingTop: 0,
              },
              sortControl: {
                minWidth: '160px',
              },
              actionsGroup: {
                marginLeft: 'auto',      // pushes the group to the far right
                flexWrap: 'nowrap',
                // Remove flex: '1 0 auto' – let the group take only its content width
                gap: '1.50rem',
              },
              legendDefineScope: {
                fontSize: '12px',
  whiteSpace: 'nowrap',
  lineHeight: 'normal',    // ensure consistent line height
  marginTop: '0',
              },

};

const mapStateToProps = state => {
    return {
        ui: state.content.ui,
        spendDetails: state.spendDetails,
        user: state.default,
        content: state.content.spendAnalysis.detailedFile,
        validation: state.content.validation,
        userData: state.valueStory,
        filter: state.detailedFileFilters.filter,
        filterText: state.detailedFileFilterText,
        overridedIndustryDetails: state.spendDetails.overridedIndustryDetails,
        enablementWaveInputDetails: state.spendDetails.enablementWaveInputDetails,
        spendDetails: state.spendDetails,
        discovery: state.content.discovery.form,
        overridedCapIqIdDetails: state.spendDetails.overridedCapIqIdDetails,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDetailedFileSuccess: message => dispatch(getDetailedFileSuccess(message)),
        getDetailedFileFailure: error => dispatch(getDetailedFileFailure(error)),
        getDetailedFileLoading: bool => dispatch(getDetailedFileLoading(bool)),
        getDetailedFileSpendData: (DMCId, VSId, userEmail, requestFileRecordCount, roundTripNumber) => dispatch(getDetailedFileSpendData(DMCId, VSId, userEmail, requestFileRecordCount, roundTripNumber)),
        getSpendColumnsConfiguration: () => dispatch(getSpendColumnsConfiguration()),
        getNdlColumnsConfiguration: () => dispatch(getNdlColumnsConfiguration()),
        getNdlReportData: (detail) => dispatch(getNdlReportData(detail)),
        insertDetailedFileRecords: (records) => dispatch(insertDetailedFileRecords(records)),
        detailedFileFilters: filter => dispatch(detailedFileFilters(filter)),
        detailedFileFilterText: filter => dispatch(detailedFileFilterText(filter)),
        selectedIndustryDetails: message => dispatch(selectedIndustryDetails(message)),
        selectedEnablementWaveDetails: message => dispatch(selectedEnablementWaveDetails(message)),
        pendingChanges: changes => dispatch(pendingChanges(changes)),
        defineScopeLoading: bool => dispatch(defineScopeLoading(bool)),
        setResultSummaryDetails: (data) => dispatch(setResultSummaryDetails(data)),
        setTopDetails: (data) => dispatch(setTopDetails(data)),
        getSelectedColumn: (DMCId, VSId, userId) => dispatch(getSelectedColumn(DMCId, VSId, userId)),
        addSelectedColumn: (DMCId, VSId, userId, ColumnsOrFavId) => dispatch(addSelectedColumn(DMCId, VSId, userId, ColumnsOrFavId)),
        removeColumnsForRequest: (UserId, VsId, DmcId) => dispatch(removeColumnsForRequest(UserId, VsId, DmcId)),
        selectedCapIqIdDetails: message => dispatch(selectedCapIqIdDetails(message)),
        getVendorFiles: (DMCId, VSId, userEmail) => dispatch(getVendorFiles(DMCId, VSId, userEmail)),
        getVendorFilesEnhanced: (DMCId, VSId, userEmail) => dispatch(getVendorFilesEnhanced(DMCId, VSId, userEmail)),
        insertReportLogDetails: (DMC_ID, VS_ID, USER_ID, LOG_TYPE, FILE_NAME) => dispatch(insertReportLogDetails(DMC_ID, VS_ID, USER_ID, LOG_TYPE, FILE_NAME)),
        //getReportLogDetails: () => dispatch(getReportLogDetails()),
        FetchUpdateFieldVisibility: (data) => dispatch(FetchUpdateFieldVisibility(data)),
        RunDmcDownloadSummary:(request)=> dispatch(RunDmcDownloadSummary(request)),
        fetchJSONConfigSpendDownloadMenu: () => dispatch(fetchJSONConfigSpendDownloadMenu()),
        requestRunDmcOutputEmail:(DMCID, VSID, Email,Flag)=> dispatch(requestRunDmcOutputEmail(DMCID, VSID, Email,Flag)),
        redirectFromEnablementTab: (flag) => dispatch(redirectFromEnablementTab(flag)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpendFilesContainer)
